function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 24 24",
  id: "icon-alert-circle",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1 12c0 6.075 4.925 11 11 11s11-4.925 11-11S18.075 1 12 1 1 5.925 1 12zm20 0a9 9 0 11-18 0 9 9 0 0118 0zm-9 5.998a1 1 0 100-2 1 1 0 000 2zm1.004-12h-2.001v8h2v-8z",
  fill: "currentColor"
}));

var _ref3 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 26 26",
  id: "icon-apis",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.501 23.833a3.251 3.251 0 003.065-2.167h9.394a4.875 4.875 0 100-9.75H7.043a2.708 2.708 0 110-5.416h3.343l-1.4 1.4 1.531 1.532 4.016-4.016L10.517 1.4 8.985 2.932l1.4 1.401H7.044a4.875 4.875 0 100 9.75H18.96a2.708 2.708 0 110 5.417H9.566a3.251 3.251 0 00-6.315 1.083 3.25 3.25 0 003.25 3.25zm-1.083-3.25a1.083 1.083 0 112.167 0 1.083 1.083 0 01-2.167 0zM19.501 2.166a3.25 3.25 0 110 6.5 3.25 3.25 0 010-6.5zm-1.083 3.25a1.083 1.083 0 112.167 0 1.083 1.083 0 01-2.167 0z",
  fill: "currentColor"
}));

var _ref4 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 24 24",
  id: "icon-arrow",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 19.826a1.919 1.919 0 01-1.408-.61L.486 8.294A1.808 1.808 0 01.627 5.69a1.932 1.932 0 012.676.137l8.697 9.4 8.697-9.4a1.932 1.932 0 012.676-.137c.778.68.84 1.846.14 2.603L13.409 19.216c-.359.388-.87.61-1.408.61z",
  fill: "currentColor"
}));

var _ref5 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 26 27",
  id: "icon-arrow-down",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.493 21.387V0h-2.986v21.387l-9.396-9.228L0 14.233 13 27l13-12.767-2.111-2.074-9.396 9.228z",
  fill: "#FBF9F9"
}));

var _ref6 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 12 8",
  id: "icon-arrow-feature",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6 0l6 8H0l6-8z",
  fill: "currentColor"
}));

var _ref7 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 5 9",
  id: "icon-arrow-left",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.402 4.131a.5.5 0 000 .738l3.67 3.363a.5.5 0 00.837-.369V1.137a.5.5 0 00-.838-.369L.402 4.131z",
  fill: "currentColor"
}));

var _ref8 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 24 24",
  id: "icon-arrow-left-full",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.414 13l6.293 6.293-1.414 1.414L2.586 12l8.707-8.707 1.414 1.414L6.414 11H21v2H6.414z",
  fill: "currentColor"
}));

var _ref9 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 24 24",
  id: "icon-arrow-left-replay",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.414 10H11c7.869 0 11 3.256 11 11h-2c0-6.656-2.253-9-9-9H5.414l4.293 4.293-1.414 1.414L1.586 11l6.707-6.707 1.414 1.414L5.414 10z",
  fill: "currentColor"
}));

var _ref10 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 28 28",
  id: "icon-arrow-loading",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M27.76 23.12l-4.731-4.732 2.32-2.32a.82.82 0 00-.32-1.358l-13.922-4.64a.82.82 0 00-1.037 1.037l4.64 13.922a.82.82 0 001.358.32l2.32-2.32 4.731 4.73a.818.818 0 001.16 0l3.48-3.48a.82.82 0 000-1.16zm-4.06 2.9l-4.732-4.731a.82.82 0 00-1.16 0l-1.961 1.961-3.702-11.105 11.105 3.702-1.961 1.961a.82.82 0 000 1.16l4.73 4.731-2.32 2.32zM10.664 6.563a.82.82 0 00.82-.82V.82a.82.82 0 00-1.64 0v4.922c0 .453.367.82.82.82zM4.283 3.123a.82.82 0 10-1.16 1.16l3.48 3.48a.82.82 0 101.16-1.16l-3.48-3.48zM6.603 13.564l-3.48 3.48a.82.82 0 101.16 1.16l3.48-3.48a.82.82 0 10-1.16-1.16zM14.724 7.764l3.48-3.48a.82.82 0 10-1.16-1.16l-3.48 3.48a.82.82 0 101.16 1.16zM6.563 10.664a.82.82 0 00-.82-.82H.82a.82.82 0 000 1.64h4.922a.82.82 0 00.82-.82z",
  fill: "currentColor"
}));

var _ref11 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 8 13",
  id: "icon-arrow-modern-next",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.777 6.165L.814 11.127l.963.963L7.7 6.165 1.777.241l-.963.962 4.963 4.962z",
  fill: "#FBF9F9"
}));

var _ref12 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 8 13",
  id: "icon-arrow-modern-prev",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.665 6.165l4.962 4.962-.962.963L.74 6.165 6.665.241l.962.962-4.962 4.962z",
  fill: "#FBF9F9"
}));

var _ref13 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 28 26",
  id: "icon-arrow-right-full",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.865 11.17H.725v2.9h21.14l-9.12 9.12 2.049 2.05 12.62-12.62L14.794 0l-2.05 2.05 9.121 9.12z",
  fill: "currentColor"
}));

var _ref14 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 26 24",
  id: "icon-arrows-horz-bltr",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.01 8.682l1.336-1.336 4.675 4.675-4.675 4.675-1.336-1.336 2.395-2.395H4.595L6.99 15.36l-1.336 1.336L.979 12.02l4.675-4.675L6.99 8.682l-2.395 2.394h16.81L19.01 8.682z",
  fill: "currentColor"
}));

var _ref15 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 15 15",
  id: "icon-atom",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.78 3.412v4.064H6.88V3.412h.902z",
  fill: "#FBF9F9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.041 5.053l3.515 2.032-.451.782L3.59 5.835l.451-.782z",
  fill: "#FBF9F9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.59 9.116l3.515-2.031.45.782-3.514 2.032-.45-.783z",
  fill: "#FBF9F9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.879 11.54V7.476h.902v4.064h-.902z",
  fill: "#FBF9F9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.619 9.899L7.104 7.867l.451-.782 3.515 2.031-.451.783z",
  fill: "#FBF9F9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.07 5.835L7.555 7.867l-.45-.782 3.514-2.032.45.782z",
  fill: "#FBF9F9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.33 1.153a6.318 6.318 0 00-6.314 6.323 6.318 6.318 0 006.314 6.322 6.318 6.318 0 006.314-6.322A6.318 6.318 0 007.33 1.153zM.114 7.476C.114 3.486 3.344.25 7.33.25c3.985 0 7.216 3.235 7.216 7.226 0 3.99-3.23 7.226-7.216 7.226S.114 11.466.114 7.476z",
  fill: "#FBF9F9"
}));

var _ref16 = /*#__PURE__*/React.createElement("symbol", {
  viewBox: "0 0 280.067 280.067",
  id: "icon-attachment",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M149.823 257.142c-31.398 30.698-81.882 30.576-113.105-.429-31.214-30.987-31.337-81.129-.42-112.308l-.026-.018L149.841 31.615l14.203-14.098c23.522-23.356 61.65-23.356 85.172 0s23.522 61.221 0 84.586l-125.19 123.02-.044-.035c-15.428 14.771-40.018 14.666-55.262-.394-15.244-15.069-15.34-39.361-.394-54.588l-.044-.053 13.94-13.756 69.701-68.843 13.931 13.774-83.632 82.599c-7.701 7.596-7.701 19.926 0 27.53s20.188 7.604 27.88 0L235.02 87.987l-.035-.026.473-.403c15.682-15.568 15.682-40.823 0-56.39s-41.094-15.568-56.776 0l-.42.473-.026-.018-14.194 14.089L50.466 158.485c-23.522 23.356-23.522 61.221 0 84.577s61.659 23.356 85.163 0l99.375-98.675 14.194-14.089 14.194 14.089-14.194 14.098-99.357 98.675-.018-.018z"
}));

var _ref17 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 26 24",
  id: "icon-back-arrow",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.985 3.527c-.82-.703-2.15-.703-2.97 0l-8.4 7.2c-.82.703-.82 1.843 0 2.546l8.4 7.2c.82.703 2.15.703 2.97 0 .82-.703.82-1.843 0-2.546L6.07 12l6.915-5.927c.82-.703.82-1.843 0-2.546z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2 12c0 .994.85 1.8 1.898 1.8h19.604c1.048 0 1.898-.806 1.898-1.8s-.85-1.8-1.898-1.8H3.898C2.85 10.2 2 11.006 2 12z",
  fill: "currentColor"
}));

var _ref18 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 24 24",
  id: "icon-bar-chart",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3 3h18a2 2 0 012 2v14a2 2 0 01-2 2H3a2 2 0 01-2-2V5a2 2 0 012-2zm0 2v14h18V5H3zm4 12h2v-6H7v6zm6 0h-2V7h2v10zm2 0h2v-7h-2v7z",
  fill: "currentColor"
}));

var _ref19 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 24 24",
  id: "icon-battery",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.809 3.727V1H8.307v2.727L6 3.796V24h11.116V3.796l-2.307-.07zm.49 17.896H7.887v-7.398l7.41-4v11.399z",
  fill: "currentColor"
}));

var _ref20 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 890 786",
  id: "icon-battery-3d",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.04,
  filter: "url(#asfilter0_f)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M445.882 270.344L73.685 488.778 43.672 506.42l54.826 32.663 245.479 145.965 54.651 32.519h.088l45.869 27.294 347.284-203.928 54.832-32.231-30.019-17.882-17.053-10.127-54.638-32.526-299.109-177.823z",
  fill: "#211E21"
})), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M.998 375.12l45.683 25.943 46.87 26.536 25.436 14.825 72.314 41.953 80.834 46.92 60.285 35.06 38.712 22.459 26.698 15.492 45.534 26.536v-5.172l.148-.074v-2.001L.998 366.539v8.581z",
  fill: "#E4E4E4"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M443.52 626.366v5.94l46.974-27.042 26.2-14.905 180.491-103.553 72.497-41.582 26.356-15.101 46.967-26.927 45.999-26.4v-5.825L443.52 626.366z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M445.767 112.617l-411.58 236.5L1 368.217l60.627 35.365L333.08 561.618l60.434 35.209h.096l50.723 29.551 384.03-220.793 60.635-34.896-33.197-19.361-18.856-10.965-60.419-35.216-330.759-192.53z",
  fill: "url(#aspaint0_linear)"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.065,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M834.031 340.737L389.166 596.631l-.498-.866 444.865-255.894.498.866zM774.617 305.094L329.752 560.988l-.498-.866 444.865-255.893.498.865zM719.609 275.366L274.744 531.26l-.498-.866L719.111 274.5l.498.866zM666.205 242.735L221.34 498.629l-.498-.866 444.865-255.894.498.866zM611.25 213.036L166.385 468.93l-.498-.866L610.752 212.17l.498.866zM557.846 177.413L112.98 433.306l-.498-.865 444.866-255.894.498.866zM496.863 141.76L51.998 397.654l-.498-.866 444.865-255.893.498.865z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.065,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M51.486 340.737l444.866 255.894.498-.866L51.984 339.871l-.498.866zM110.898 305.094l444.866 255.894.498-.866-444.866-255.893-.498.865zM165.893 275.366L610.758 531.26l.498-.866L166.391 274.5l-.498.866zM219.318 242.735l444.866 255.894.498-.866-444.866-255.894-.498.866zM274.307 213.036L719.172 468.93l.498-.866L274.805 212.17l-.498.866zM327.771 177.413l444.866 255.893.498-.865-444.866-255.894-.498.866zM388.641 141.76l444.865 255.894.498-.866-444.865-255.893-.498.865z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M531.47 311.165c-44.156-26.417-116.771-27.156-162.197-1.642-45.419 25.514-46.454 67.612-2.299 94.03 44.156 26.42 116.771 27.156 162.19 1.642 45.426-25.512 46.461-67.609 2.306-94.03z",
  fill: "url(#aspaint1_linear)"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M368.009 141.05c-22.098-12.826-33.26-29.642-33.488-46.572V341.45h231V93.965c0 1.482-.113 2.907-.283 4.332v.057c0 .114-.057.228-.057.342v.114s-.057.171-.057.285v.115c0 .114-.057.17-.057.284v.171l-.057.172c0 .114-.057.227-.057.227v.171c0 .114-.057.171-.057.285v.115c0 .114-.057.17-.057.284v.114c-.057.114-.058.228-.115.342 0 .171-.057.285-.057.399-3.018 14.366-14.067 28.275-33.146 39.276-22.668 13.111-52.282 19.667-81.841 19.667-29.615 0-59.118-6.556-81.671-19.667z",
  fill: "#BBFFC6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M368.744 290.814c-45.391 26.222-45.62 68.633-.741 94.684 45.05 26.222 118.177 26.222 163.512 0 45.163-26.051 45.392-68.462.342-94.684-44.879-26.107-118.006-26.107-163.113 0z",
  fill: "#6FB57B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.9,
  d: "M368.744 249.35c-45.391-26.222-45.62-68.633-.741-94.684 45.05-26.221 118.177-26.221 163.512 0 45.163 26.051 45.392 68.462.342 94.684-44.879 26.108-118.006 26.108-163.113 0z",
  fill: "url(#aspaint2_linear)"
}), /*#__PURE__*/React.createElement("g", {
  opacity: 0.9
}, /*#__PURE__*/React.createElement("path", {
  d: "M368.744 292.364c-45.391 26.222-45.62 68.632-.741 94.683 45.05 26.222 118.177 26.222 163.512 0 45.163-26.051 45.391-68.461.342-94.683-44.879-26.108-118.006-26.108-163.113 0z",
  fill: "url(#aspaint3_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M368.009 249.625c-22.097-12.826-33.259-29.643-33.487-46.573v139.95h230.999V202.539c0 1.482-.112 2.907-.283 4.332v.058c0 .114-.057.227-.057.341v.114s-.057.172-.057.286v.114c0 .114-.057.17-.057.284v.172l-.057.171a.582.582 0 01-.057.227v.171c0 .114-.057.172-.057.286v.114c0 .114-.057.171-.057.285v.114c-.057.114-.057.227-.114.341 0 .171-.057.286-.057.4-3.019 14.365-14.068 28.274-33.147 39.276-22.667 13.111-52.282 19.666-81.841 19.666-29.615 0-59.117-6.555-81.671-19.666z",
  fill: "url(#aspaint4_linear)"
})), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M550.4 271.445l1.187 2.012-17.989 10.096-1.186-2.012 17.988-10.096zM550.4 237.445l1.187 2.012-17.989 10.096-1.186-2.012 17.988-10.096zM550.4 340.445l1.187 2.012-17.989 10.096-1.186-2.012 17.988-10.096zM550.4 199.445l1.187 2.012-17.989 10.096-1.186-2.012 17.988-10.096zM550.4 306.445l1.187 2.012-17.989 10.096-1.186-2.012 17.988-10.096zM550.4 165.445l1.187 2.012-17.989 10.096-1.186-2.012 17.988-10.096z",
  fill: "#969696"
}), /*#__PURE__*/React.createElement("path", {
  d: "M368.744 46.416c-45.391 26.222-45.62 68.632-.741 94.683 45.05 26.222 118.177 26.222 163.512 0 45.163-26.051 45.392-68.461.342-94.683-44.879-26.108-118.006-26.108-163.113 0z",
  fill: "url(#aspaint5_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M446.269 147.389c-23.693 0-47.328-5.245-65.325-15.734-35.937-20.92-35.71-54.838.569-75.816 18.054-10.432 41.746-15.619 65.324-15.619 23.636 0 47.272 5.187 65.212 15.62 36.052 20.977 35.88 54.895-.285 75.815-18.111 10.489-41.86 15.734-65.495 15.734z",
  fill: "url(#aspaint6_linear)"
}), /*#__PURE__*/React.createElement("g", {
  opacity: 0.12,
  filter: "url(#asfilter1_f)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M591 379c0 36.451-63.352 66-141.5 66S308 415.451 308 379s63.352-66 141.5-66S591 342.549 591 379z",
  fill: "#34363F"
})), /*#__PURE__*/React.createElement("g", {
  opacity: 0.8,
  filter: "url(#asfilter2_f)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M371.727 359.29V135.023h19.934V359.29h-19.934z",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("path", {
  d: "M418.218 74.342c-17.762 9.832-17.852 25.734-.29 35.501 17.628 9.832 46.243 9.832 63.983 0 17.672-9.767 17.762-25.67.133-35.501-17.561-9.79-46.176-9.79-63.826 0z",
  fill: "url(#aspaint7_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M417.93 94.567c-8.647-4.81-13.015-11.114-13.104-17.462v14.261h90.392V76.912c0 .556-.045 1.09-.111 1.625v.021c0 .043-.023.085-.023.128v.043s-.022.064-.022.107v.043c0 .042-.022.064-.022.106v.065l-.023.064c0 .043-.022.085-.022.085v.064c0 .043-.022.064-.022.107v.043c0 .043-.023.064-.023.107v.043c-.022.042-.022.085-.044.128 0 .064-.023.107-.023.15-1.181 5.386-5.504 10.6-12.97 14.726-8.87 4.916-20.458 7.374-32.025 7.374-11.588 0-23.133-2.458-31.958-7.374z",
  fill: "url(#aspaint8_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M418.218 58.341c-17.762 9.832-17.852 25.734-.29 35.502 17.629 9.832 46.244 9.832 63.984 0 17.673-9.768 17.763-25.67.134-35.502-17.562-9.789-46.177-9.789-63.828 0z",
  fill: "url(#aspaint9_linear)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 431.152,
  cy: 81.13,
  rx: 8.646,
  ry: 5.091,
  fill: "#D1CFCF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M431.152 85.203c-4.846 0-7.068-2.105-7.617-3.666l.178-46.35a7.44 7.44 0 0114.878 0l.144 37.48c.022 5.796-1.787 12.536-7.583 12.536z",
  fill: "#FBF9F9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M431.152 54.656c-4.846 0-7.068-2.104-7.617-3.665l.14-15.805a7.477 7.477 0 0114.953 0l.14 15.805-.004.008c-.555.89-2.276 3.657-7.612 3.657z",
  fill: "#6E6"
}), /*#__PURE__*/React.createElement("mask", {
  id: "asa",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 431.153,
  cy: 29.486,
  rx: 7.411,
  ry: 4.359
})), /*#__PURE__*/React.createElement("ellipse", {
  cx: 431.153,
  cy: 29.486,
  rx: 7.411,
  ry: 4.359,
  fill: "#85FC99"
}), /*#__PURE__*/React.createElement("path", {
  d: "M428.597 29.486c0-3.771 2.532-5.385 2.743-5.509.441-.26.398-.1-.187-.1v19.936c3.508 0 7.17-.816 10.294-2.653 2.893-1.702 7.084-5.495 7.084-11.674h-19.934zm2.556-5.608c-.585 0-.628-.16-.187.099.211.124 2.744 1.738 2.744 5.509h-19.935c0 6.18 4.191 9.972 7.084 11.674 3.124 1.837 6.786 2.653 10.294 2.653V23.878zm2.557 5.608c0 3.772-2.533 5.385-2.744 5.51-.441.259-.398.098.187.098V15.16c-3.508 0-7.17.815-10.294 2.652-2.893 1.702-7.084 5.495-7.084 11.674h19.935zm-2.557 5.608c.585 0 .628.16.187-.099-.211-.124-2.743-1.737-2.743-5.509h19.934c0-6.179-4.191-9.972-7.084-11.674-3.124-1.837-6.786-2.652-10.294-2.652v19.934z",
  fill: "#82EA93",
  mask: "url(#asa)"
}), /*#__PURE__*/React.createElement("mask", {
  id: "asb",
  maskUnits: "userSpaceOnUse",
  x: 415,
  y: 20,
  width: 17,
  height: 69
}, /*#__PURE__*/React.createElement("path", {
  fill: "#C4C4C4",
  d: "M415.508 20.24h16.468v68.017h-16.468z"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#asb)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 430.74,
  cy: 81.13,
  rx: 8.646,
  ry: 5.091,
  fill: "#D1CFCF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M430.74 85.203c-4.847 0-7.068-2.105-7.617-3.666l.178-46.35a7.44 7.44 0 0114.878 0l.143 37.48c.023 5.796-1.786 12.536-7.582 12.536z",
  fill: "#EFEFF1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M430.74 54.656c-4.847 0-7.068-2.104-7.617-3.665l.14-15.805a7.477 7.477 0 0114.953 0l.14 15.805-.004.008c-.555.89-2.276 3.657-7.612 3.657z",
  fill: "#60D760"
}), /*#__PURE__*/React.createElement("mask", {
  id: "asc",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 430.741,
  cy: 29.486,
  rx: 7.411,
  ry: 4.359
})), /*#__PURE__*/React.createElement("ellipse", {
  cx: 430.741,
  cy: 29.486,
  rx: 7.411,
  ry: 4.359,
  fill: "#6E6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M428.184 29.486c0-3.771 2.533-5.385 2.744-5.509.441-.26.398-.1-.187-.1v19.936c3.508 0 7.17-.816 10.294-2.653 2.893-1.702 7.084-5.495 7.084-11.674h-19.935zm2.557-5.608c-.585 0-.628-.16-.187.099.211.124 2.743 1.738 2.743 5.509h-19.934c0 6.179 4.191 9.972 7.084 11.674 3.124 1.837 6.786 2.653 10.294 2.653V23.878zm2.556 5.608c0 3.772-2.532 5.385-2.743 5.509-.441.26-.398.1.187.1V15.16c-3.508 0-7.17.815-10.294 2.652-2.893 1.702-7.084 5.495-7.084 11.674h19.934zm-2.556 5.608c.585 0 .628.16.187-.099-.211-.124-2.744-1.737-2.744-5.509h19.935c0-6.179-4.191-9.972-7.084-11.674-3.124-1.837-6.786-2.652-10.294-2.652v19.934z",
  fill: "#82EA93",
  mask: "url(#asc)"
})), /*#__PURE__*/React.createElement("ellipse", {
  cx: 470.261,
  cy: 61.581,
  rx: 8.646,
  ry: 5.091,
  fill: "#D1CFCF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M470.261 65.654c-4.846 0-7.068-2.104-7.616-3.666l.177-46.35a7.44 7.44 0 0114.878 0l.144 37.48c.022 5.796-1.786 12.536-7.583 12.536z",
  fill: "#FBF9F9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M470.261 35.108c-4.846 0-7.068-2.105-7.616-3.666l.14-15.805a7.476 7.476 0 0114.953 0l.14 15.805-.005.008c-.554.89-2.275 3.658-7.612 3.658z",
  fill: "#6E6"
}), /*#__PURE__*/React.createElement("mask", {
  id: "asd",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 470.262,
  cy: 9.937,
  rx: 7.411,
  ry: 4.359
})), /*#__PURE__*/React.createElement("ellipse", {
  cx: 470.262,
  cy: 9.937,
  rx: 7.411,
  ry: 4.359,
  fill: "#85FC99"
}), /*#__PURE__*/React.createElement("path", {
  d: "M467.706 9.937c0-3.771 2.532-5.385 2.743-5.509.442-.26.398-.1-.187-.1v19.936c3.508 0 7.171-.816 10.294-2.653 2.893-1.702 7.085-5.495 7.085-11.674h-19.935zm2.556-5.608c-.584 0-.628-.16-.186.1.21.123 2.743 1.737 2.743 5.508h-19.935c0 6.18 4.192 9.972 7.085 11.674 3.123 1.837 6.785 2.653 10.293 2.653V4.329zm2.557 5.608c0 3.772-2.533 5.385-2.743 5.51-.442.259-.398.099.186.099V-4.39c-3.508 0-7.17.815-10.293 2.653-2.893 1.701-7.085 5.494-7.085 11.673h19.935zm-2.557 5.609c.585 0 .629.16.187-.1-.211-.124-2.743-1.737-2.743-5.509h19.935c0-6.179-4.192-9.972-7.085-11.673-3.123-1.838-6.786-2.653-10.294-2.653v19.934z",
  fill: "#82EA93",
  mask: "url(#asd)"
}), /*#__PURE__*/React.createElement("mask", {
  id: "ase",
  maskUnits: "userSpaceOnUse",
  x: 454,
  y: 0,
  width: 18,
  height: 69
}, /*#__PURE__*/React.createElement("path", {
  fill: "#C4C4C4",
  d: "M454.617.693h16.469V68.71h-16.469z"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#ase)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 469.851,
  cy: 61.581,
  rx: 8.646,
  ry: 5.091,
  fill: "#D1CFCF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M469.851 65.654c-4.846 0-7.068-2.104-7.617-3.666l.178-46.35a7.44 7.44 0 0114.878 0l.144 37.48c.022 5.796-1.787 12.536-7.583 12.536z",
  fill: "#EFEFF1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M469.851 35.108c-4.846 0-7.068-2.105-7.617-3.666l.141-15.805a7.476 7.476 0 0114.953 0l.14 15.805-.005.008c-.554.89-2.275 3.658-7.612 3.658z",
  fill: "#60D760"
}), /*#__PURE__*/React.createElement("mask", {
  id: "asf",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 469.852,
  cy: 9.937,
  rx: 7.411,
  ry: 4.359
})), /*#__PURE__*/React.createElement("ellipse", {
  cx: 469.852,
  cy: 9.937,
  rx: 7.411,
  ry: 4.359,
  fill: "#6E6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M467.296 9.937c0-3.771 2.532-5.385 2.743-5.509.441-.26.398-.1-.187-.1v19.936c3.508 0 7.17-.816 10.294-2.653 2.893-1.702 7.085-5.495 7.085-11.674h-19.935zm2.556-5.608c-.585 0-.628-.16-.187.1.211.123 2.744 1.737 2.744 5.508h-19.935c0 6.18 4.192 9.972 7.085 11.674 3.123 1.837 6.785 2.653 10.293 2.653V4.329zm2.557 5.608c0 3.772-2.533 5.385-2.744 5.51-.441.259-.398.099.187.099V-4.39c-3.508 0-7.17.815-10.293 2.653-2.893 1.701-7.085 5.494-7.085 11.673h19.935zm-2.557 5.609c.585 0 .628.16.187-.1-.211-.124-2.743-1.737-2.743-5.509h19.935c0-6.179-4.192-9.972-7.085-11.673-3.124-1.838-6.786-2.653-10.294-2.653v19.934z",
  fill: "#82EA93",
  mask: "url(#asf)"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "aspaint0_linear",
  x1: 842.051,
  y1: 369.328,
  x2: -30.965,
  y2: 369.328,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F2F2F2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "aspaint1_linear",
  x1: 560.222,
  y1: 384.085,
  x2: 334.521,
  y2: 369.365,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D9D6D6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A8A8A8"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "aspaint2_linear",
  x1: 450.019,
  y1: 135,
  x2: 450.019,
  y2: 268.931,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#85FC99",
  stopOpacity: 0.78
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CBFFD4",
  stopOpacity: 0.75
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "aspaint3_linear",
  x1: 481.717,
  y1: 398.8,
  x2: 422.839,
  y2: 266.324,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9AA79C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7EFF93"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "aspaint4_linear",
  x1: 481.717,
  y1: 398.8,
  x2: 422.839,
  y2: 266.324,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9AA79C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7EFF93"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "aspaint5_linear",
  x1: 349.241,
  y1: 66.075,
  x2: 545.502,
  y2: 129.86,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F8F8F8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D9D9D9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "aspaint6_linear",
  x1: 349.24,
  y1: 90.609,
  x2: 535.389,
  y2: 127.263,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E0E0E0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CCC6C6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C4C4C4"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "aspaint7_linear",
  x1: 487,
  y1: 88.515,
  x2: 417.152,
  y2: 88.515,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D9D6D6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A8A8A8"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "aspaint8_linear",
  x1: 487,
  y1: 88.515,
  x2: 417.152,
  y2: 88.515,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D9D6D6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A8A8A8"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "aspaint9_linear",
  x1: 490.196,
  y1: 91.173,
  x2: 409.848,
  y2: 66.065,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DADADA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F8F8F8"
})), /*#__PURE__*/React.createElement("filter", {
  id: "asfilter0_f",
  x: 2.89,
  y: 229.562,
  width: 884.594,
  height: 556.081,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 20.391,
  result: "effect1_foregroundBlur"
})), /*#__PURE__*/React.createElement("filter", {
  id: "asfilter1_f",
  x: 264,
  y: 269,
  width: 371,
  height: 220,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 22,
  result: "effect1_foregroundBlur"
})), /*#__PURE__*/React.createElement("filter", {
  id: "asfilter2_f",
  x: 331.857,
  y: 95.154,
  width: 99.674,
  height: 304.005,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 19.935,
  result: "effect1_foregroundBlur"
}))));

var _ref21 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 16 18",
  id: "icon-bell",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.131 7.513c0-3.02-1.665-5.114-3.819-5.743a1.487 1.487 0 00-2.774-.001C4.382 2.394 2.72 4.484 2.72 7.512c0 1.958-.395 3.056-1.126 3.851a16.78 16.78 0 01-.677.644c-.106.098-.189.174-.214.199l-.214.217v2.536h4.528c.153.79.581 1.318 1.356 1.791a2.981 2.981 0 003.106 0 2.93 2.93 0 001.328-1.791h4.556v-2.536l-.214-.217a11.954 11.954 0 00-.205-.191c-.223-.206-.561-.518-.685-.653-.732-.8-1.127-1.898-1.127-3.85zM9.217 14.96H6.57c.105.195.284.343.576.521a1.493 1.493 0 002.07-.521zm3.944-2.593c.156.17.492.483.714.688v.418h-11.9v-.418c.22-.202.557-.514.713-.684.994-1.08 1.519-2.54 1.519-4.858 0-2.812 1.735-4.453 3.718-4.453 1.978 0 3.719 1.65 3.719 4.453 0 2.31.525 3.77 1.517 4.854z",
  fill: "currentColor"
}));

var _ref22 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 12 14",
  id: "icon-bell-alert",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.083 5.833c0-2.368-1.305-4.011-2.995-4.505a1.167 1.167 0 00-2.176-.001c-1.691.492-2.995 2.131-2.995 4.506 0 1.536-.31 2.397-.884 3.021-.095.105-.355.344-.531.505a9.29 9.29 0 00-.167.156l-.168.17v1.99h3.551c.12.62.456 1.034 1.064 1.404a2.338 2.338 0 003.478-1.404h3.573v-1.99l-.168-.17c-.017-.018-.08-.075-.16-.15-.176-.161-.44-.406-.538-.512-.574-.627-.884-1.489-.884-3.02zm-3.07 5.842H4.938c.082.153.222.269.452.409a1.171 1.171 0 001.623-.41zm3.094-2.034c.123.134.386.379.56.539v.328H1.333v-.328c.173-.158.437-.403.56-.536.779-.848 1.19-1.992 1.19-3.811C3.083 3.628 4.444 2.34 6 2.34c1.551 0 2.917 1.295 2.917 3.493 0 1.813.411 2.958 1.19 3.808zM6 9.332a.583.583 0 100-1.167.583.583 0 000 1.167zm.585-5.25H5.418v3.5h1.167v-3.5z",
  fill: "currentColor"
}));

var _ref23 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 21 20",
  id: "icon-book",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.436 18.333h-12.5a2.5 2.5 0 01-2.5-2.5V4.167a2.5 2.5 0 012.5-2.5h12.5V15a.833.833 0 000 1.667v1.666zm-2.5-2.5c0-.292.05-.572.142-.833H5.936a.833.833 0 100 1.667h10.142a2.496 2.496 0 01-.143-.834zm-10-12.5h10.833v10H5.936c-.293 0-.573.05-.834.143v-9.31c0-.46.373-.833.834-.833z",
  fill: "currentColor"
}));

var _ref24 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 14 14",
  id: "icon-brightness-high",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.583 2.958a4.118 4.118 0 00-1.166 0V.61a6.498 6.498 0 011.166 0v2.348zM4.083 7a2.917 2.917 0 105.834 0 2.917 2.917 0 00-5.834 0zM8.75 7a1.75 1.75 0 11-3.5 0 1.75 1.75 0 013.5 0zm-1.167 6.39v-2.348a4.11 4.11 0 01-1.166 0v2.349a6.503 6.503 0 001.166 0zm3.459-6.973h2.348a6.503 6.503 0 010 1.167h-2.348a4.126 4.126 0 000-1.167zM2.917 7c0-.198.014-.393.041-.583H.61a6.498 6.498 0 000 1.167h2.348A4.118 4.118 0 012.917 7zm6.528-3.27l1.661-1.66c.3.249.576.525.825.824l-1.66 1.66a4.107 4.107 0 00-.826-.824zM2.07 2.894l1.66 1.66c.235-.312.513-.59.826-.824L2.894 2.07c-.3.249-.576.525-.825.824zm8.201 6.552l1.661 1.66c-.25.3-.526.576-.825.825l-1.66-1.66a4.11 4.11 0 00.824-.825zM2.894 11.93l1.66-1.66a4.11 4.11 0 01-.824-.825l-1.661 1.66c.25.3.526.576.825.825z",
  fill: "currentColor"
}));

var _ref25 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 24 24",
  id: "icon-calendar",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.962 1.938h-3.396v-.885c0-.28-.12-.547-.331-.745A1.177 1.177 0 0017.434 0c-.3 0-.588.111-.8.308a1.017 1.017 0 00-.332.745v.885H7.698v-.885c0-.28-.12-.547-.331-.745A1.177 1.177 0 006.566 0c-.3 0-.588.111-.8.308a1.017 1.017 0 00-.332.745v.885H2.4c-1.2 0-2.4.61-2.4 1.727v17.187c.046.57.317 1.104.76 1.5A2.596 2.596 0 002.4 23h19.562c1.2 0 2.038-1.032 2.038-2.148V3.665c0-1.116-.838-1.727-2.038-1.727zM2.264 4.044h3.17v1.053c0 .28.12.547.332.745.212.197.5.308.8.308.3 0 .588-.11.8-.308.213-.198.332-.466.332-.745V4.044h8.604v1.053c0 .28.12.547.332.745.212.197.5.308.8.308.3 0 .588-.11.8-.308.213-.198.332-.466.332-.745V4.044h3.17v3.791H2.264V4.044zm0 16.85V9.94h19.472v-.294l.226 11.247H2.264z",
  fill: "currentColor"
}));

var _ref26 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 15 16",
  id: "icon-canary",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.973 3.912v4.064h-.91V3.912h.91z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.2 5.553l3.546 2.032-.455.782-3.545-2.032.455-.782z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.746 9.616L7.29 7.584l.455.783-3.545 2.031-.455-.782z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.063 12.04V7.976h.91v4.064h-.91z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.836 10.399L7.291 8.367l.455-.783 3.545 2.032-.455.783z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.291 6.335L7.746 8.367l-.455-.782 3.545-2.032.455.782z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.518 1.653c-3.518 0-6.37 2.83-6.37 6.323 0 3.492 2.852 6.322 6.37 6.322 3.518 0 6.37-2.83 6.37-6.322s-2.852-6.323-6.37-6.323zM.238 7.976c0-3.99 3.26-7.226 7.28-7.226 4.02 0 7.28 3.235 7.28 7.226 0 3.99-3.26 7.226-7.28 7.226-4.02 0-7.28-3.236-7.28-7.226z",
  fill: "currentColor"
}));

var _ref27 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 16 15",
  id: "icon-canary-network",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#azclip0_8979_42153)",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.621 10.702c.849 0 1.544-.695 1.544-1.544 0-.849-.695-1.543-1.544-1.543-.849 0-1.543.694-1.543 1.543s.689 1.544 1.543 1.544zM7.768 3.473c-.827 0-1.504.695-1.504 1.544 0 .849.677 1.543 1.504 1.543.828 0 1.505-.694 1.505-1.543 0-.85-.677-1.544-1.505-1.544zM4.877 10.702c.849 0 1.543-.695 1.543-1.544 0-.849-.694-1.543-1.543-1.543-.85 0-1.544.694-1.544 1.543s.695 1.544 1.544 1.544z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.75 1.097a6.403 6.403 0 100 12.806 6.403 6.403 0 000-12.806zM.432 7.5a7.318 7.318 0 1114.636 0 7.318 7.318 0 01-14.636 0z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "azclip0_8979_42153"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(.432 .182)",
  d: "M0 0h14.636v14.636H0z"
}))));

var _ref28 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 24 24",
  id: "icon-check-mark",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.707 14.293L19 5l1.414 1.414L9.707 17.121 4 11.414 5.414 10l4.293 4.293z",
  fill: "currentColor"
}));

var _ref29 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 25 14",
  id: "icon-chevron-down",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.527.027l1.945 1.945L12.5 13.944.527 1.972 2.472.027 12.5 10.055 22.527.027z",
  fill: "currentColor"
}));

var _ref30 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 24 24",
  id: "icon-circle-block",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 23C5.925 23 1 18.075 1 12S5.925 1 12 1s11 4.925 11 11-4.925 11-11 11zm7.032-5.382a9 9 0 00-12.65-12.65l12.65 12.65zm-1.414 1.414a9 9 0 01-12.65-12.65l12.65 12.65z",
  fill: "currentColor"
}));

var _ref31 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 24 24",
  id: "icon-circle-checked",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 23C5.925 23 1 18.075 1 12S5.925 1 12 1s11 4.925 11 11-4.925 11-11 11zm0-2a9 9 0 100-18 9 9 0 000 18zm3.293-12.707L10 13.586l-2.293-2.293-1.414 1.414L10 16.414l6.707-6.707-1.414-1.414z",
  fill: "currentColor"
}));

var _ref32 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 27 26",
  id: "icon-classic-arrow",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.14 11.17H0v2.9h21.14l-9.12 9.12 2.05 2.05 12.62-12.62L14.07 0l-2.05 2.05 9.12 9.12z",
  fill: "#34363F"
}));

var _ref33 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 11 10",
  id: "icon-close",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.307 4.092L9.41.007l.911.908L6.22 5l4.102 4.085-.911.908-4.103-4.085-4.102 4.085-.912-.908L4.396 5 .293.915l.912-.908 4.102 4.085z",
  fill: "currentColor"
}));

var _ref34 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 9 9",
  id: "icon-close-x",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M.293 6.31a1 1 0 001.414 1.414l2.379-2.378 2.378 2.378A1 1 0 107.88 6.31L5.5 3.932l2.224-2.225A1 1 0 006.31.293L4.086 2.517 1.86.293A1 1 0 10.447 1.707l2.225 2.225L.292 6.31z",
  fill: "#A0A0AC"
}));

var _ref35 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 9 9",
  id: "icon-close-x-white",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M.293 6.31a1 1 0 001.414 1.414l2.379-2.378 2.378 2.378A1 1 0 107.88 6.31L5.5 3.932l2.224-2.225A1 1 0 006.31.293L4.086 2.517 1.86.293A1 1 0 10.447 1.707l2.225 2.225L.292 6.31z",
  fill: "#fff"
}));

var _ref36 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 24 24",
  id: "icon-cloud-download",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18 17v2a5 5 0 00.725-9.948A7.004 7.004 0 006.22 7.05 6.001 6.001 0 006 18.917v-2.043a4.002 4.002 0 01.84-7.87l.55-.022.276-.478a5.002 5.002 0 019.264 1.662l.144.852.863-.017h.032L18 11a3 3 0 110 6zm-7-5v6.253L8.707 16.01l-1.414 1.384L12 22l4.707-4.607-1.414-1.384L13 18.253V12h-2z",
  fill: "currentColor"
}));

var _ref37 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 15 14",
  id: "icon-collaborate",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.417 13.417a6.417 6.417 0 110-12.834 6.417 6.417 0 010 12.834zm4.316-3.428a5.25 5.25 0 10-8.633 0c.657-.867 2.2-1.239 4.317-1.239s3.66.372 4.316 1.24zm-.837.943c-.17-.614-1.397-1.015-3.48-1.015-2.081 0-3.308.4-3.479 1.015a5.23 5.23 0 003.48 1.318 5.23 5.23 0 003.48-1.318zM7.416 3.5c-1.412 0-2.333 1.024-2.333 2.333 0 2 1.027 2.917 2.334 2.917 1.294 0 2.333-.887 2.333-2.8 0-1.329-.925-2.45-2.333-2.45zM6.25 5.833c0 1.324.477 1.75 1.167 1.75.687 0 1.166-.409 1.166-1.633 0-.729-.457-1.283-1.166-1.283-.739 0-1.167.476-1.167 1.166z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 11.792,
  cy: 10.792,
  r: 3.208,
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.059 10.524h1.337v.535h-1.337v1.337h-.535v-1.337h-1.336v-.535h1.336V9.188h.535v1.336z",
  fill: "currentColor"
}));

var _ref38 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 18 18",
  id: "icon-collapse",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.366 6.828V5.079H14.22l3.765-3.752-1.24-1.236-3.765 3.752V.71h-1.754v6.119h6.139zM5.088 4.205v4.37H3.334V2.458h6.139v1.748H5.088zm8.77 4.37v4.371H9.473v1.748h6.139V8.576h-1.754zM2.2 17.062l3.765-3.753v3.134h1.754v-6.118h-6.14v1.748h3.145L.96 15.824l1.24 1.237z",
  fill: "currentColor"
}));

var _ref39 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 14 14",
  id: "icon-community",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.005 13.257c3.224 0 5.837-2.585 5.837-5.773 0-3.188-2.613-5.772-5.837-5.772-3.224 0-5.838 2.584-5.838 5.772s2.614 5.773 5.838 5.773z",
  stroke: "currentColor",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.004 2.674c.538 0 .973-.43.973-.962A.968.968 0 007.004.75a.968.968 0 00-.973.962c0 .531.436.962.973.962zM2.885 10.628a.96.96 0 00-.677-1.185.974.974 0 00-1.198.67.96.96 0 00.678 1.184.974.974 0 001.197-.67zM12.31 11.3a.96.96 0 00.688-1.179.974.974 0 00-1.191-.68.96.96 0 00-.688 1.178.974.974 0 001.192.68z",
  fill: "currentColor",
  stroke: "currentColor",
  strokeMiterlimit: 10
}));

var _ref40 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 892 934",
  id: "icon-community-3d",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.04,
  filter: "url(#bmfilter0_f)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M443.882 418.34L71.685 636.775l-30.013 17.641 54.826 32.663 245.479 145.965 54.651 32.519h.088l45.869 27.294 347.284-203.928 54.832-32.23-30.019-17.883-17.053-10.126-54.638-32.526L443.882 418.34z",
  fill: "#211E21"
})), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3 500.804l45.734 25.972 46.921 26.565 25.466 14.841 72.394 42.001 80.925 46.972 60.353 35.099 38.754 22.484 26.728 15.509 45.585 26.566v-5.178l.149-.074v-2.003L3 492.213v8.591z",
  fill: "#E4E4E4"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M446.01 752.331v5.946l47.026-27.072 26.23-14.921 180.692-103.669 72.578-41.628 26.386-15.118 47.019-26.958 46.051-26.429v-5.832L446.01 752.331z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M448.265 238.006L36.225 474.77 3 493.892l60.695 35.404 271.757 158.213 60.501 35.247h.097l50.779 29.585L831.288 531.3l60.702-34.934-33.233-19.383-18.878-10.977-60.486-35.255-331.128-192.745z",
  fill: "url(#bmpaint0_linear)"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.065,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M836.966 466.384l-445.362 256.18-.499-.867 445.363-256.179.498.866zM777.488 430.697L332.126 686.876l-.499-.866 445.362-256.18.499.867zM722.425 400.937l-445.362 256.18-.499-.867 445.363-256.18.498.867zM668.952 368.273L223.59 624.453l-.498-.867 445.362-256.18.498.867zM613.931 338.535L168.569 594.714l-.499-.866 445.362-256.18.499.867zM560.458 302.867L115.096 559.046l-.498-.866L559.96 302l.498.867zM499.427 267.179L54.065 523.359l-.499-.867 445.362-256.18.499.867z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.065,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M53.542 466.384l445.362 256.18.498-.867L54.04 465.518l-.498.866zM113.02 430.697l445.362 256.179.499-.866-445.362-256.18-.499.867zM168.083 400.937l445.362 256.18.498-.867-445.362-256.18-.498.867zM221.555 368.273l445.362 256.18.499-.867-445.362-256.18-.499.867zM276.618 338.535L721.98 594.714l.499-.866-445.363-256.18-.498.867zM330.13 302.867l445.362 256.179.498-.866L330.628 302l-.498.867zM391.081 267.179l445.362 256.18.498-.867-445.362-256.18-.498.867z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M298.232 504.852v51.055l140.194-82.219v-51.061l-140.194 82.225z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M338.948 354.025l101.82 58.79L298.226 495.7l-101.833-58.802 142.555-82.873z",
  fill: "#F7F7F7"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M298.229 495.701v9.153l-101.832-58.802V436.9l101.832 58.801z",
  fill: "#DBDFE0"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M298.228 495.704v9.15l31.654-18.288 110.829-65.076v-9.15l-142.483 83.364z",
  fill: "#CFD2D3"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M232.548 466.925l1.31.754 21.237 12.266.223.13 20.377 11.765 1.082.625 21.453 12.389v51.055l-9.137-5.273v-45.695l-7.017-4.05-5.299-3.06v36.557l-9.138-5.28v-36.557l-7.023-4.056-5.298-3.06v36.557l-9.138-5.273v-36.558l-7.023-4.055-5.299-3.061v36.558l-9.137-5.28v-36.557l-7.018-4.05-5.298-3.06v36.557l-7.914 4.569-1.224-.705v-51.061l29.281 16.909z",
  fill: "#CFD2D3"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M255.315 485.436v36.557l5.298-3.061v-30.436l-5.298-3.06zM276.78 497.832v36.557l5.298-3.06v-30.437l-5.298-3.06zM212.403 460.652v36.557l5.298-3.06v-30.436l-5.298-3.061z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M217.702 463.715v30.436l7.017 4.05v-30.437l-7.017-4.049z",
  fill: "#5DE273"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M233.86 473.043V509.6l5.298-3.06v-30.437l-5.298-3.06z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M239.152 476.104v30.436l7.024 4.056v-30.437l-7.024-4.055zM260.611 488.494v30.437l7.024 4.055V492.55l-7.024-4.056zM282.075 500.891v30.436l7.017 4.05V504.94l-7.017-4.049z",
  fill: "#5DE273"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M198.388 505.304l76.694 44.285 6.102-3.524 7.908-4.569v-6.121l-7.017-4.049-5.299 3.06-9.137-5.28v-6.12l-7.024-4.056-5.298 3.06-9.138-5.274v-6.12l-7.023-4.056-5.299 3.06-9.137-5.279V498.2l-7.018-4.05-5.298 3.061-7.913 4.569-6.103 3.524z",
  fill: "#F9FAFB"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M275.082 549.588v9.138l-76.694-44.286v-9.137l76.694 44.285z",
  fill: "#DBDFE0"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M289.092 550.638l-14.01 8.093v-9.137l6.102-3.525 7.908-4.569v9.138z",
  fill: "#CFD2D3"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M298.232 447.276v51.055l140.194-82.219v-51.061l-140.194 82.225z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M338.948 296.451l101.82 58.79-142.542 82.885-101.833-58.802 142.555-82.873z",
  fill: "#F7F7F7"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M298.229 438.125v9.153l-101.832-58.802v-9.152l101.832 58.801z",
  fill: "#DBDFE0"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M298.228 438.13v9.15l31.654-18.288 110.829-65.076v-9.15L298.228 438.13zM232.548 409.352l1.31.755 21.237 12.266.223.13 20.377 11.765 1.082.624 21.453 12.39v51.055l-9.137-5.273v-45.695l-7.017-4.05-5.299-3.06v36.557l-9.138-5.28v-36.557l-7.023-4.056-5.298-3.06v36.557l-9.138-5.274v-36.557l-7.023-4.055-5.299-3.061v36.557l-9.137-5.28v-36.557l-7.018-4.049-5.298-3.061v36.558l-7.914 4.568-1.224-.704v-51.062l29.281 16.909z",
  fill: "#CFD2D3"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M255.315 427.857v36.558l5.298-3.061v-30.436l-5.298-3.061zM276.78 440.258v36.557l5.298-3.06v-30.437l-5.298-3.06zM212.403 403.078v36.557l5.298-3.06v-30.437l-5.298-3.06z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M217.702 406.145v30.436l7.017 4.049v-30.436l-7.017-4.049z",
  fill: "#5DE273"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M233.86 415.473v36.557l5.298-3.061v-30.436l-5.298-3.06z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M239.152 418.529v30.437l7.024 4.055v-30.436l-7.024-4.056zM260.611 430.92v30.436l7.024 4.056v-30.436l-7.024-4.056zM282.075 443.316v30.437l7.017 4.049v-30.436l-7.017-4.05z",
  fill: "#5DE273"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M298.232 389.709v51.055l140.194-82.218v-51.062l-140.194 82.225z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M338.948 238.885l101.82 58.789-142.542 82.885-101.833-58.802 142.555-82.872z",
  fill: "#F7F7F7"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M298.229 380.557v9.153l-101.832-58.802v-9.152l101.832 58.801z",
  fill: "#DBDFE0"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M298.228 380.557v9.15l31.654-18.287 110.829-65.077v-9.15l-142.483 83.364zM232.548 351.78l1.31.754 21.237 12.267.223.129 20.377 11.766 1.082.624 21.453 12.39v51.055l-9.137-5.274v-45.695l-7.017-4.049-5.299-3.06v36.557l-9.138-5.28v-36.557l-7.023-4.056-5.298-3.06v36.557l-9.138-5.274v-36.557l-7.023-4.056-5.299-3.06v36.557l-9.137-5.28v-36.557l-7.018-4.049-5.298-3.061v36.557l-7.914 4.569-1.224-.705v-51.061l29.281 16.909z",
  fill: "#CFD2D3"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M255.315 370.287v36.557l5.298-3.06v-30.437l-5.298-3.06zM276.78 382.689v36.558l5.298-3.061V385.75l-5.298-3.061zM212.403 345.508v36.557l5.298-3.06v-30.437l-5.298-3.06z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M217.702 348.572v30.437l7.017 4.049v-30.436l-7.017-4.05z",
  fill: "#5DE273"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M233.86 357.9v36.558l5.298-3.061v-30.436l-5.298-3.061z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M239.152 360.959v30.436l7.024 4.056v-30.436l-7.024-4.056zM260.611 373.348v30.436l7.024 4.056v-30.437l-7.024-4.055zM282.075 385.748v30.437l7.017 4.049v-30.436l-7.017-4.05z",
  fill: "#5DE273"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M298.232 329.989v51.055l140.194-82.219v-51.061l-140.194 82.225z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M338.948 179.162l101.82 58.789-142.542 82.885-101.833-58.801 142.555-82.873z",
  fill: "#F7F7F7"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M298.229 320.836v9.153l-101.832-58.802v-9.152l101.832 58.801z",
  fill: "#DBDFE0"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M298.228 320.839v9.15l31.654-18.288 110.829-65.076v-9.15l-142.483 83.364z",
  fill: "#CFD2D3"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M232.548 292.06l1.31.754 21.237 12.266.223.13 20.377 11.765 1.082.624 21.453 12.39v51.055l-9.137-5.273v-45.695l-7.017-4.05-5.299-3.06v36.557l-9.138-5.28v-36.557l-7.023-4.056-5.298-3.06v36.557l-9.138-5.274v-36.557l-7.023-4.055-5.299-3.061v36.557l-9.137-5.28V292.9l-7.018-4.049-5.298-3.061v36.558l-7.914 4.568-1.224-.704V275.15l29.281 16.91z",
  fill: "#CFD2D3"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M255.315 310.568v36.557l5.298-3.06v-30.436l-5.298-3.061zM276.78 322.969v36.557l5.298-3.061v-30.436l-5.298-3.06zM212.403 285.787v36.557l5.298-3.06v-30.437l-5.298-3.06z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M217.702 288.852v30.436l7.017 4.05v-30.437l-7.017-4.049z",
  fill: "#5DE273"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M233.86 298.182v36.557l5.298-3.061v-30.436l-5.298-3.06z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M239.152 301.236v30.437l7.024 4.055v-30.436l-7.024-4.056zM260.611 313.629v30.436l7.024 4.056v-30.436l-7.024-4.056zM282.075 326.027v30.437l7.017 4.049v-30.436l-7.017-4.05z",
  fill: "#5DE273"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M298.232 270.268v51.055l140.194-82.219v-51.061l-140.194 82.225z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M338.948 119.441l101.82 58.79-142.542 82.885-101.833-58.802 142.555-82.873z",
  fill: "#F7F7F7"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M298.229 261.116v9.152l-101.832-58.802v-9.152l101.832 58.802z",
  fill: "#DBDFE0"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M298.228 261.116v9.15l31.654-18.288 110.829-65.076v-9.15l-142.483 83.364zM232.548 232.339l1.31.754 21.237 12.266.223.13 20.377 11.765 1.082.625 21.453 12.389v51.056l-9.137-5.274v-45.695l-7.017-4.05-5.299-3.06v36.557l-9.138-5.28v-36.557l-7.023-4.055-5.298-3.061v36.557l-9.138-5.273v-36.557l-7.023-4.056-5.299-3.061v36.558l-9.137-5.28V233.18l-7.018-4.05-5.298-3.06v36.557l-7.914 4.569-1.224-.705V215.43l29.281 16.909z",
  fill: "#CFD2D3"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M255.315 250.848v36.557l5.298-3.061v-30.436l-5.298-3.06zM276.78 263.248v36.557l5.298-3.06v-30.437l-5.298-3.06zM212.403 226.066v36.557l5.298-3.06v-30.436l-5.298-3.061z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M217.702 229.131v30.436l7.017 4.05V233.18l-7.017-4.049z",
  fill: "#5DE273"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M233.86 238.461v36.557l5.298-3.06v-30.437l-5.298-3.06z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M239.152 241.516v30.436l7.024 4.056v-30.437l-7.024-4.055zM260.611 253.904v30.437l7.024 4.055V257.96l-7.024-4.056zM282.075 266.307v30.436l7.017 4.05v-30.437l-7.017-4.049z",
  fill: "#5DE273"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M298.232 210.547v51.055l140.194-82.219v-51.061l-140.194 82.225z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M338.948 59.72l101.82 58.79-142.542 82.885-101.833-58.802 142.555-82.872z",
  fill: "#F7F7F7"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M298.229 201.393v9.152l-101.832-58.801v-9.152l101.832 58.801z",
  fill: "#DBDFE0"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M298.228 201.395v9.15l31.654-18.288 110.829-65.076v-9.15l-142.483 83.364z",
  fill: "#CFD2D3"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M232.548 172.616l1.31.754 21.237 12.267.223.129 20.377 11.766 1.082.624 21.453 12.39v51.055l-9.137-5.274v-45.695l-7.017-4.049-5.299-3.061v36.558l-9.138-5.28v-36.557l-7.023-4.056-5.298-3.06v36.557l-9.138-5.274v-36.557l-7.023-4.056-5.299-3.06v36.557l-9.137-5.28v-36.557l-7.018-4.05-5.298-3.06v36.557l-7.914 4.569-1.224-.705v-51.061l29.281 16.909z",
  fill: "#CFD2D3"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M255.315 191.125v36.557l5.298-3.06v-30.437l-5.298-3.06zM276.78 203.525v36.557l5.298-3.06v-30.436l-5.298-3.061zM212.403 166.344v36.557l5.298-3.06v-30.437l-5.298-3.06z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M217.702 169.41v30.437l7.017 4.049V173.46l-7.017-4.05z",
  fill: "#5DE273"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M233.86 178.736v36.557l5.298-3.06v-30.436l-5.298-3.061z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M239.152 181.795v30.436l7.024 4.056v-30.436l-7.024-4.056zM260.611 194.186v30.436l7.024 4.056v-30.437l-7.024-4.055zM282.075 206.584v30.436l7.017 4.05v-30.436l-7.017-4.05z",
  fill: "#5DE273"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M298.232 150.826v51.055l140.194-82.218V68.602l-140.194 82.224z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M338.948 0l101.82 58.79-142.542 82.884-101.833-58.801L338.948 0z",
  fill: "#F7F7F7"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M298.229 141.674v9.153L196.397 92.025v-9.152l101.832 58.801z",
  fill: "#DBDFE0"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M298.228 141.674v9.151l31.654-18.288 110.829-65.076v-9.15l-142.483 83.363z",
  fill: "#CFD2D3"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M232.548 112.895l1.31.755 21.237 12.266.223.13 20.377 11.765 1.082.624 21.453 12.39v51.055l-9.137-5.273v-45.695l-7.017-4.05-5.299-3.06v36.557l-9.138-5.28v-36.557l-7.023-4.056-5.298-3.06v36.557l-9.138-5.274v-36.557l-7.023-4.056-5.299-3.06v36.557l-9.137-5.28v-36.557l-7.018-4.049-5.298-3.061v36.558l-7.914 4.568-1.224-.704V95.986l29.281 16.909z",
  fill: "#CFD2D3"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M255.315 131.404v36.557l5.298-3.06v-30.436l-5.298-3.061zM276.78 143.805v36.557l5.298-3.061v-30.436l-5.298-3.06zM212.403 106.625v36.557l5.298-3.06v-30.437l-5.298-3.06z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M217.702 109.689v30.437l7.017 4.049v-30.436l-7.017-4.05z",
  fill: "#5DE273"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M233.86 119.018v36.557l5.298-3.061v-30.436l-5.298-3.06z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M239.152 122.074v30.437l7.024 4.055V126.13l-7.024-4.056zM260.611 134.463v30.436l7.024 4.056v-30.436l-7.024-4.056zM282.075 146.863V177.3l7.017 4.049v-30.436l-7.017-4.05z",
  fill: "#5DE273"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M267.045 523.972v50.253l31.158-17.994v-50.26l-31.158 18.001z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M199.019 438.805l100.221 57.867-32.195 18.289-100.234-57.879 32.208-18.277z",
  fill: "#F9FAFB"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M267.041 514.96v9.009L166.807 466.09v-9.008l100.234 57.878z",
  fill: "#DBDFE0"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M267.044 514.964v9.007l31.158-18.001 6.755-3.901v-9.007l-37.913 21.902z",
  fill: "#CFD2D3"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M202.395 486.636l1.29.742 20.903 12.074.22.128 20.057 11.58 1.065.615 21.117 12.195v50.254l-8.994-5.191v-44.977l-6.907-3.986-5.216-3.013v35.984l-8.994-5.197V511.86l-6.913-3.992-5.215-3.012v35.983l-8.995-5.191v-35.983l-6.913-3.992-5.215-3.012v35.983l-8.994-5.197v-35.983l-6.907-3.986-5.216-3.013v35.984l-7.789 4.497-1.205-.694v-50.26l28.821 16.644z",
  fill: "#CFD2D3"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M224.798 504.855v35.984l5.216-3.012v-29.959l-5.216-3.013zM245.927 517.057v35.983l5.216-3.012v-29.959l-5.216-3.012zM182.562 480.465v35.983l5.215-3.012v-29.959l-5.215-3.012z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M187.779 483.477v29.958l6.907 3.986v-29.958l-6.907-3.986z",
  fill: "#6E6"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M203.681 492.66v35.984l5.215-3.013v-29.959l-5.215-3.012z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M208.897 495.67v29.959l6.914 3.992v-29.959l-6.914-3.992zM230.02 507.869v29.959l6.914 3.992v-29.959l-6.914-3.992zM251.142 520.07v29.959l6.907 3.986v-29.959l-6.907-3.986z",
  fill: "#6E6"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M168.769 524.414l75.49 43.59 6.006-3.469 7.784-4.497v-6.024l-6.907-3.986-5.215 3.012-8.995-5.197v-6.025l-6.913-3.992-5.215 3.012-8.994-5.19v-6.025l-6.914-3.992-5.215 3.012-8.994-5.197v-6.024l-6.907-3.986-5.215 3.012-7.79 4.497-6.006 3.469z",
  fill: "#F9FAFB"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M244.26 568.004v8.995l-75.491-43.591v-8.994l75.491 43.59z",
  fill: "#DBDFE0"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M258.049 569.035l-13.79 7.966v-8.993l6.007-3.47 7.783-4.497v8.994z",
  fill: "#CFD2D3"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#bmfilter1_f)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M191.948 484.84v29.959l6.907 3.986v-29.959l-6.907-3.986z",
  fill: "#6E6"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#bmfilter2_f)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M213.065 497.035v29.959l6.914 3.992v-29.959l-6.914-3.992z",
  fill: "#6E6"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#bmfilter3_f)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M234.19 509.234v29.959l6.914 3.992v-29.959l-6.914-3.992z",
  fill: "#6E6"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#bmfilter4_f)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M255.312 521.432v29.958l6.907 3.986v-29.958l-6.907-3.986z",
  fill: "#6E6"
})), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M266.447 464.38v51.541l31.955-18.456v-51.547l-31.955 18.462z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M195.85 377.023l102.789 59.349-32.192 18.767-102.801-59.362 32.204-18.754z",
  fill: "#F9FAFB"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M266.443 455.138v9.24l-102.801-59.362v-9.239l102.801 59.361z",
  fill: "#DBDFE0"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M266.447 455.142v9.237l31.955-18.461 6.928-4.001v-9.237l-38.883 22.462zM200.139 426.09l1.324.761 21.439 12.383.224.131 20.572 11.877 1.092.63 21.657 12.508v51.541l-9.224-5.324v-46.13l-7.084-4.088-5.349-3.089v36.905l-9.225-5.33V451.96l-7.09-4.094-5.349-3.09v36.905l-9.224-5.324v-36.905l-7.091-4.094-5.348-3.09v36.905l-9.225-5.33v-36.905l-7.084-4.088-5.349-3.089v36.905l-7.989 4.612-1.236-.711V409.02l29.559 17.07z",
  fill: "#CFD2D3"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M223.118 444.773v36.905l5.349-3.089v-30.726l-5.349-3.09zM244.786 457.287v36.905l5.349-3.089v-30.726l-5.349-3.09zM179.802 419.76v36.905l5.348-3.09v-30.726l-5.348-3.089z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M185.152 422.848v30.726l7.084 4.088v-30.726l-7.084-4.088z",
  fill: "#6E6"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M201.46 432.268v36.905l5.349-3.09v-30.726l-5.349-3.089z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M206.81 435.354v30.726l7.09 4.094v-30.726l-7.09-4.094zM228.472 447.863v30.726l7.09 4.095v-30.726l-7.09-4.095zM250.137 460.377v30.726l7.084 4.088v-30.726l-7.084-4.088z",
  fill: "#6E6"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#bmfilter5_f)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M189.428 424.246v30.726l7.084 4.088v-30.726l-7.084-4.088z",
  fill: "#6E6"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#bmfilter6_f)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M211.088 436.754v30.726l7.09 4.094v-30.726l-7.09-4.094z",
  fill: "#6E6"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#bmfilter7_f)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M232.75 449.264v30.726l7.09 4.094v-30.726l-7.09-4.094z",
  fill: "#6E6"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#bmfilter8_f)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M254.414 461.773V492.5l7.084 4.088v-30.726l-7.084-4.089z",
  fill: "#6E6"
})), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M266.447 407.88v51.541l31.955-18.456v-51.547l-31.955 18.462z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M195.85 320.523l102.789 59.349-32.192 18.767-102.801-59.362 32.204-18.754z",
  fill: "#F9FAFB"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M266.443 398.638v9.24l-102.801-59.362v-9.239l102.801 59.361z",
  fill: "#DBDFE0"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M266.447 398.642v9.237l31.955-18.461 6.928-4.001v-9.237l-38.883 22.462zM200.139 369.59l1.324.761 21.439 12.383.224.131 20.572 11.877 1.092.63 21.657 12.508v51.541l-9.224-5.324v-46.13l-7.084-4.088-5.349-3.089v36.905l-9.225-5.33V395.46l-7.09-4.094-5.349-3.09v36.905l-9.224-5.324v-36.905l-7.091-4.094-5.348-3.09v36.905l-9.225-5.33v-36.905l-7.084-4.088-5.349-3.089v36.905l-7.989 4.612-1.236-.711V352.52l29.559 17.07z",
  fill: "#CFD2D3"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M223.118 388.273v36.905l5.349-3.089v-30.726l-5.349-3.09zM244.786 400.787v36.905l5.349-3.089v-30.726l-5.349-3.09zM179.802 363.26v36.905l5.348-3.09v-30.726l-5.348-3.089z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M185.152 366.348v30.726l7.084 4.088v-30.726l-7.084-4.088z",
  fill: "#6E6"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M201.46 375.768v36.905l5.349-3.09v-30.726l-5.349-3.089z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M206.81 378.854v30.726l7.09 4.094v-30.726l-7.09-4.094zM228.472 391.363v30.726l7.09 4.095v-30.726l-7.09-4.095zM250.137 403.877v30.726l7.084 4.088v-30.726l-7.084-4.088z",
  fill: "#6E6"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#bmfilter9_f)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M189.428 367.746v30.726l7.084 4.088v-30.726l-7.084-4.088z",
  fill: "#6E6"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#bmfilter10_f)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M211.088 380.256v30.726l7.09 4.094V384.35l-7.09-4.094z",
  fill: "#6E6"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#bmfilter11_f)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M232.75 392.764v30.726l7.09 4.094v-30.726l-7.09-4.094z",
  fill: "#6E6"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#bmfilter12_f)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M254.414 405.273V436l7.084 4.088v-30.726l-7.084-4.089z",
  fill: "#6E6"
})), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M266.447 347.659V399.2l31.955-18.456v-51.547l-31.955 18.462z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M202.542 256.607l102.788 59.349-38.883 22.463-102.801-59.362 38.896-22.45z",
  fill: "#F9FAFB"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M266.443 338.419v9.24l-102.801-59.361v-9.239l102.801 59.36z",
  fill: "#DBDFE0"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M266.447 338.422v9.237l31.955-18.462 6.928-4.001v-9.237l-38.883 22.463zM200.139 309.369l1.324.761 21.439 12.383.224.131 20.572 11.877 1.092.631 21.657 12.507V399.2l-9.224-5.324v-46.129l-7.084-4.088-5.349-3.09v36.905l-9.225-5.33v-36.905l-7.09-4.094-5.349-3.09v36.905l-9.224-5.323v-36.905l-7.091-4.095-5.348-3.089v36.905l-9.225-5.33v-36.905l-7.084-4.088-5.349-3.09v36.905l-7.989 4.612-1.236-.711v-51.547l29.559 17.07z",
  fill: "#CFD2D3"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M223.118 328.055v36.905l5.349-3.09v-30.726l-5.349-3.089zM244.784 340.566v36.905l5.349-3.089v-30.726l-5.349-3.09zM179.8 303.039v36.905l5.348-3.089v-30.726l-5.348-3.09z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M185.15 306.129v30.726l7.084 4.088v-30.726l-7.084-4.088z",
  fill: "#6E6"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M201.46 315.549v36.905l5.349-3.09v-30.726l-5.349-3.089z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M206.806 318.635v30.726l7.09 4.094v-30.726l-7.09-4.094zM228.47 331.145v30.726l7.091 4.094v-30.726l-7.091-4.094zM250.137 343.658v30.726l7.084 4.088v-30.726l-7.084-4.088z",
  fill: "#6E6"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#bmfilter13_f)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M189.424 307.527v30.726l7.084 4.088v-30.726l-7.084-4.088z",
  fill: "#6E6"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#bmfilter14_f)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M211.086 320.035v30.726l7.09 4.095v-30.727l-7.09-4.094z",
  fill: "#6E6"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#bmfilter15_f)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M232.75 332.545v30.726l7.09 4.094v-30.726l-7.09-4.094z",
  fill: "#6E6"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#bmfilter16_f)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M254.414 345.055v30.726l7.084 4.088v-30.726l-7.084-4.088z",
  fill: "#6E6"
})), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M480.288 102l72.288 45.146-72.288 45.153-72.297-45.153L480.288 102zm55.927 47.354l3.528-2.208-59.455-37.134-59.463 37.134 3.528 2.208 55.935 34.933 55.927-34.933z",
  fill: "#F9FAFB"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M480.287 110.012v4.41l55.927 34.932 3.528-2.209-59.455-37.133z",
  fill: "#CFD2D3"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M420.824 147.145l3.529 2.209 55.934-34.932v-4.41l-59.463 37.133z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M424.353 149.356l55.935 34.933 55.927-34.933-55.927-34.932-55.935 34.932z",
  fill: "#F9FAFB"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M480.288 192.3v45.162l72.288-45.162v-45.154L480.288 192.3z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M407.991 147.146V192.3l72.296 45.162V192.3l-72.296-45.154z",
  fill: "#CFD2D3"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M480.287 237.458v6.801l76.274-47.643-3.986-4.319-72.288 45.161z",
  fill: "#DBDFE0"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M404.006 196.616l76.274 47.651.007-.008v-6.801l-72.296-45.161-3.985 4.319z",
  fill: "#F9FAFB"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M480.287 244.26v5.721l72.288-45.162 3.986-2.49v-5.712l-76.274 47.643z",
  fill: "#CFD2D3"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M404.006 196.617v5.712l3.985 2.49 16.24 10.146 4.846 3.025 34.971 21.853 16.232 10.138h.007v-5.705l-.007-.008-76.274-47.651z",
  fill: "#DBDFE0"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M480.288 249.982v45.26l72.288-45.153V204.82l-72.288 45.162z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M424.298 234.379l39.749 24.826v-5.967l-34.971-21.843-4.778 2.984z",
  fill: "#DBDFE0"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M429.076 217.99v13.402l34.971 21.844v-13.394l-34.971-21.852z",
  fill: "#6E6"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M424.229 214.967v19.371l.069.04 4.778-2.983v-13.404l-4.847-3.024z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M407.991 204.82v45.269l72.289 45.161h.007v-45.268h-.007l-16.232-10.138v19.361l-39.749-24.826-.068-.042v-19.371l-16.24-10.146z",
  fill: "#CFD2D3"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M404.006 254.398v5.721l3.985 2.489 16.24 10.147 4.846 3.025 34.971 21.844 16.239 10.138v-5.712h-.007l-76.274-47.652z",
  fill: "#DBDFE0"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M480.287 295.243v6.809l76.274-47.651-3.986-4.311-72.288 45.153z",
  fill: "#DBDFE0"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M404.006 254.401l76.274 47.651h.007v-6.801h-.007l-72.289-45.161-3.985 4.311z",
  fill: "#F9FAFB"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M480.287 302.05v5.712l72.288-45.154 3.986-2.489v-5.721l-76.274 47.652z",
  fill: "#CFD2D3"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M480.288 307.763v45.195l72.288-45.162v-45.187l-72.288 45.154z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M407.991 262.609v45.187l72.296 45.162v-45.195l-16.239-10.138v19.288l-39.817-24.869v-19.288l-16.24-10.147z",
  fill: "#CFD2D3"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M404.006 312.115v5.712l3.985 2.49 16.24 10.146 4.846 3.025 34.971 21.853 16.232 10.138.007-.008v-5.713l-76.281-47.643zM480.287 352.956v6.801l76.274-47.643-3.986-4.319-72.288 45.161z",
  fill: "#DBDFE0"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M404.006 312.114l76.281 47.643v-6.801l-72.296-45.161-3.985 4.319z",
  fill: "#F9FAFB"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M480.287 359.758v5.713l72.288-45.154 3.986-2.49v-5.712l-76.274 47.643z",
  fill: "#CFD2D3"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M429.076 275.779v13.18l34.971 21.844v-13.18l-34.971-21.844z",
  fill: "#6E6"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M424.23 291.986v.057l39.817 24.868v-6.107l-34.97-21.843-4.847 3.025z",
  fill: "#DBDFE0"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M424.229 272.756v19.23l4.847-3.025V275.78l-4.847-3.024zM480.288 365.47v45.153l72.288-45.161v-45.146l-72.288 45.154z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M429.076 333.543v13.131l34.971 21.843v-13.123l-34.971-21.851z",
  fill: "#6E6"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#bmfilter17_f)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M429.076 217.99v13.402l34.971 21.844v-13.394l-34.971-21.852z",
  fill: "#6E6"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#bmfilter18_f)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M429.076 275.779v13.18l34.971 21.844v-13.18l-34.971-21.844z",
  fill: "#6E6"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#bmfilter19_f)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M429.076 333.543v13.131l34.971 21.843v-13.123l-34.971-21.851z",
  fill: "#6E6"
})), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M424.23 349.644v.057l39.817 24.868v-6.107l-34.97-21.843-4.847 3.025z",
  fill: "#DBDFE0"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M407.991 320.318v45.146l72.296 45.161v-45.137l-.007-.008-16.232-10.138v19.23l-39.817-24.869v-19.239l-16.24-10.146z",
  fill: "#CFD2D3"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M424.229 330.516v19.181l4.847-3.026V333.54l-4.847-3.024zM480.28 423.14v45.096l72.288-45.153v-45.112L480.28 423.14z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M552.576 377.974v-.05",
  stroke: "#231F20"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M407.984 377.971v20.21l16.17-10.104-16.17-10.106z",
  fill: "#CFD2D3"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M445.185 433.888l16.826 10.51v12.43l8.132 5.077-6.097-39.788-18.861 11.771z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M464.042 422.109v.008l6.097 39.788 10.142 6.33v-35.988l-16.239-10.138z",
  fill: "#CFD2D3"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M407.99 419.814v3.264l18.358 11.474v-3.264l-18.358-11.474z",
  fill: "#DBDFE0"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M426.343 431.292v3.256l1.6.998 7.301 4.558 26.764 16.725v-33.44l-16.826 10.5-7.294 4.558v.066l-.046-.024-7.292-4.576-4.207-2.621z",
  fill: "#BBBBBC"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M424.161 388.082l.061.034 39.819 24.876-26.156 16.338-29.902-18.678-2.69-1.682-7.294-4.559 9.984-6.231 16.172-10.106.006.008z",
  fill: "#F9FAFB"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M404 369.777v5.713l3.986 2.48 16.17 10.106.008.008.062.033 39.816 24.876 16.239 10.148v-5.72h-.007L404 369.777zM480.287 410.623v6.8l76.274-47.651-1.212-1.311-2.774-3-72.288 45.162z",
  fill: "#DBDFE0"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M404.006 369.772l76.274 47.651h.007v-6.801l-72.296-45.161-3.985 4.311z",
  fill: "#F9FAFB"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M480.287 417.425v5.712l72.288-45.162 3.986-2.489v-5.713l-76.274 47.652zM437.887 429.329v9.117l7.292-4.558 18.862-11.771v-9.125l-26.154 16.337z",
  fill: "#CFD2D3"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M405.302 408.976l2.689 1.681 29.904 18.678v9.118l-.046.032-7.293-4.567-4.206-2.628-18.359-11.475-9.983-6.239v-9.158l7.294 4.558z",
  fill: "#DBDFE0"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M424.231 234.421l.07-.042-.07.042z",
  fill: "#231F20"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M464.042 412.992v9.117l16.239 10.138v-9.109l-16.239-10.146zM698.316 459.017v58.314l36.155-20.881v-58.321l-36.155 20.888z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M626.01 356l116.297 67.148-43.994 25.415-116.31-67.163L626.01 356z",
  fill: "#F9FAFB"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M698.311 448.564v10.454L582 391.856v-10.454l116.311 67.162z",
  fill: "#DBDFE0"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M698.313 448.565v10.451l36.155-20.888 7.839-4.527V423.15l-43.994 25.415zM623.293 415.694l1.497.862 24.256 14.01.254.148 23.275 13.438 1.236.713 24.503 14.152v58.314l-10.437-6.024v-52.191l-8.014-4.626-6.052-3.495v41.755l-10.437-6.031v-41.755l-8.022-4.632-6.052-3.496v41.755l-10.437-6.023v-41.755l-8.022-4.632-6.051-3.496v41.755l-10.437-6.031v-41.754l-8.015-4.626-6.052-3.495v41.755l-9.039 5.218-1.398-.805v-58.321l33.444 19.313z",
  fill: "#CFD2D3"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M649.296 436.836v41.755l6.052-3.496v-34.764l-6.052-3.495zM673.81 450.994v41.755l6.051-3.495V454.49l-6.051-3.496zM600.28 408.533v41.755l6.052-3.495v-34.764l-6.052-3.496z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M606.337 412.029v34.764l8.015 4.626v-34.764l-8.015-4.626z",
  fill: "#6E6"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M624.788 422.684v41.755l6.052-3.496v-34.764l-6.052-3.495z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M630.839 426.18v34.764l8.022 4.632v-34.764l-8.022-4.632zM655.353 440.332v34.764l8.022 4.632v-34.764l-8.022-4.632zM679.862 454.49v34.764l8.015 4.626v-34.764l-8.015-4.626z",
  fill: "#6E6"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M584.277 459.532l87.598 50.582 6.97-4.025 9.032-5.219v-6.991l-8.015-4.625-6.052 3.496-10.437-6.031v-6.991l-8.022-4.632-6.051 3.495-10.437-6.023v-6.991l-8.022-4.633-6.052 3.496-10.437-6.031v-6.991l-8.015-4.625-6.051 3.495-9.039 5.219-6.97 4.025z",
  fill: "#F9FAFB"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M671.873 510.113v10.437l-87.598-50.582v-10.437l87.598 50.582z",
  fill: "#DBDFE0"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M687.877 511.308l-16.002 9.244v-10.437l6.97-4.025 9.032-5.219v10.437z",
  fill: "#CFD2D3"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#bmfilter20_f)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M611.171 413.613v34.764l8.015 4.626v-34.764l-8.015-4.626z",
  fill: "#6E6"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#bmfilter21_f)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M635.675 427.762v34.764l8.022 4.632v-34.764l-8.022-4.632z",
  fill: "#6E6"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#bmfilter22_f)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M660.187 441.916v34.764l8.022 4.632v-34.764l-8.022-4.632z",
  fill: "#6E6"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#bmfilter23_f)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M684.698 456.072v34.764l8.015 4.626v-34.764l-8.015-4.626z",
  fill: "#6E6"
})), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M484.791 540.206l67.836 39.179V379.346l-67.836-39.178v200.038z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M613.02 475.665l-52.963 30.595v-8.593l45.532-26.288 7.431 4.286zM610.987 507.241l-8.303 4.792-7.431 4.286-7.56 4.362-.528.301-8.475 4.9-8.303-8.303 5.438-3.145 26.859-15.496 8.303 8.303z",
  fill: "#F9FAFB"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M620.466 340.168v93.197l-7.441-4.297v-76.02l-7.431 4.286-45.532 26.299v76.03l-7.431 4.297v-84.614l67.835-39.178zM613.025 449.107v26.557l-52.964 30.596v-29.433l9.09-5.244-9.09-5.245-7.43 4.297v108.748l17.758-10.253v-51.552l5.439-3.144 26.858-15.497 8.303 8.303-8.303 4.792v38.435l8.303-4.792 9.476-5.471v-95.393l-7.44 4.296z",
  fill: "#CFD2D3"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M552.627 301l-67.836 39.168 67.836 39.178 67.835-39.178L552.627 301z",
  fill: "#F9FAFB"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M605.589 357.334v67.448l-45.532 26.287v-67.437l45.532-26.298z",
  fill: "#6E6"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M613.025 353.047v76.02l-7.431-4.286v-67.448l7.431-4.286z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M560.057 451.069v8.594l11.578 6.677 48.826-28.216 4.125-2.38-4.125-2.38-7.44-4.297-7.432-4.286-45.532 26.288z",
  fill: "#F9FAFB"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M620.459 438.124l-48.826 28.215v6.677l33.954-19.611 7.432-4.296 7.44-4.297 4.125-2.38v-6.688l-4.125 2.38z",
  fill: "#DBDFE0"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M571.634 466.339v6.677l-2.488-1.432-9.089-5.245v-6.677l11.577 6.677z",
  fill: "#CFD2D3"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M605.589 453.404v17.974l-45.532 26.288v-20.839l9.089-5.244 2.488 1.432 33.955-19.611z",
  fill: "#6E6"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M613.025 449.109v26.557l-7.431-4.286v-17.974l7.431-4.297zM602.683 512.033v38.436l-7.431-4.437v-29.713l7.431-4.286z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M595.253 525.183v20.849l-24.866 14.356V517.58l8.303 8.303 8.475-4.9.528-.301 6.117 3.64 1.443.861z",
  fill: "#6E6"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#bmfilter24_f)",
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#6E6"
}, /*#__PURE__*/React.createElement("path", {
  d: "M605.589 357.334v67.448l-45.532 26.287v-67.437l45.532-26.298zM605.589 453.406v17.974l-45.532 26.288v-20.839l9.089-5.244 2.488 1.432 33.955-19.611zM595.253 525.183v20.849l-24.866 14.356V517.58l8.303 8.303 8.475-4.9.528-.301 6.117 3.64 1.443.861z"
})), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M560.062 459.662v6.677l-7.431 4.297v-6.677l7.431-4.297z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M602.686 550.469l-7.431-4.437-24.866 14.356v8.743l-17.758 10.254h14.56l8.034-4.642h10.898l24.866-14.355v-14.712l-8.303 4.793z",
  fill: "#CED1D5"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M595.251 516.318v8.863l-1.443-.861-6.117-3.64 7.56-4.362z",
  fill: "#AAA"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M432.273 296l-72.289 45.146 72.289 45.153 72.297-45.153L432.273 296zm-55.927 47.354l-3.529-2.208 59.456-37.134 59.462 37.134-3.528 2.208-55.934 34.933-55.927-34.933z",
  fill: "#F9FAFB"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M432.274 304.012v4.41l-55.928 34.932-3.528-2.209 59.456-37.133z",
  fill: "#CFD2D3"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M491.736 341.145l-3.528 2.209-55.935-34.932v-4.41l59.463 37.133z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M488.207 343.356l-55.934 34.933-55.927-34.933 55.927-34.932 55.934 34.932z",
  fill: "#F9FAFB"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M432.273 386.3v45.162L359.984 386.3v-45.154l72.289 45.154z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M504.569 341.146V386.3l-72.296 45.162V386.3l72.296-45.154z",
  fill: "#CFD2D3"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M432.274 431.458v6.801L356 390.616l3.986-4.319 72.288 45.161z",
  fill: "#DBDFE0"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M508.555 390.616l-76.274 47.651-.008-.008v-6.801l72.296-45.161 3.986 4.319z",
  fill: "#F9FAFB"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M432.274 438.26v5.721l-72.288-45.162-3.986-2.49v-5.712l76.274 47.643z",
  fill: "#CFD2D3"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M508.555 390.617v5.712l-3.986 2.49-16.24 10.146-4.846 3.025-34.971 21.853-16.231 10.138h-.008v-5.705l.008-.008 76.274-47.651z",
  fill: "#DBDFE0"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M432.273 443.982v45.26l-72.289-45.153V398.82l72.289 45.162z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M488.263 428.379l-39.749 24.826v-5.967l34.971-21.843 4.778 2.984z",
  fill: "#DBDFE0"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M483.485 411.99v13.402l-34.971 21.844v-13.394l34.971-21.852z",
  fill: "#6E6"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M488.332 408.967v19.371l-.07.04-4.778-2.983v-13.404l4.848-3.024z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M504.569 398.82v45.269l-72.288 45.161h-.008v-45.268h.008l16.231-10.138v19.361l39.749-24.826.068-.042v-19.371l16.24-10.146z",
  fill: "#CFD2D3"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M508.555 448.398v5.721l-3.986 2.489-16.24 10.147-4.846 3.025-34.971 21.844-16.239 10.138v-5.712h.008l76.274-47.652z",
  fill: "#DBDFE0"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M432.274 489.243v6.809L356 448.401l3.986-4.311 72.288 45.153z",
  fill: "#DBDFE0"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M508.555 448.401l-76.274 47.651h-.008v-6.801h.008l72.288-45.161 3.986 4.311z",
  fill: "#F9FAFB"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M432.274 496.05v5.712l-72.288-45.154-3.986-2.489v-5.721l76.274 47.652z",
  fill: "#CFD2D3"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M432.273 501.763v45.195l-72.289-45.162v-45.187l72.289 45.154z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M504.569 456.609v45.187l-72.296 45.162v-45.195l16.239-10.138v19.288l39.817-24.869v-19.288l16.24-10.147z",
  fill: "#CFD2D3"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M508.555 506.115v5.712l-3.986 2.49-16.24 10.146-4.846 3.025-34.971 21.853-16.231 10.138-.008-.008v-5.713l76.282-47.643zM432.274 546.956v6.801L356 506.114l3.986-4.319 72.288 45.161z",
  fill: "#DBDFE0"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M508.555 506.114l-76.282 47.643v-6.801l72.296-45.161 3.986 4.319z",
  fill: "#F9FAFB"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M432.274 553.758v5.713l-72.288-45.154-3.986-2.49v-5.712l76.274 47.643z",
  fill: "#CFD2D3"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M483.485 469.779v13.18l-34.971 21.844v-13.18l34.971-21.844z",
  fill: "#6E6"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M488.331 485.986v.057l-39.817 24.868v-6.107l34.969-21.843 4.848 3.025z",
  fill: "#DBDFE0"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M488.332 466.756v19.23l-4.848-3.025V469.78l4.848-3.024zM432.273 559.47v45.153l-72.289-45.161v-45.146l72.289 45.154z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M483.485 527.543v13.131l-34.971 21.843v-13.123l34.971-21.851z",
  fill: "#6E6"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#bmfilter25_f)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M483.485 411.99v13.402l-34.971 21.844v-13.394l34.971-21.852z",
  fill: "#6E6"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#bmfilter26_f)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M483.485 469.779v13.18l-34.971 21.844v-13.18l34.971-21.844z",
  fill: "#6E6"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#bmfilter27_f)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M483.485 527.543v13.131l-34.971 21.843v-13.123l34.971-21.851z",
  fill: "#6E6"
})), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M488.331 543.644v.057l-39.817 24.868v-6.107l34.969-21.843 4.848 3.025z",
  fill: "#DBDFE0"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M504.569 514.318v45.146l-72.296 45.161v-45.137l.008-.008 16.231-10.138v19.23l39.817-24.869v-19.239l16.24-10.146z",
  fill: "#CFD2D3"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M488.332 524.516v19.181l-4.848-3.026V527.54l4.848-3.024zM432.28 617.14v45.096l-72.288-45.153v-45.112l72.288 45.169z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M359.984 571.974v-.05",
  stroke: "#231F20"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M504.577 571.971v20.21l-16.171-10.104 16.171-10.106z",
  fill: "#CFD2D3"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M467.376 627.888l-16.826 10.51v12.43l-8.132 5.077 6.097-39.788 18.861 11.771z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M448.518 616.109v.008l-6.097 39.788-10.142 6.33v-35.988l16.239-10.138z",
  fill: "#CFD2D3"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M504.571 613.814v3.264l-18.358 11.474v-3.264l18.358-11.474z",
  fill: "#DBDFE0"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M486.217 625.292v3.256l-1.599.998-7.301 4.558-26.764 16.725v-33.44l16.826 10.5 7.293 4.558v.066l.046-.024 7.292-4.576 4.207-2.621z",
  fill: "#BBBBBC"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M488.399 582.082l-.06.034-39.819 24.876 26.155 16.338 29.903-18.678 2.69-1.682 7.293-4.559-9.983-6.231-16.172-10.106-.007.008z",
  fill: "#F9FAFB"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M508.56 563.777v5.713l-3.985 2.48-16.171 10.106-.007.008-.062.033-39.817 24.876-16.239 10.148v-5.72h.008l76.273-47.644zM432.274 604.623v6.8L356 563.772l1.211-1.311 2.775-3 72.288 45.162z",
  fill: "#DBDFE0"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M508.555 563.772l-76.274 47.651h-.008v-6.801l72.296-45.161 3.986 4.311z",
  fill: "#F9FAFB"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M432.274 611.425v5.712l-72.288-45.162-3.986-2.489v-5.713l76.274 47.652zM474.674 623.329v9.117l-7.292-4.558-18.862-11.771v-9.125l26.154 16.337z",
  fill: "#CFD2D3"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M507.259 602.976l-2.689 1.681-29.904 18.678v9.118l.046.032 7.292-4.567 4.207-2.628 18.359-11.475 9.982-6.239v-9.158l-7.293 4.558z",
  fill: "#DBDFE0"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M488.329 428.421l-.069-.042.069.042z",
  fill: "#231F20"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M448.518 606.992v9.117l-16.239 10.138v-9.109l16.239-10.146z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "bmfilter0_f",
  x: 0.89,
  y: 377.558,
  width: 884.594,
  height: 556.081,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 20.391,
  result: "effect1_foregroundBlur"
})), /*#__PURE__*/React.createElement("filter", {
  id: "bmfilter1_f",
  x: 175.949,
  y: 468.84,
  width: 38.907,
  height: 65.945,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 8,
  result: "effect1_foregroundBlur"
})), /*#__PURE__*/React.createElement("filter", {
  id: "bmfilter2_f",
  x: 197.064,
  y: 481.035,
  width: 38.913,
  height: 65.951,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 8,
  result: "effect1_foregroundBlur"
})), /*#__PURE__*/React.createElement("filter", {
  id: "bmfilter3_f",
  x: 218.189,
  y: 493.234,
  width: 38.913,
  height: 65.951,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 8,
  result: "effect1_foregroundBlur"
})), /*#__PURE__*/React.createElement("filter", {
  id: "bmfilter4_f",
  x: 239.312,
  y: 505.432,
  width: 38.907,
  height: 65.945,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 8,
  result: "effect1_foregroundBlur"
})), /*#__PURE__*/React.createElement("filter", {
  id: "bmfilter5_f",
  x: 173.428,
  y: 408.246,
  width: 39.084,
  height: 66.814,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 8,
  result: "effect1_foregroundBlur"
})), /*#__PURE__*/React.createElement("filter", {
  id: "bmfilter6_f",
  x: 195.088,
  y: 420.754,
  width: 39.09,
  height: 66.82,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 8,
  result: "effect1_foregroundBlur"
})), /*#__PURE__*/React.createElement("filter", {
  id: "bmfilter7_f",
  x: 216.75,
  y: 433.264,
  width: 39.09,
  height: 66.82,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 8,
  result: "effect1_foregroundBlur"
})), /*#__PURE__*/React.createElement("filter", {
  id: "bmfilter8_f",
  x: 238.414,
  y: 445.773,
  width: 39.084,
  height: 66.814,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 8,
  result: "effect1_foregroundBlur"
})), /*#__PURE__*/React.createElement("filter", {
  id: "bmfilter9_f",
  x: 173.428,
  y: 351.746,
  width: 39.084,
  height: 66.814,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 8,
  result: "effect1_foregroundBlur"
})), /*#__PURE__*/React.createElement("filter", {
  id: "bmfilter10_f",
  x: 195.088,
  y: 364.256,
  width: 39.09,
  height: 66.82,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 8,
  result: "effect1_foregroundBlur"
})), /*#__PURE__*/React.createElement("filter", {
  id: "bmfilter11_f",
  x: 216.75,
  y: 376.764,
  width: 39.09,
  height: 66.82,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 8,
  result: "effect1_foregroundBlur"
})), /*#__PURE__*/React.createElement("filter", {
  id: "bmfilter12_f",
  x: 238.414,
  y: 389.273,
  width: 39.084,
  height: 66.814,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 8,
  result: "effect1_foregroundBlur"
})), /*#__PURE__*/React.createElement("filter", {
  id: "bmfilter13_f",
  x: 173.424,
  y: 291.527,
  width: 39.084,
  height: 66.814,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 8,
  result: "effect1_foregroundBlur"
})), /*#__PURE__*/React.createElement("filter", {
  id: "bmfilter14_f",
  x: 195.086,
  y: 304.035,
  width: 39.09,
  height: 66.82,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 8,
  result: "effect1_foregroundBlur"
})), /*#__PURE__*/React.createElement("filter", {
  id: "bmfilter15_f",
  x: 216.75,
  y: 316.545,
  width: 39.09,
  height: 66.82,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 8,
  result: "effect1_foregroundBlur"
})), /*#__PURE__*/React.createElement("filter", {
  id: "bmfilter16_f",
  x: 238.414,
  y: 329.055,
  width: 39.084,
  height: 66.814,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 8,
  result: "effect1_foregroundBlur"
})), /*#__PURE__*/React.createElement("filter", {
  id: "bmfilter17_f",
  x: 413.076,
  y: 201.99,
  width: 66.971,
  height: 67.245,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 8,
  result: "effect1_foregroundBlur"
})), /*#__PURE__*/React.createElement("filter", {
  id: "bmfilter18_f",
  x: 413.076,
  y: 259.779,
  width: 66.971,
  height: 67.023,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 8,
  result: "effect1_foregroundBlur"
})), /*#__PURE__*/React.createElement("filter", {
  id: "bmfilter19_f",
  x: 413.076,
  y: 317.543,
  width: 66.971,
  height: 66.974,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 8,
  result: "effect1_foregroundBlur"
})), /*#__PURE__*/React.createElement("filter", {
  id: "bmfilter20_f",
  x: 595.17,
  y: 397.613,
  width: 40.015,
  height: 71.389,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 8,
  result: "effect1_foregroundBlur"
})), /*#__PURE__*/React.createElement("filter", {
  id: "bmfilter21_f",
  x: 619.676,
  y: 411.762,
  width: 40.022,
  height: 71.396,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 8,
  result: "effect1_foregroundBlur"
})), /*#__PURE__*/React.createElement("filter", {
  id: "bmfilter22_f",
  x: 644.188,
  y: 425.916,
  width: 40.022,
  height: 71.396,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 8,
  result: "effect1_foregroundBlur"
})), /*#__PURE__*/React.createElement("filter", {
  id: "bmfilter23_f",
  x: 668.697,
  y: 440.072,
  width: 40.015,
  height: 71.389,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 8,
  result: "effect1_foregroundBlur"
})), /*#__PURE__*/React.createElement("filter", {
  id: "bmfilter24_f",
  x: 546.057,
  y: 343.334,
  width: 73.532,
  height: 231.054,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 7,
  result: "effect1_foregroundBlur"
})), /*#__PURE__*/React.createElement("filter", {
  id: "bmfilter25_f",
  x: 432.514,
  y: 395.99,
  width: 66.971,
  height: 67.245,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 8,
  result: "effect1_foregroundBlur"
})), /*#__PURE__*/React.createElement("filter", {
  id: "bmfilter26_f",
  x: 432.514,
  y: 453.779,
  width: 66.971,
  height: 67.023,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 8,
  result: "effect1_foregroundBlur"
})), /*#__PURE__*/React.createElement("filter", {
  id: "bmfilter27_f",
  x: 432.514,
  y: 511.543,
  width: 66.971,
  height: 66.974,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 8,
  result: "effect1_foregroundBlur"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bmpaint0_linear",
  x1: 844.991,
  y1: 495.003,
  x2: -29,
  y2: 495.003,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F2F2F2"
}))));

var _ref41 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 18 17",
  id: "icon-compare",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.864.708H.98C.439.708 0 1.198 0 1.803v9.852c0 .605.439 1.095.98 1.095h5.884c.541 0 .98-.49.98-1.095V1.803c0-.605-.439-1.095-.98-1.095zM1.207 11.412V2.046h5.43v9.366h-5.43zM16.072 4.25H10.19c-.542 0-.98.47-.98 1.052v9.466c0 .58.438 1.051.98 1.051h5.883c.542 0 .98-.47.98-1.051V5.302c0-.581-.438-1.052-.98-1.052zm-5.657 10.284V5.535h5.43v8.999h-5.43z",
  fill: "currentColor"
}));

var _ref42 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 19 19",
  id: "icon-compass",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M.792 9.5a8.708 8.708 0 1017.416 0 8.708 8.708 0 00-17.416 0zm15.833 0a7.125 7.125 0 11-14.25 0 7.125 7.125 0 0114.25 0z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.709 11.71l2.21-6.628L7.29 7.29l-2.21 6.627 6.628-2.209zm-1.252-1.253l-2.872.957.958-2.872 2.872-.957-.957 2.872z",
  fill: "#6E6"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.081 13.919l6.628-2.21-1.252-1.252-2.872.958.957-2.872L7.291 7.29 5.08 13.92z",
  fill: "#000"
}));

var _ref43 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 13 13",
  id: "icon-copy",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.688.813h4.875c.936 0 1.624.688 1.624 1.625v4.874c0 .937-.688 1.625-1.624 1.625H8.937v1.626c0 .936-.688 1.624-1.624 1.624H2.438c-.937 0-1.626-.688-1.626-1.624V5.686c0-.936.69-1.625 1.625-1.625h1.626V2.438c0-.936.688-1.624 1.625-1.624zM4.063 5.688H2.438v4.875h4.874V8.937H5.688c-.936 0-1.625-.688-1.625-1.624V5.688zm1.625-3.25v4.874h4.875V2.438H5.686z",
  fill: "currentColor"
}));

var _ref44 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 18 19",
  id: "icon-cube",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.256.5V9.06h-.514V.5h.514z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.567.324h.867v8.91h-.867V.324zm.353.352v8.206h.16V.676h-.16z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.708 4.557l7.42 4.28-.256.444-7.42-4.279.256-.445z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.645 4.316l7.726 4.456-.433.75-7.726-4.455.433-.75zm.13.482l-.081.14L8.809 9.04l.08-.139-7.115-4.103z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.451 13.12l7.42-4.283.258.444-7.42 4.285-.258-.445z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.938 8.596l.434.75-7.727 4.46-.433-.75 7.726-4.46zm-7.244 4.59l.08.139L8.89 9.217l-.081-.14-7.115 4.108z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.742 17.62V9.058h.514v8.564h-.514z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.567 8.882h.867v8.916h-.867V8.882zm.353.353v8.21h.16v-8.21h-.16z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.288 13.566L8.872 9.28l.257-.444 7.416 4.284-.257.444z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.065 8.596l7.72 4.46-.433.75-7.721-4.46.434-.75zm.129.482l-.081.139 7.11 4.107.08-.139-7.11-4.107z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.544 5.002L9.13 9.282l-.257-.446 7.416-4.279.256.445z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.352 4.316l.433.75-7.72 4.456-.434-.75 7.721-4.456zM9.113 8.901l.08.14 7.11-4.103-.08-.14-7.11 4.103z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.999.204L16.67 4.63v8.86L9 17.918 1.32 13.491v-8.86L9 .204zM1.835 4.928v8.266L9 17.325l7.158-4.13V4.927L9 .797l-7.164 4.13z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9 0l7.849 4.53v9.063L9 18.122l-7.854-4.53V4.53L9 0zM1.5 4.733v8.656L9 17.714l7.496-4.325V4.733L9 .407 1.5 4.733zM9 .593l7.335 4.233v8.47L9 17.529l-7.34-4.233v-8.47L9 .593zM2.013 5.03v8.063L9 17.122l6.982-4.03V5.03L9 1 2.013 5.03z",
  fill: "currentColor"
}));

var _ref45 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 11 13",
  id: "icon-custom-trash",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.6 1.97c0-.653-.492-1.182-1.1-1.182-.608 0-1.1.529-1.1 1.182h-.733C3.667.882 4.487 0 5.5 0s1.833.882 1.833 1.97h3.3c.203 0 .367.176.367.394 0 .217-.164.394-.367.394h-.406l-.95 8.847C9.19 12.4 8.565 13 7.82 13H3.18c-.745 0-1.371-.6-1.457-1.395l-.95-8.847H.366c-.18 0-.33-.14-.361-.324L0 2.364c0-.218.164-.394.367-.394H6.6zm2.888.788H1.51l.94 8.757c.044.397.357.697.73.697H7.82c.372 0 .685-.3.728-.697l.94-8.757zM4.4 4.728c.18 0 .33.121.36.282l.007.062v4.826c0 .19-.165.344-.367.344a.361.361 0 01-.36-.282l-.007-.062V5.072c0-.19.164-.345.367-.345zm2.2 0c.18 0 .33.121.36.282l.007.062v4.826c0 .19-.164.344-.367.344a.361.361 0 01-.36-.282l-.007-.062V5.072c0-.19.165-.345.367-.345z",
  fill: "currentColor"
}));

var _ref46 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 32 32",
  id: "icon-deployment",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17 7.004v8.998h-2V7.004h2z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.707 10.637l7.793 4.499-1 1.732-7.793-4.5 1-1.731z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.707 19.632l7.792-4.5 1 1.733-7.792 4.499-1-1.732z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15 24.998V16h2v8.998h-2z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.292 21.364l-7.792-4.5 1-1.731 7.793 4.499-1 1.732z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.293 12.369L16.5 16.868l-1-1.732 7.792-4.5 1 1.733z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16 2C8.268 2 2 8.268 2 16s6.268 14 14 14 14-6.268 14-14S23.732 2 16 2zM0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16z",
  fill: "currentColor"
}));

var _ref47 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 15 15",
  id: "icon-dollar-in-circle",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.5 15a7.45 7.45 0 01-5.303-2.197A7.45 7.45 0 010 7.5c0-2.003.78-3.887 2.197-5.303A7.45 7.45 0 017.5 0a7.45 7.45 0 015.303 2.197A7.45 7.45 0 0115 7.5a7.45 7.45 0 01-2.197 5.303A7.45 7.45 0 017.5 15zM7.5.937A6.57 6.57 0 00.937 7.5 6.57 6.57 0 007.5 14.063 6.57 6.57 0 0014.063 7.5 6.57 6.57 0 007.5.937z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.5 7.031A1.173 1.173 0 016.328 5.86c0-.646.526-1.171 1.172-1.171.646 0 1.172.525 1.172 1.171a.469.469 0 00.937 0 2.113 2.113 0 00-1.64-2.056v-.522a.469.469 0 10-.938 0v.522a2.113 2.113 0 00-1.64 2.056c0 1.163.946 2.11 2.109 2.11.646 0 1.172.525 1.172 1.172 0 .646-.526 1.171-1.172 1.171a1.173 1.173 0 01-1.172-1.171.469.469 0 00-.937 0c0 1.002.702 1.842 1.64 2.056v.522a.469.469 0 00.938 0v-.522a2.113 2.113 0 001.64-2.056c0-1.163-.946-2.11-2.109-2.11z",
  fill: "currentColor"
}));

var _ref48 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 24 24",
  id: "icon-download",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.293 9.293L13 12.586V2h-2v10.586L7.707 9.293l-1.414 1.414L12 16.414l5.707-5.707-1.414-1.414zM22 20v-4h-2v4H4v-4H2v4a2 2 0 002 2h16a2 2 0 002-2z",
  fill: "currentColor"
}));

var _ref49 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 10 10",
  id: "icon-drag",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("circle", {
  transform: "matrix(-1 0 0 1 5 1.333)",
  fill: "currentColor",
  r: 0.917
}), /*#__PURE__*/React.createElement("circle", {
  r: 0.917,
  transform: "matrix(-1 0 0 1 8.667 1.333)",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("circle", {
  transform: "matrix(-1 0 0 1 3.167 3.167)",
  fill: "currentColor",
  r: 0.917
}), /*#__PURE__*/React.createElement("circle", {
  transform: "matrix(-1 0 0 1 1.333 1.333)",
  fill: "currentColor",
  r: 0.917
}), /*#__PURE__*/React.createElement("circle", {
  transform: "matrix(-1 0 0 1 8.667 5)",
  fill: "currentColor",
  r: 0.917
}), /*#__PURE__*/React.createElement("circle", {
  r: 0.917,
  transform: "matrix(-1 0 0 1 6.833 6.833)",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("circle", {
  transform: "matrix(-1 0 0 1 8.667 8.667)",
  fill: "currentColor",
  r: 0.917
}), /*#__PURE__*/React.createElement("circle", {
  transform: "matrix(-1 0 0 1 6.833 3.167)",
  fill: "currentColor",
  r: 0.917
}), /*#__PURE__*/React.createElement("circle", {
  transform: "matrix(-1 0 0 1 5 5)",
  fill: "currentColor",
  r: 0.917
}));

var _ref50 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 13 13",
  id: "icon-duplicate",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.063 9.75v1.219c0 1.122.909 2.031 2.03 2.031h4.876C12.09 13 13 12.09 13 10.969V6.094c0-1.122-.91-2.032-2.031-2.032H9.75v.813h1.219c.673 0 1.219.546 1.219 1.219v4.875c0 .673-.546 1.219-1.22 1.219H6.095a1.219 1.219 0 01-1.219-1.22V9.75h-.813z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 2.031C0 .91.91 0 2.031 0h4.875c1.122 0 2.032.91 2.032 2.031v4.875c0 1.122-.91 2.032-2.032 2.032H2.031A2.031 2.031 0 010 6.905V2.031z",
  fill: "currentColor"
}));

var _ref51 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 122 55",
  id: "icon-effect-canary",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("rect", {
  opacity: 0.06,
  y: 54.238,
  width: 54.106,
  height: 56.27,
  rx: 4.317,
  transform: "rotate(-90 0 54.238)",
  fill: "#1641F7"
}), /*#__PURE__*/React.createElement("rect", {
  opacity: 0.1,
  x: 21.866,
  y: 54.4,
  width: 54.106,
  height: 56.27,
  rx: 4.317,
  transform: "rotate(-90 21.866 54.4)",
  fill: "#1641F7"
}), /*#__PURE__*/React.createElement("rect", {
  opacity: 0.3,
  x: 43.734,
  y: 54.561,
  width: 54.106,
  height: 56.27,
  rx: 4.317,
  transform: "rotate(-90 43.734 54.561)",
  fill: "#1641F7"
}), /*#__PURE__*/React.createElement("rect", {
  x: 65.6,
  y: 54.723,
  width: 54.106,
  height: 56.27,
  rx: 4.317,
  transform: "rotate(-90 65.6 54.723)",
  fill: "#1641F7"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M94.683 20.232v8.52h-1.894v-8.52h1.894z",
  fill: "#FBF9F9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M86.832 23.673l7.378 4.26-.947 1.64-7.378-4.26.947-1.64z",
  fill: "#FBF9F9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M85.885 32.192l7.378-4.26.947 1.64-7.378 4.26-.947-1.64z",
  fill: "#FBF9F9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M92.789 37.272v-8.52h1.894v8.52h-1.894z",
  fill: "#FBF9F9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M100.641 33.832l-7.379-4.26.947-1.64 7.378 4.26-.946 1.64z",
  fill: "#FBF9F9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M101.587 25.313l-7.378 4.26-.947-1.64 7.379-4.26.946 1.64z",
  fill: "#FBF9F9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M93.736 15.496c-7.321 0-13.256 5.935-13.256 13.256 0 7.321 5.935 13.256 13.256 13.256 7.321 0 13.256-5.935 13.256-13.256 0-7.32-5.935-13.256-13.256-13.256zm-15.15 13.256c0-8.367 6.783-15.15 15.15-15.15s15.149 6.783 15.149 15.15-6.782 15.15-15.15 15.15c-8.366 0-15.149-6.783-15.149-15.15z",
  fill: "#FBF9F9"
}));

var _ref52 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 18 14",
  id: "icon-email",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.853 1.674l-5.156 5.122 5.156 5.123c.093-.195.15-.41.15-.64V2.314c0-.23-.057-.445-.15-.64zM15.505.82H1.494c-.23 0-.446.057-.64.15l6.589 6.556c.583.583 1.53.583 2.113 0L16.146.97a1.477 1.477 0 00-.641-.15zM.15 1.674c-.093.195-.15.41-.15.64v8.965c0 .23.057.445.15.64l5.155-5.123L.15 1.674z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.99 7.501l-.73.73c-.97.97-2.55.97-3.521 0l-.73-.73-5.155 5.122c.194.094.41.15.64.15h14.011c.23 0 .445-.056.64-.15L10.99 7.501z",
  fill: "currentColor"
}));

var _ref53 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 16 17",
  id: "icon-embed",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.56 6.5L4 5.844l-.56-.576L0 8.804l3.44 3.455 1.12-1.152-2.24-2.303L4.56 6.5zM12 5.843l-.56.658 2.24 2.303-2.24 2.303 1.12 1.152 2.72-2.797.72-.658-3.44-3.537-.56.576zM5.63 14.354l1.538.451L10.37 3.256l-1.538-.45-3.204 11.548z",
  fill: "currentColor"
}));

var _ref54 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 27 27",
  id: "icon-energy-bought",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("rect", {
  width: 27,
  height: 27,
  rx: 5,
  fill: "#FC1355"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.5 22.5L18 18H9l4.5 4.5z",
  fill: "#FBF9F9",
  opacity: 0.7
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.5 10.5L18 6H9l4.5 4.5z",
  fill: "#FBF9F9",
  opacity: 0.5
}));

var _ref55 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 27 27",
  id: "icon-energy-sold",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("rect", {
  width: 27,
  height: 27,
  rx: 5,
  fill: "#6E6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.5 4.5L18 9H9l4.5-4.5z",
  fill: "#FBF9F9",
  opacity: 0.7
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.5 16.5L18 21H9l4.5-4.5z",
  fill: "#FBF9F9",
  opacity: 0.5
}));

var _ref56 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 30 30",
  id: "icon-equality",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.07.5h6.004a.83.83 0 01.83.83l-.01 5.115h.01v.5a.83.83 0 01-1.493.5h-.179l.009-4.112-4.683 4.675a8.725 8.725 0 011.722 5.213c0 4.832-3.924 8.757-8.757 8.757a8.712 8.712 0 01-3.633-.794 8.713 8.713 0 01-2.803.75v2.676h2.803a.83.83 0 010 1.661h-2.803v2.803a.83.83 0 01-1.66 0V26.27H5.624a.83.83 0 010-1.66h2.803v-2.676C3.984 21.515.5 17.773.5 13.22c0-4.833 3.924-8.757 8.757-8.757 1.296 0 2.527.287 3.633.793a8.714 8.714 0 013.633-.793c2.282 0 4.361.875 5.92 2.306l4.617-4.609h-3.601a.83.83 0 01-.417-1.548L23.071.5zM11.078 6.36a7.105 7.105 0 00-1.783-.236h-.037a7.091 7.091 0 00-7.096 7.097 7.091 7.091 0 007.096 7.096c.629 0 1.24-.083 1.82-.236a8.747 8.747 0 01-3.31-6.86 8.746 8.746 0 013.31-6.86zm3.626 13.72a7.091 7.091 0 008.916-6.86 7.091 7.091 0 00-8.916-6.86 8.746 8.746 0 013.311 6.86 8.746 8.746 0 01-3.31 6.86zm14.54-13.135h.15-.15zm-16.353.184a7.08 7.08 0 00-3.463 6.092 7.08 7.08 0 003.463 6.091 7.08 7.08 0 003.463-6.091 7.08 7.08 0 00-3.463-6.092z",
  fill: "#fff"
}));

var _ref57 = /*#__PURE__*/React.createElement("symbol", {
  viewBox: "0 0 384 384",
  id: "icon-euro",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M256 330.667c-53.44 0-99.84-30.293-122.987-74.667H256v-42.667H119.147c-1.067-6.933-1.813-14.08-1.813-21.333s.747-14.4 1.813-21.333H256V128H133.013C156.16 83.627 202.453 53.333 256 53.333c34.453 0 65.92 12.587 90.133 33.387L384 49.067C350.08 18.667 305.173 0 256 0 172.48 0 101.547 53.44 75.2 128H0v42.667h65.28C64.427 177.707 64 184.747 64 192s.427 14.293 1.28 21.333H0V256h75.2c26.347 74.56 97.28 128 180.8 128 49.173 0 94.08-18.667 128-49.067l-37.867-37.76c-24.213 20.8-55.68 33.494-90.133 33.494z",
  fill: "currentColor"
}));

var _ref58 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 32 32",
  id: "icon-evolution",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.948 2.384l-.565.565 8.889 8.89.566-.566-8.89-8.89z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M.969 2.95L2.949.97l10.303 10.303-1.98 1.98L.97 2.948zm1.414 0l.566-.566 8.889 8.889-.566.565L2.383 2.95z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.726 20.16l-.566.567 8.89 8.889.565-.566-8.89-8.89z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.746 20.727l1.98-1.98L31.029 29.05l-1.98 1.98-10.303-10.303zm1.414 0l.566-.566 8.89 8.889-.567.566-8.889-8.89z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.272 20.162l-8.89 8.889.566.566 8.89-8.89-.566-.565z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M.969 29.05l10.303-10.303 1.98 1.98L2.949 31.031l-1.98-1.98zm10.303-8.888L2.383 29.05l.566.566 8.889-8.89-.566-.565z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.05 2.384l-8.89 8.89.566.565 8.889-8.889-.566-.566z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.746 11.273L29.05.97l1.98 1.98-10.303 10.303-1.98-1.98zM29.05 2.384l-8.889 8.89.566.565 8.89-8.889-.567-.566z",
  fill: "currentColor"
}));

var _ref59 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 29 29",
  id: "icon-exchanges",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.497 5.4c2.723 0 5.059 1.227 6.607 3.413h-4.331v2.275h7.963V3.125h-2.275v3.72c-1.963-2.375-4.773-3.72-7.964-3.72-6.283 0-11.376 5.093-11.376 11.376h2.275a9.101 9.101 0 019.101-9.1zm0 18.202c-2.723 0-5.058-1.227-6.606-3.413h4.331v-2.275H4.26v7.963h2.275v-3.72c1.962 2.375 4.773 3.72 7.963 3.72 6.283 0 11.377-5.093 11.377-11.376h-2.276a9.101 9.101 0 01-9.1 9.101z",
  fill: "currentColor"
}));

var _ref60 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 10 15",
  id: "icon-expand",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 .018h10v10H0z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 10,
  height: 2,
  rx: 1,
  y: 13,
  fill: "currentColor"
}));

var _ref61 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 13 13",
  id: "icon-expand-2",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.744 5.246l2.625-2.601v2.173h1.223V.576h-4.28v1.212h2.192L7.879 4.389l.865.857zm2.625 1.39v4.848H6.476v1.212h6.116v-6.06h-1.223zM1.584 1.788v4.848H.36V.576h6.115v1.212H1.584zM4.64 12.696v-1.212H2.448l2.626-2.602-.865-.857-2.626 2.602V8.454H.36v4.242h4.281z",
  fill: "currentColor"
}));

var _ref62 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 11 7",
  id: "icon-eye",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.498 6.587c1.25 0 2.446-.552 3.56-1.46.38-.309.724-.639 1.027-.97.182-.199.312-.356.383-.45l.158-.207-.158-.208c-.071-.093-.2-.25-.383-.45a9.723 9.723 0 00-1.027-.97C7.944.965 6.748.413 5.498.413s-2.445.552-3.56 1.459c-.38.31-.723.64-1.026.97-.182.2-.312.357-.383.45L.371 3.5l.158.208c.071.093.2.25.383.45.303.33.647.66 1.027.97 1.114.907 2.31 1.459 3.56 1.459zm3.86-2.9a8.898 8.898 0 01-.937.886c-.96.781-1.957 1.242-2.922 1.242-.965 0-1.963-.46-2.923-1.242A8.898 8.898 0 011.473 3.5a8.898 8.898 0 011.104-1.073c.959-.781 1.957-1.242 2.922-1.242.965 0 1.963.46 2.922 1.242A8.898 8.898 0 019.525 3.5c-.05.059-.106.121-.166.186zM3.666 3.5c0-.852.82-1.544 1.833-1.544s1.834.692 1.834 1.544c0 .852-.821 1.543-1.834 1.543-1.012 0-1.833-.69-1.833-1.543zm2.751 0c0-.426-.41-.772-.917-.772-.506 0-.916.346-.916.772 0 .426.41.772.916.772.507 0 .917-.346.917-.772z",
  fill: "currentColor"
}));

var _ref63 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 11 9",
  id: "icon-eye-closed",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.241 8.632l-.648-.546 1.863-1.569a8.716 8.716 0 01-.515-.39c-.38-.309-.724-.639-1.027-.97a6.897 6.897 0 01-.383-.45L.373 4.5l.158-.208c.071-.093.2-.25.383-.45.303-.33.647-.66 1.027-.97 1.114-.907 2.31-1.459 3.56-1.459.788 0 1.555.22 2.294.61L9.76.368l.648.546L1.24 8.632zm5.884-6.046l-.693.584a2.092 2.092 0 00-.932-.214c-1.012 0-1.833.692-1.833 1.544 0 .286.093.554.254.784l-.813.685a7.615 7.615 0 01-.53-.396A8.9 8.9 0 011.475 4.5a8.898 8.898 0 011.104-1.073c.959-.781 1.957-1.242 2.921-1.242.536 0 1.081.142 1.625.401zM4.615 4.7a.659.659 0 01-.031-.2c0-.426.41-.772.916-.772.083 0 .162.01.238.026L4.615 4.7zm4.597-1.701l-.648.545a8.962 8.962 0 01.962.956 8.898 8.898 0 01-1.104 1.073c-.959.781-1.957 1.242-2.922 1.242-.239 0-.48-.028-.723-.083l-.725.61c.473.16.957.245 1.448.245 1.25 0 2.446-.552 3.56-1.46.38-.309.724-.639 1.027-.97.182-.199.312-.356.383-.45l.158-.207-.158-.208a6.91 6.91 0 00-.383-.45A9.785 9.785 0 009.212 3z",
  fill: "currentColor"
}));

var _ref64 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 24 24",
  id: "icon-eye-no",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.707 1.293L1.293 2.707l4.065 4.065c-.379.314-.754.65-1.124 1.01-.83.801-1.58 1.657-2.24 2.514-.399.516-.681.923-.836 1.165L.813 12l.345.539c.155.242.437.649.836 1.165.66.857 1.41 1.713 2.24 2.515C6.664 18.569 9.272 20 12 20c1.72 0 3.394-.57 5.006-1.58l4.287 4.287 1.414-1.414-20-20zm12.838 15.666l-1.513-1.513a4 4 0 01-5.478-5.478L6.78 8.194c-.388.312-.773.655-1.156 1.025A21.334 21.334 0 003.216 12a21.328 21.328 0 002.408 2.781C7.718 16.806 9.895 18 12 18c1.168 0 2.359-.368 3.545-1.041zm-5.477-5.477a2.002 2.002 0 002.45 2.45l-2.45-2.45zm10.03 4.409l-1.414-1.414a21.608 21.608 0 002.1-2.477 21.34 21.34 0 00-2.408-2.781C16.282 7.194 14.106 6 12 6c-.522 0-1.049.073-1.578.215L8.84 4.633C9.873 4.221 10.927 4 12 4c2.728 0 5.336 1.43 7.766 3.781.83.802 1.58 1.658 2.24 2.515.399.516.681.923.837 1.165l.344.539-.345.539c-.154.242-.437.649-.836 1.165a23.57 23.57 0 01-1.908 2.187z",
  fill: "#000"
}));

var _ref65 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 49 38",
  id: "icon-facade-pv",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clclip0_5463_339989)"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#clfilter0_d_5463_339989)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.466 32.738l-14.16-7.573 13.816-7.047 14.572 7.31-14.228 7.31z",
  fill: "#D8D8D8",
  fillOpacity: 0.07,
  shapeRendering: "crispEdges"
})), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.569 32.745l-.166-15.17 14.291-7.342v15.316L24.57 32.745z",
  fill: "url(#clpaint0_linear_5463_339989)"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#clfilter1_d_5463_339989)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.466 17.543L10.306 9.97v15.318l14.27 7.453-.11-15.198z",
  fill: "url(#clpaint1_linear_5463_339989)"
})), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.5 3.215L10.374 9.952 24.5 17.54l14.194-6.935L24.5 3.215z",
  fill: "#4B464B"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "clpaint0_linear_5463_339989",
  x1: 24.673,
  y1: 32.745,
  x2: 31.504,
  y2: 8.47,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#211E21"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#211E21",
  stopOpacity: 0.94
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "clpaint1_linear_5463_339989",
  x1: 34.125,
  y1: 7.963,
  x2: 12.644,
  y2: 9.076,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#6E6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#87FC87"
})), /*#__PURE__*/React.createElement("filter", {
  id: "clfilter0_d_5463_339989",
  x: 6.306,
  y: 18.118,
  width: 36.388,
  height: 22.62,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_5463_339989"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_5463_339989",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "clfilter1_d_5463_339989",
  x: 4.306,
  y: 3.97,
  width: 26.27,
  height: 34.771,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.4 0 0 0 0 0.933333 0 0 0 0 0.4 0 0 0 0.6 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_5463_339989"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_5463_339989",
  result: "shape"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clclip0_5463_339989"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h49v38H0z"
}))));

var _ref66 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 39 35",
  id: "icon-facade-pv-white",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#cmfilter0_d_6538_144455)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.465 29.738l-14.16-7.573 13.817-7.047 14.572 7.31-14.229 7.31z",
  fill: "#D8D8D8",
  fillOpacity: 0.07,
  shapeRendering: "crispEdges"
})), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.569 29.745l-.166-15.17 14.291-7.342V22.55L20.57 29.745z",
  fill: "url(#cmpaint0_linear_6538_144455)"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#cmfilter1_d_6538_144455)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.465 14.543L6.305 6.97v15.318l14.27 7.453-.11-15.198z",
  fill: "url(#cmpaint1_linear_6538_144455)"
})), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.5.215L6.374 6.952 20.5 14.54l14.194-6.935L20.5.215z",
  fill: "#FBF9F9"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "cmpaint0_linear_6538_144455",
  x1: 21.672,
  y1: 8.411,
  x2: 37.454,
  y2: 12.152,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EAEAEA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.605,
  stopColor: "#D3D3DB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B6B6C4"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "cmpaint1_linear_6538_144455",
  x1: 30.125,
  y1: 4.963,
  x2: 8.643,
  y2: 6.077,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#6E6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#87FC87"
})), /*#__PURE__*/React.createElement("filter", {
  id: "cmfilter0_d_6538_144455",
  x: 2.306,
  y: 15.118,
  width: 36.388,
  height: 22.62,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_6538_144455"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_6538_144455",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "cmfilter1_d_6538_144455",
  x: 0.306,
  y: 0.97,
  width: 26.27,
  height: 34.771,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.4 0 0 0 0 0.933333 0 0 0 0 0.4 0 0 0 0.6 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_6538_144455"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_6538_144455",
  result: "shape"
}))));

var _ref67 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 8 14",
  id: "icon-facebook-button",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.786 2.703H7.03V.604A16.596 16.596 0 005.217.511c-3.938 0-2.867 4.318-3.024 4.95H.213v2.347h1.98v5.904H4.62V7.809h1.9l.302-2.347H4.62c.107-1.553-.432-2.759 1.166-2.759z",
  fill: "currentColor"
}));

var _ref68 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 24 25",
  id: "icon-factory",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M24 23.905l-3.514-9.18V9.105h-7.771v5.618l-3.513 9.18H24z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.756 24.013l-4.367-11.06V5.675H4.293v7.276L0 24.013h17.756z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M7.786 2.62h6.622c.728 0 1.31-.582 1.31-1.31 0-.728-.582-1.31-1.31-1.31H7.786c-.728 0-1.31.582-1.31 1.31v2.91l1.31-1.6z",
  fill: "currentColor"
}));

var _ref69 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 7 11",
  id: "icon-fb",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.473 2.14H6.5V.45A14.03 14.03 0 005.004.375c-3.25 0-2.365 3.475-2.495 3.984H.875v1.889h1.634V11h2.003V6.248H6.08l.249-1.888H4.512c.088-1.25-.357-2.22.961-2.22z",
  fill: "#FBF9F9"
}));

var _ref70 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 110 110",
  id: "icon-file",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#cqpattern0)",
  d: "M0 0h110v110H0z"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
  id: "cqpattern0",
  patternContentUnits: "objectBoundingBox",
  width: 1,
  height: 1
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#cqimage0_5329_308",
  transform: "scale(.002)"
})), /*#__PURE__*/React.createElement("image", {
  id: "cqimage0_5329_308",
  width: 500,
  height: 500,
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  xlinkHref: "data:image/png;base64,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"
})));

var _ref71 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 14 18",
  id: "icon-file-upload",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.56.75H1.75a1.5 1.5 0 00-1.5 1.5v13.5a1.5 1.5 0 001.5 1.5h10.5a1.5 1.5 0 001.5-1.5V4.94L9.56.75zm-7.81 1.5h6v3a1.5 1.5 0 001.5 1.5h3v9H1.75V2.25zm7.5 3V2.56l2.69 2.69H9.25zm-1.5 8.25v-3.44l.97.97 1.06-1.06L7 7.19 4.22 9.97l1.06 1.06.97-.97v3.44h1.5z",
  fill: "#1641F7"
}));

var _ref72 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 18 11",
  id: "icon-filter",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.807 4.702v1.774H2.77V4.702h12.038zM17.387.266V2.04H.19V.266h17.198zM12.228 9.138v1.774h-6.02V9.138h6.02z",
  fill: "#6E6"
}));

var _ref73 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 39 43",
  id: "icon-flat-pv",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ctclip0_5463_339886)"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#ctfilter0_d_5463_339886)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.462 37.046l-15.496-8.57 15.12-7.974 15.948 8.272-15.572 8.272z",
  fill: "#D8D8D8",
  fillOpacity: 0.07,
  shapeRendering: "crispEdges"
})), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.575 37.053l-.181-17.165 15.64-8.308v17.33l-15.459 8.143z",
  fill: "url(#ctpaint0_linear_5463_339886)"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#ctfilter1_d_5463_339886)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.462 19.852l-15.496-8.57 15.12-7.974 15.948 8.272-15.572 8.272z",
  fill: "url(#ctpaint1_linear_5463_339886)"
})), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.041 28.656V11.262L19.5 19.847l.075 17.17-15.534-8.36z",
  fill: "#4B464B"
}), /*#__PURE__*/React.createElement("g", {
  opacity: 0.5,
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#000"
}, /*#__PURE__*/React.createElement("path", {
  d: "M32.06 10.235l-14.527 8.288-.016-.028 14.526-8.289.016.029zM29.982 9.195l-14.526 8.288-.016-.028 14.526-8.288.016.028zM28.424 8.155l-14.526 8.289-.017-.028 14.526-8.289.017.028zM26.346 7.116L12.34 15.404l-.016-.028 14.008-8.288.015.028zM24.788 6.076l-14.526 8.289-.016-.028 14.526-8.289.016.028zM23.23 5.037L8.704 13.325l-.016-.028L23.214 5.01l.016.028zM21.152 3.997L6.627 12.286l-.016-.028 14.526-8.289.017.028z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.61 10.235l14.526 8.288.017-.028-14.527-8.289-.016.029zM8.688 9.195l14.526 8.288.016-.028L8.704 9.167l-.016.028zM10.246 8.155l14.526 8.289.016-.028-14.526-8.289-.016.028zM12.323 7.116l14.008 8.288.015-.028L12.34 7.088l-.016.028zM13.881 6.076l14.526 8.289.017-.028-14.526-8.289-.017.028zM15.44 5.037l14.526 8.288.016-.028L15.456 5.01l-.016.028zM17.517 3.997l14.526 8.289.016-.028-14.526-8.289-.016.028z"
}))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "ctpaint0_linear_5463_339886",
  x1: 19.689,
  y1: 37.053,
  x2: 27.641,
  y2: 9.724,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#211E21"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#211E21",
  stopOpacity: 0.94
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ctpaint1_linear_5463_339886",
  x1: 30.033,
  y1: 9.011,
  x2: 6.52,
  y2: 10.19,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#6E6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#87FC87"
})), /*#__PURE__*/React.createElement("filter", {
  id: "ctfilter0_d_5463_339886",
  x: 1.505,
  y: 20.502,
  width: 35.991,
  height: 21.467,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2.462
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.231
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_5463_339886"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_5463_339886",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "ctfilter1_d_5463_339886",
  x: 0.274,
  y: -0.385,
  width: 38.452,
  height: 23.928,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.846
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.4 0 0 0 0 0.933333 0 0 0 0 0.4 0 0 0 0.6 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_5463_339886"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_5463_339886",
  result: "shape"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "ctclip0_5463_339886"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h39v43H0z"
}))));

var _ref74 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 39 43",
  id: "icon-flat-pv-white",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#cuclip0_6538_144394)"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#cufilter0_d_6538_144394)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.462 37.046l-15.496-8.57 15.12-7.974 15.948 8.272-15.572 8.272z",
  fill: "#D8D8D8",
  fillOpacity: 0.07,
  shapeRendering: "crispEdges"
})), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.575 37.053l-.182-17.165 15.64-8.308v17.33l-15.459 8.143z",
  fill: "url(#cupaint0_linear_6538_144394)"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#cufilter1_d_6538_144394)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.462 19.852l-15.496-8.57 15.12-7.974 15.948 8.272-15.572 8.272z",
  fill: "url(#cupaint1_linear_6538_144394)"
})), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.041 28.656V11.262L19.5 19.847l.075 17.17-15.534-8.36z",
  fill: "#FBF9F9"
}), /*#__PURE__*/React.createElement("g", {
  opacity: 0.5,
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#000"
}, /*#__PURE__*/React.createElement("path", {
  d: "M32.06 10.235l-14.527 8.288-.016-.028 14.526-8.288.017.028zM29.982 9.195l-14.526 8.288-.016-.027 14.526-8.289.016.028zM28.424 8.156l-14.526 8.288-.017-.028 14.526-8.289.017.029zM26.346 7.116L12.34 15.404l-.016-.028 14.008-8.288.015.028zM24.788 6.076l-14.526 8.289-.016-.028 14.526-8.289.017.028zM23.23 5.037L8.704 13.325l-.016-.028L23.214 5.01l.016.028zM21.153 3.997L6.627 12.286l-.017-.028 14.527-8.289.016.028z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.61 10.235l14.527 8.288.016-.028-14.526-8.288-.017.028zM8.688 9.195l14.526 8.288.016-.027L8.704 9.167l-.016.028zM10.246 8.156l14.526 8.288.016-.028-14.526-8.289-.016.029zM12.324 7.116l14.007 8.288.016-.028-14.008-8.288-.015.028zM13.882 6.076l14.526 8.289.016-.028-14.526-8.289-.016.028zM15.44 5.037l14.526 8.288.016-.028L15.456 5.01l-.016.028zM17.517 3.997l14.526 8.289.017-.028-14.527-8.289-.016.028z"
}))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "cupaint0_linear_6538_144394",
  x1: 20.782,
  y1: 12.912,
  x2: 38.113,
  y2: 16.886,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EAEAEA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.605,
  stopColor: "#D3D3DB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B6B6C4"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "cupaint1_linear_6538_144394",
  x1: 30.033,
  y1: 9.01,
  x2: 6.52,
  y2: 10.19,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#6E6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#87FC87"
})), /*#__PURE__*/React.createElement("filter", {
  id: "cufilter0_d_6538_144394",
  x: 1.504,
  y: 20.502,
  width: 35.991,
  height: 21.467,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2.462
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.231
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_6538_144394"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_6538_144394",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "cufilter1_d_6538_144394",
  x: 0.274,
  y: -0.385,
  width: 38.453,
  height: 23.928,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.846
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.4 0 0 0 0 0.933333 0 0 0 0 0.4 0 0 0 0.6 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_6538_144394"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_6538_144394",
  result: "shape"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "cuclip0_6538_144394"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h39v43H0z"
}))));

var _ref75 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 16 16",
  id: "icon-github",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.999.167C3.582.167 0 3.762 0 8.198a8.031 8.031 0 005.472 7.621c.4.074.546-.174.546-.387 0-.19-.007-.696-.011-1.366-2.225.486-2.695-1.077-2.695-1.077-.363-.928-.888-1.175-.888-1.175-.727-.498.054-.488.054-.488.803.057 1.225.829 1.225.829.714 1.227 1.873.873 2.329.667.072-.52.279-.873.508-1.074-1.776-.204-3.644-.893-3.644-3.97 0-.876.312-1.593.824-2.155-.083-.204-.357-1.02.078-2.126 0 0 .672-.216 2.2.824a7.633 7.633 0 012.003-.27 7.65 7.65 0 012.003.27c1.527-1.038 2.198-.822 2.198-.822.436 1.105.162 1.921.08 2.124.513.563.822 1.28.822 2.156 0 3.085-1.87 3.764-3.652 3.963.287.248.543.738.543 1.487 0 1.075-.01 1.94-.01 2.204 0 .215.144.465.55.386A8.032 8.032 0 0016 8.198C16 3.762 12.418.166 7.999.166z",
  fill: "currentColor"
}));

var _ref76 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 15 17",
  id: "icon-github-outline",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.96 14.715a1.12 1.12 0 01-.026.283c-.035.165-.104.34-.2.502a1.52 1.52 0 01-1.34.767c-1.413 0-1.968-.693-2.662-2.429-.47-1.176-.693-1.453-1.22-1.453v-1.553c1.412 0 1.967.693 2.661 2.43.47 1.175.693 1.452 1.22 1.452 0-.225-.002-.425-.009-.695-.015-.633-.017-.763.01-.932.012-.37.107-.632.299-.892-1.733-.377-2.902-1.157-3.573-2.42l-.251-.591C.624 8.48.51 7.683.51 6.762c0-1.06.324-2.008.927-2.801-.188-.753-.162-1.674.254-2.713l.136-.34.348-.111c.047-.015.103-.029.17-.04.679-.106 1.644.148 2.906.957a10.3 10.3 0 012.317-.26c.705 0 1.406.071 2.075.212 1.228-.77 2.167-1.01 2.828-.908.065.01.122.023.168.038l.35.111.136.342c.364.914.427 1.756.294 2.493.695.833 1.069 1.857 1.069 3.02 0 .98-.07 1.718-.273 2.436l-.213.585c-.558 1.262-1.789 2.05-3.686 2.425.197.273.289.55.289.953v1.553a.236.236 0 00.006.05l-.006 1.503c-.662 0-1.153-.322-1.395-.831a1.606 1.606 0 01-.158-.733v-1.542c0-.065-.002-.069-.16-.227-.425-.424-.617-.744-.617-1.326v-.702l.7-.07c2.08-.21 3.211-.787 3.586-1.631l.176-.48c.14-.5.197-1.11.197-1.963 0-.905-.316-1.653-.914-2.251l-.328-.329.134-.444a2.66 2.66 0 00.021-1.397 2.93 2.93 0 00-.065.018c-.416.116-.935.364-1.56.782l-.286.19-.333-.082a8.513 8.513 0 00-2.035-.242c-.777 0-1.546.1-2.255.293l-.347.094-.296-.203c-.647-.442-1.185-.705-1.616-.828a2.912 2.912 0 00-.088-.024c-.15.617-.09 1.125.062 1.505l.182.456-.334.36c-.532.575-.813 1.274-.813 2.102 0 .759.089 1.387.252 1.86l.203.481c.508.954 1.587 1.527 3.51 1.733l.694.075v.697c0 .582-.192.902-.615 1.326-.159.159-.161.162-.161.227l-.014.144c-.008.047-.008.169.004.677.005.234.009.419.01.612.009.04.01.066.013.121z",
  fill: "currentColor"
}));

var _ref77 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 24 24",
  id: "icon-globe",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1zm-8.934 9.907c.291.373 1.102.851 2.342 1.24.489.154 1.024.289 1.598.403A27.195 27.195 0 017 12c0-3.328.606-6.333 1.655-8.358a9.01 9.01 0 00-5.59 7.265zm4.063 3.704c-1.606-.28-2.983-.702-4.026-1.245a9.012 9.012 0 005.552 6.992c-.766-1.479-1.296-3.48-1.526-5.747zm2.05.266c.897.081 1.842.123 2.821.123.963 0 1.912-.055 2.825-.156C14.375 18.442 13.127 21 12 21c-1.123 0-2.367-2.543-2.821-6.123zm5.807-2.072c-.95.123-1.958.195-2.986.195a28.82 28.82 0 01-2.985-.15A23.58 23.58 0 019 12c0-5.016 1.594-9 3-9s3 3.984 3 9c0 .271-.005.54-.014.805zm1.893 1.722c-.225 2.302-.758 4.334-1.534 5.83a9.01 9.01 0 005.576-7.16c-1.06.55-2.456 1.012-4.042 1.33zm4.05-3.667c-.471.528-1.955 1.156-3.933 1.594.003-.15.004-.302.004-.454 0-3.328-.606-6.333-1.655-8.358a9.01 9.01 0 015.583 7.218z",
  fill: "currentColor"
}));

var _ref78 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 24 24",
  id: "icon-globe-no",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.547 4.96L1.293 2.708l1.414-1.414 20 20-1.414 1.414-2.254-2.254A10.956 10.956 0 0112 23C5.925 23 1 18.075 1 12c0-2.678.957-5.132 2.547-7.04zm14.07 14.072l-1.296-1.297c-.259.987-.587 1.872-.976 2.623.825-.33 1.59-.78 2.273-1.326zm-4.077-4.078l1.098 1.098C14.086 19 12.996 21 12 21c-1.123 0-2.367-2.543-2.821-6.123.897.081 1.842.123 2.821.123.518 0 1.033-.016 1.54-.046zm-1.957-1.957L9.05 10.464a23.415 23.415 0 00-.035 2.386c.813.085 1.674.135 2.568.147zM7.218 8.633a25.337 25.337 0 00-.212 3.917 15.421 15.421 0 01-1.598-.402c-1.24-.39-2.05-.867-2.342-1.24a8.958 8.958 0 011.902-4.526l2.25 2.25zm1.437-4.99c-.177.341-.342.71-.493 1.105L9.744 6.33C10.338 4.292 11.2 3 12 3c1.367 0 2.911 3.765 2.996 8.582l2.752 2.752c1.227-.3 2.311-.69 3.173-1.138a8.941 8.941 0 01-1.082 3.229l1.458 1.457A10.948 10.948 0 0023 12c0-6.075-4.925-11-11-11-2.164 0-4.181.625-5.882 1.703l1.457 1.458a8.96 8.96 0 011.08-.519zM7.129 14.61c-1.606-.28-2.983-.702-4.026-1.245a9.012 9.012 0 005.552 6.992c-.766-1.479-1.296-3.48-1.526-5.747zm13.8-3.75c-.471.527-1.955 1.155-3.933 1.593.003-.15.004-.302.004-.454 0-3.328-.606-6.333-1.655-8.358a9.01 9.01 0 015.583 7.218z",
  fill: "currentColor"
}));

var _ref79 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 15 15",
  id: "icon-gmail-button",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.078 11.766L7.65 8.641a.26.26 0 00-.301 0l-4.427 3.125a.26.26 0 00-.11.213v.26c0 .144.116.261.26.261h8.854a.26.26 0 00.26-.26v-.26a.26.26 0 00-.11-.214z",
  fill: "#FBF9F9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.65 8.641L3.224 5.516a.26.26 0 00-.41.213v6.25a.26.26 0 00.41.213l4.428-3.125a.26.26 0 000-.425z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.047 5.498a.264.264 0 00-.27.018L7.348 8.641a.26.26 0 000 .426l4.427 3.125a.26.26 0 00.411-.213V5.73a.26.26 0 00-.14-.231zM12.695 3.304a.26.26 0 00-.247-.179H2.552a.26.26 0 00-.156.469L7.344 7.24a.26.26 0 00.309 0L12.6 3.594a.26.26 0 00.094-.29z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.448 3.125a.26.26 0 00-.156.052L7.5 6.707l-4.792-3.53a.26.26 0 00-.156-.052c-.719 0-1.302.583-1.302 1.302v6.77c0 .72.583 1.303 1.302 1.303h.52a.26.26 0 00.261-.26V6.232L7.35 9.067a.26.26 0 00.301 0l4.017-2.835v6.008c0 .143.116.26.26.26h.52c.72 0 1.303-.583 1.303-1.302v-6.77c0-.72-.583-1.303-1.302-1.303z",
  fill: "#B43B32"
}));

var _ref80 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 12 12",
  id: "icon-google",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#daclip0_6831_34931)",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.868 7.173l-.391 1.461-1.432.03A5.6 5.6 0 01.375 6c0-.933.227-1.812.629-2.587l1.274.234.559 1.266a3.344 3.344 0 00.031 2.26zM11.527 4.95a5.631 5.631 0 01-2.005 5.437l-1.605-.083-.228-1.418a3.352 3.352 0 001.443-1.711H6.124V4.949H11.527z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.52 10.387h.001a5.624 5.624 0 01-8.476-1.72l1.823-1.493a3.345 3.345 0 004.82 1.713l1.833 1.5zM9.59 1.67L7.768 3.162a3.346 3.346 0 00-4.931 1.751l-1.833-1.5A5.624 5.624 0 019.59 1.67z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "daclip0_6831_34931"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(.375 .375)",
  d: "M0 0h11.25v11.25H0z"
}))));

var _ref81 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 15 15",
  id: "icon-google-button",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#dbclip0)",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.368 8.673l-.391 1.462-1.432.03a5.6 5.6 0 01-.67-2.665c0-.933.227-1.812.629-2.587l1.274.234.559 1.266a3.344 3.344 0 00.031 2.26zM13.027 6.45a5.631 5.631 0 01-2.005 5.437l-1.606-.083-.227-1.418a3.352 3.352 0 001.443-1.711H7.624V6.449H13.027z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.021 11.886a5.624 5.624 0 01-8.476-1.72l1.823-1.492a3.345 3.345 0 004.821 1.712l1.832 1.5zM11.09 3.17L9.268 4.662a3.346 3.346 0 00-4.931 1.751l-1.833-1.5A5.624 5.624 0 0111.09 3.17z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "dbclip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  transform: "translate(1.875 1.875)",
  d: "M0 0h11.25v11.25H0z"
}))));

var _ref82 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 24 24",
  id: "icon-grid",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20 2H4a2 2 0 00-2 2v16a2 2 0 002 2h16a2 2 0 002-2V4a2 2 0 00-2-2zM4 20v-7h7v7H4zm9 0h7v-7h-7v7zm0-9h7V4h-7v7zm-2-7H4v7h7V4z",
  fill: "currentColor"
}));

var _ref83 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 18 18",
  id: "icon-grid-market",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.281.64a8.517 8.517 0 016.176 4.364l-2.119.744a6.303 6.303 0 00-4.057-2.863V.639z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.042.361c.082-.07.19-.1.295-.084a8.884 8.884 0 016.443 4.554.366.366 0 01-.201.518l-2.119.744a.367.367 0 01-.435-.155 5.936 5.936 0 00-3.82-2.695.366.366 0 01-.29-.358V.639c0-.106.046-.208.127-.278zm.606.717v1.517a6.677 6.677 0 013.842 2.711l1.43-.502a8.161 8.161 0 00-5.272-3.726z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.706.639v2.245a6.208 6.208 0 00-4.967 6.101c0 3.442 2.806 6.241 6.255 6.241s6.254-2.8 6.254-6.24c0-.267-.018-.536-.056-.814l2.118-.743c.097.515.146 1.037.146 1.556 0 4.656-3.796 8.444-8.462 8.444S.532 13.641.532 8.985A8.422 8.422 0 017.706.64z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.945.361c.081.07.128.171.128.278v2.245a.366.366 0 01-.292.359 5.842 5.842 0 00-4.675 5.742c0 3.24 2.641 5.875 5.888 5.875 3.246 0 5.887-2.636 5.887-5.875 0-.249-.017-.5-.053-.764a.366.366 0 01.242-.395l2.119-.743a.368.368 0 01.482.278c.101.538.152 1.082.152 1.624 0 4.859-3.96 8.81-8.829 8.81-4.869 0-8.829-3.952-8.829-8.81A8.788 8.788 0 017.651.277a.368.368 0 01.294.084zm-.606.715A8.054 8.054 0 00.9 8.986c0 4.453 3.632 8.077 8.095 8.077 4.463 0 8.095-3.624 8.095-8.078 0-.355-.024-.711-.071-1.066l-1.429.501c.018.19.026.378.026.565 0 3.644-2.97 6.607-6.621 6.607-3.652 0-6.622-2.963-6.622-6.607A6.572 6.572 0 017.34 2.593V1.076z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.143 7.746a.368.368 0 00-.367.367v3.242c0 .202.165.367.367.367h1.324a.366.366 0 00.367-.367V8.113a.366.366 0 00-.367-.367H8.143zM10.983 6.497a.366.366 0 00-.367.368v4.49c0 .202.161.367.367.367h1.324a.366.366 0 00.367-.367v-4.49a.366.366 0 00-.367-.368h-1.324zM5.302 9.075a.368.368 0 00-.367.367v1.913c0 .202.166.367.367.367h1.329a.368.368 0 00.367-.367V9.442a.368.368 0 00-.367-.367H5.302z",
  fill: "currentColor"
}));

var _ref84 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 63 27",
  id: "icon-gs",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FC1355",
  d: "M34.557 16h15.246v4H34.557zM58.007 9v-.5h-.316l-.135.286.451.214zM62 9l.446.225.367-.725H62V9zm-3.993.5H62v-1h-3.993v1zm3.547-.725l-4.547 9 .892.45 4.547-9-.892-.45zm-6.956 8.57l3.861-8.13-.903-.43-3.861 8.13.903.43z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.805 27l4.093-8.988L49.902 9h3.985l4.049 9.014L53.898 27h-4.093z",
  fill: "#FC1355"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.226 20l-3.244-1.299-2.106-1.92-1.302-2.455L0 11.987V8.015l.572-2.393L1.85 3.216 4.043 1.27 7.226 0h3.362l3.19 1.068 1.449 1.013 1.727 1.902-3.026 2.382-1.332-1.534-.825-.564-1.84-.566H8.005l-1.671.7-1.166 1.062-.775 1.363-.378 1.603v3.114l.378 1.605.803 1.415 1.11 1.01 1.7.726H9.97l1.338-.551 1.084-.842.729-1.092.171-.668v-.53H8.466V8.941h8.813v4.46l-.344 1.699-1.353 2.076-2.155 1.715L10.718 20H7.226zM23.283 20l-3.134-.93-1.733-1.179-1.138-1.387 2.738-2.555.972 1.187.934.59 2.032.573h1.994l1.619-.618.385-.461.263-.5v-1.1l-.407-.79-.898-.469c-.858-.215-1.727-.46-2.58-.7-.855-.24-1.755-.483-2.638-.709l-.07-.02-2.303-1.563L18.302 7.8l-.405-2.46.824-2.517 1.93-1.962L23.363 0h2.994l3.178.79L31.4 2.369l1.123 1.57-2.811 2.275-.981-1.142-1.271-.997-1.653-.38h-1.894l-1.172.371-.718.717-.237.843.18.833.138.252 1.08.744 5.481 1.475 2.367 1.584.951 2.281v2.822l-.776 1.59-1.468 1.654L26.562 20h-3.28z",
  fill: "#34363F"
}));

var _ref85 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 63 27",
  id: "icon-gs-logo",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#5DE273",
  d: "M34.557 16h15.246v4H34.557zM58.008 9v-.5h-.316l-.136.286.452.214zM62 9l.447.225.366-.725H62V9zm-3.992.5H62v-1h-3.992v1zm3.546-.725l-4.547 9 .893.45 4.547-9-.893-.45zm-6.956 8.57l3.861-8.13-.903-.43-3.86 8.13.902.43z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.804 27l4.093-8.988L49.901 9h3.985l4.05 9.014L53.896 27h-4.093z",
  fill: "#5DE273"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.226 20l-3.244-1.299-2.106-1.92-1.302-2.455L0 11.987V8.015l.572-2.393L1.85 3.216 4.043 1.27 7.226 0h3.362l3.19 1.068 1.449 1.013 1.727 1.902-3.026 2.382-1.332-1.534-.825-.564-1.84-.566H8.005l-1.671.7-1.166 1.062-.775 1.363-.378 1.603v3.114l.378 1.605.803 1.415 1.11 1.01 1.7.726H9.97l1.338-.551 1.084-.842.729-1.092.171-.668v-.53H8.466V8.941h8.813v4.46l-.344 1.699-1.353 2.076-2.155 1.715L10.718 20H7.226zM23.283 20l-3.134-.93-1.733-1.179-1.137-1.387 2.737-2.555.972 1.187.935.59 2.032.573h1.993l1.619-.618.385-.461.263-.5v-1.1l-.407-.79-.898-.469c-.858-.215-1.727-.46-2.58-.7-.854-.24-1.755-.483-2.638-.709l-.07-.02-2.303-1.563L18.302 7.8l-.405-2.46.824-2.517 1.93-1.962L23.363 0h2.994l3.178.79 1.867 1.578 1.123 1.57-2.812 2.275-.98-1.142-1.272-.997-1.653-.38h-1.894l-1.171.371-.719.717-.237.843.18.833.138.252 1.08.744 5.481 1.475 2.367 1.584.951 2.281v2.822l-.775 1.59-1.468 1.654L26.563 20h-3.28z",
  fill: "#34363F"
}));

var _ref86 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 81 66",
  id: "icon-gs-logo-2",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#dgfilter0_d)"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#dgfilter1_b)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 4,
  width: 73,
  height: 58,
  rx: 6,
  fill: "url(#dgpaint0_linear)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FC1355",
  d: "M44.997 31.815h14.117v3.704H44.997z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M66.668 25.402h4.19l-4.37 8.65-.39-.197 4.05-8.016h-3.204l-3.516 7.402-.394-.187 3.634-7.652z",
  fill: "#FC1355"
}), /*#__PURE__*/React.createElement("path", {
  d: "M59.114 42l3.79-8.322-3.7-8.345h3.69l3.749 8.347L62.904 42h-3.79z",
  fill: "#FC1355"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.69 35.519l-3.003-1.203-1.95-1.777-1.205-2.274L13 28.1v-3.678l.53-2.215 1.183-2.228 2.03-1.801L19.691 17h3.113l2.953.99 1.342.937 1.6 1.76-2.803 2.207-1.233-1.42-.763-.523-1.705-.524h-1.783l-1.547.648-1.08.983-.717 1.262-.35 1.484v2.884l.35 1.486.743 1.31 1.028.936 1.573.672h1.82l1.238-.51 1.004-.78.675-1.011.159-.619v-.49h-4.469v-3.403H29v4.129l-.319 1.573-1.253 1.923-1.994 1.587-2.509 1.028h-3.233zM34.558 35.519l-2.901-.862-1.605-1.091L29 32.28l2.534-2.365.9 1.099.866.546 1.881.53h1.846l1.499-.572.357-.427.243-.462v-1.02l-.377-.73-.831-.435c-.795-.199-1.6-.426-2.39-.648-.79-.221-1.624-.447-2.442-.656l-.065-.018-2.132-1.448-.942-1.452-.375-2.278.764-2.33 1.787-1.817 2.51-.798h2.773l2.942.732 1.728 1.46 1.04 1.454-2.603 2.107-.908-1.058-1.177-.923-1.53-.351h-1.754l-1.085.343-.665.664-.22.78.167.772.127.233 1 .689 5.076 1.366 2.191 1.466.881 2.112v2.613l-.718 1.472-1.36 1.532-2.942 1.056h-3.037z",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "dgfilter0_d",
  x: 0,
  y: 0,
  width: 81,
  height: 66,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "dgfilter1_b",
  x: -10,
  y: -14,
  width: 101,
  height: 86,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImage",
  stdDeviation: 7
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur",
  result: "shape"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "dgpaint0_linear",
  x1: 5.38,
  y1: 58,
  x2: 14.771,
  y2: -8.161,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#211E21"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#211E21",
  stopOpacity: 0.94
}))));

var _ref87 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 64 28",
  id: "icon-gs-logo-white",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#5DE273",
  d: "M34.805 16.5h15.246v4H34.805zM58.26 9.5V9h-.317l-.135.286.451.214zm3.992 0l.446.225.367-.725h-.813v.5zm-3.993.5h3.993V9h-3.993v1zm3.547-.725l-4.547 9 .892.45 4.547-9-.892-.45zm-6.956 8.57l3.861-8.13-.903-.43-3.861 8.13.903.43z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M50.055 27.5l4.093-8.988L50.152 9.5h3.985l4.049 9.014-4.038 8.986h-4.093z",
  fill: "#5DE273"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.476 20.5l-3.244-1.299-2.106-1.92-1.302-2.455-.574-2.339V8.515l.572-2.393L2.1 3.716 4.293 1.77 7.476.5h3.362l3.19 1.068 1.449 1.013 1.727 1.902-3.026 2.382-1.332-1.534-.825-.564-1.84-.566H8.255l-1.671.7-1.166 1.062-.775 1.363-.378 1.603v3.114l.378 1.605.803 1.415 1.11 1.01 1.7.726h1.964l1.338-.551 1.084-.842.729-1.092.171-.668v-.53H8.716V9.441h8.813v4.46l-.344 1.699-1.353 2.076-2.155 1.715-2.709 1.109H7.476zM23.532 20.5l-3.134-.93-1.733-1.179-1.138-1.387 2.738-2.555.972 1.187.935.59 2.031.573h1.994l1.619-.618.385-.461.263-.5v-1.1l-.407-.79-.898-.469c-.858-.215-1.727-.46-2.58-.7a123.48 123.48 0 00-2.639-.709l-.07-.02-2.302-1.563L18.55 8.3l-.405-2.46.824-2.517 1.93-1.962L23.612.5h2.994l3.178.79 1.866 1.578 1.123 1.57-2.811 2.275-.981-1.142-1.271-.997-1.653-.38h-1.894l-1.172.371-.718.717-.237.843.18.833.138.252 1.08.744 5.481 1.475 2.367 1.584.951 2.281v2.822l-.775 1.59-1.469 1.654-3.178 1.14h-3.28z",
  fill: "#FBF9F9"
}));

var _ref88 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 12 12",
  id: "icon-heatpump",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#diclip0_7449_173076)",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.34.944h9.32c.553 0 1.007.455 1.007 1.011v7.078c0 .556-.454 1.01-1.008 1.01h-.504v.506c0 .14-.112.253-.251.253H8.518a.252.252 0 01-.252-.253v-.505H3.733v.505c0 .14-.113.253-.252.253H2.096a.252.252 0 01-.252-.253v-.505h-.503A1.012 1.012 0 01.333 9.033V1.955c0-.556.454-1.01 1.008-1.01zm1.008 9.353h.881v-.253h-.88v.252zm6.422 0h.882v-.253H8.77v.252zM2.694 5.194a3.305 3.305 0 116.61 0 3.305 3.305 0 01-6.61 0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.99 5.16a1.47 1.47 0 00-.904-.283c-.102 0-.201.009-.296.022a.833.833 0 00-.274-.304.415.415 0 01.22-.14c.125-.024.298-.02.454-.011.07.003.136.007.199.007.118 0 .394 0 .511-.26.04-.09.035-.195-.016-.312-.144-.33-.666-.759-1.117-.916a2.184 2.184 0 00-.713-.13c-.6 0-1.013.319-1.077.833-.06.474.14.87.375 1.165a.815.815 0 00-.13.382.422.422 0 01-.235-.119c-.098-.112-.168-.25-.237-.384-.128-.252-.263-.516-.576-.483-.098.01-.187.067-.263.17-.217.288-.33.95-.242 1.417.146.768.591 1.265 1.134 1.265.125 0 .25-.027.375-.079.439-.184.686-.548.826-.895l.046.002c.13 0 .251-.03.36-.082a.403.403 0 01.01.252c-.05.14-.135.27-.217.395-.15.227-.319.484-.134.737.071.097.196.146.37.146.372 0 .94-.227 1.268-.506.428-.365.666-.8.654-1.196a.878.878 0 00-.371-.692zM4.96 6.493a.41.41 0 01-.158.035c-.255 0-.497-.335-.588-.815a1.848 1.848 0 01.043-.746c.075.147.168.328.31.49.185.21.461.319.822.327.03.039.064.075.1.109-.095.241-.257.487-.529.6zm1.09-.936a.277.277 0 01-.278-.276.277.277 0 01.556 0 .277.277 0 01-.279.276zm-.124-1.092a.823.823 0 00-.135.031c-.165-.204-.3-.468-.264-.761.029-.233.206-.35.525-.35.16 0 .343.034.53.1.232.08.475.258.63.41a4.319 4.319 0 00-.24-.01c-.127 0-.239.01-.343.03-.322.063-.548.297-.703.55zm1.419 2.167c-.176.15-.452.275-.673.336.09-.138.202-.309.272-.51.105-.304.018-.61-.122-.867a.798.798 0 00.044-.144 1.51 1.51 0 01.219-.018c.228 0 .414.057.569.173.099.074.147.16.15.27.008.224-.164.508-.46.76z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "diclip0_7449_173076"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  transform: "translate(.333)",
  d: "M0 0h11.333v11.333H0z"
}))));

var _ref89 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 106 95",
  id: "icon-heatpump-3d",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.1,
  filter: "url(#djfilter0_f_16429_470839)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M52.898 34.783L15.839 56.532l-2.988 1.756 5.458 3.253 24.442 14.533 5.442 3.238h.008l4.567 2.717 34.579-20.304 5.459-3.21-2.989-1.78-1.698-1.008-5.44-3.239-29.782-17.705z",
  fill: "#211E21"
})), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9 43.706l4.549 2.583 4.666 2.642 2.533 1.476 7.2 4.177 8.048 4.672L42 62.746l3.854 2.237 2.658 1.542 4.534 2.642v-.514l.015-.008v-.2L9 42.852v.855z",
  fill: "#E4E4E4"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M53.06 68.722v.59l4.677-2.692 2.609-1.484 17.97-10.31 7.22-4.14 2.623-1.504 4.677-2.681 4.58-2.628v-.58L53.06 68.721z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M53.284 17.569l-40.98 23.547L9 43.018l6.036 3.521 27.028 15.736 6.018 3.505h.01l5.05 2.942L91.377 46.74l6.037-3.475-3.305-1.927-1.877-1.092-6.016-3.506-32.933-19.17z",
  fill: "url(#djpaint0_linear_16429_470839)"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.065,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M91.943 40.282L47.649 65.761l-.05-.086 44.294-25.479.05.086zM86.027 36.733L41.733 62.212l-.05-.087 44.295-25.478.05.086zM80.551 33.773L36.257 59.252l-.05-.086 44.295-25.479.05.086zM75.233 30.525L30.939 56.003l-.05-.086 44.294-25.479.05.087zM69.76 27.567L25.466 53.045l-.05-.086L69.712 27.48l.05.087zM64.443 24.02L20.149 49.498l-.05-.086 44.294-25.479.05.087zM58.373 20.47L14.079 45.949l-.05-.087 44.294-25.478.05.086z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.065,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.027 40.282L58.32 65.761l.05-.086-44.294-25.479-.05.086zM19.942 36.733l44.294 25.479.05-.087-44.294-25.478-.05.086zM25.418 33.773l44.294 25.479.05-.086-44.294-25.479-.05.086zM30.736 30.525L75.03 56.003l.05-.086-44.294-25.479-.05.087zM36.213 27.567l44.294 25.478.05-.086L36.263 27.48l-.05.087zM41.535 24.02l44.294 25.478.05-.086-44.294-25.479-.05.087zM47.597 20.47L91.89 45.949l.05-.087-44.295-25.478-.05.086z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M73.293 11.739l-9.307-5.367-31.588 18.206 9.171 5.502L73.293 11.74z",
  fill: "#FBF9F9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M46.596 54.06v-1.087l-3.397 2.038v.951l3.397-1.902z",
  fill: "#333"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43.2 55.962l-.884-.543.883-.408v.951z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.221 49.712v-1.087l-3.396 2.038v.952l3.396-1.903z",
  fill: "#333"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.825 51.615l-.883-.544v-.68l.883.273v.95z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M72.681 39.115v-1.087l-3.396 2.038v.951l3.397-1.902z",
  fill: "#333"
}), /*#__PURE__*/React.createElement("path", {
  d: "M69.285 41.017l-.883-.543.883-.408v.951z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.398 50.12V24.51l9.103 5.57.68 25.746-9.783-5.706z",
  fill: "#CFD2D3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M73.293 11.739l.475 25.746-31.724 18.273-.475-25.678L73.293 11.74z",
  fill: "#EFEFF1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M67.306 20.495l4.368-2.52c.218-.126.396-.027.396.224a.87.87 0 01-.396.686l-4.368 2.52c-.217.126-.395.027-.395-.224v-.013a.892.892 0 01.395-.673z",
  fill: "#34363F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M65.13 21.755l1.062-.613c.217-.126.396-.027.396.224a.87.87 0 01-.396.686l-1.063.614c-.217.125-.395.026-.395-.225v-.013c.013-.25.184-.547.395-.673z",
  fill: "#85FC99"
}), /*#__PURE__*/React.createElement("path", {
  d: "M67.306 23.348l4.368-2.52c.218-.125.396-.026.396.224a.87.87 0 01-.396.686l-4.368 2.52c-.217.126-.395.027-.395-.224v-.013a.892.892 0 01.395-.673z",
  fill: "#34363F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M65.13 24.608l1.062-.613c.217-.126.396-.027.396.224a.87.87 0 01-.396.686l-1.063.614c-.217.125-.395.026-.395-.225v-.013c.013-.25.184-.547.395-.673z",
  fill: "#85FC99"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43.145 53.271l.004.898L63.821 42.12l-.102-23.928-.774.446.099 23.036-19.899 11.597z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43.047 30.242l.099 23.03 19.898-11.597-.099-23.037-19.898 11.604z",
  fill: "#DBDFE0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M46.458 46.596c1.637 1.136 4.005 1.071 6.624-.457 4.927-2.872 8.898-9.822 8.873-15.523-.012-3.028-1.15-5.098-2.957-5.934 1.46.98 2.36 2.916 2.371 5.603.024 5.701-3.953 12.651-8.873 15.523-2.328 1.357-4.45 1.563-6.045.795l.007-.007z",
  fill: "#DAE5F8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M44.127 41.013c.012 2.654.884 4.569 2.317 5.57 0 .013.014.013.014.013 1.595.769 3.717.562 6.045-.795 4.92-2.872 8.898-9.821 8.873-15.523-.011-2.687-.911-4.622-2.371-5.602-1.589-.742-3.697-.529-6.004.808-4.927 2.871-8.898 9.828-8.874 15.523v.006z",
  fill: "#34363F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M55.843 25.227l.307.168v.062c.042.047.09.095.13.149 1.561 2.204-1.366 6.673-1.366 6.673s-3.446 2.376-3.624 2.111c-.732-1.12-2.064-.74-2.84-.872l-.041.054-.28-.162a.543.543 0 01-.26-.386c-.66-3.352 5.683-9.019 7.968-7.81l.006.013z",
  fill: "#6E6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M55.221 32.461s2.927-4.469 1.367-6.673c-1.732-2.449-9.114 3.828-8.405 7.424.223 1.142 2.4-.194 3.414 1.36.172.265 3.624-2.111 3.624-2.111z",
  fill: "url(#djpaint1_linear_16429_470839)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M53.118 38.471s1.525-4.49 1.885-4.675c2.097-1.09 3.188-3.912 4.241-4.073.306-.042.558-.002.77.105l.327.183-.013.075c1.518 1.762-.662 9.126-3.608 10.744-.78.432-1.4.49-1.883.342l-.02.034-.369-.216c-1.091-.683-1.324-2.526-1.324-2.526l-.006.007z",
  fill: "#6E6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M53.424 38.647s.5 4.06 3.603 2.36c3.441-1.886 5.835-11.612 2.524-11.108-1.054.16-2.137 2.975-4.242 4.073-.36.185-1.885 4.675-1.885 4.675z",
  fill: "#85FC99"
}), /*#__PURE__*/React.createElement("path", {
  d: "M50.175 35.966s-3.375-.033-5.195 3.928c-2.022 4.404 2.548 8.78 5.422 4.753.913-1.276-.026-3.014 1.248-5.693.182-.382-.724-2.283-1.114-2.873-.076-.116-.368-.108-.368-.108l.007-.007z",
  fill: "#6E6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M50.474 36.142s-3.374-.033-5.194 3.927c-2.022 4.397 2.548 8.78 5.422 4.753.913-1.276-.026-3.014 1.248-5.693.216-.457-1.482-2.98-1.482-2.98l.006-.007z",
  fill: "#85FC99"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.963 37.587c.008 1.973 1.4 2.77 3.11 1.776s3.081-3.402 3.073-5.382c-.009-1.98-1.4-2.77-3.104-1.776-1.71.994-3.08 3.402-3.079 5.382z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M55.198 31.958l.512.297-.223.382-.695-.249.406-.43zM51.375 39.867l-.546-.31.39-.969.519.304-.363.975z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M50.407 37.837c.008 1.98 1.4 2.77 3.103 1.776 1.71-.994 3.088-3.402 3.08-5.382-.01-1.98-1.4-2.77-3.11-1.776-1.711.994-3.082 3.402-3.073 5.382z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M62.633 18.918l.1 23.451s-.013.041-.04.055a.204.204 0 01-.198 0c-.027-.013-.04-.033-.04-.054l-.1-23.288.278-.164zM61.574 19.535l.1 23.451s-.013.041-.04.055a.204.204 0 01-.197 0c-.028-.013-.041-.033-.041-.053l-.1-23.289.278-.164zM60.515 20.151l.1 23.452s-.013.04-.04.054a.203.203 0 01-.197.001c-.028-.013-.041-.034-.041-.054l-.1-23.288.278-.165zM59.457 20.769l.1 23.45s-.013.042-.04.056a.203.203 0 01-.198 0c-.027-.013-.04-.033-.04-.054l-.1-23.288.278-.164zM58.398 21.385l.1 23.451s-.013.041-.04.055a.204.204 0 01-.198 0c-.027-.013-.04-.033-.04-.053l-.1-23.289.278-.164zM57.34 22.002l.1 23.451s-.014.041-.041.055a.203.203 0 01-.197 0c-.028-.013-.041-.033-.041-.053l-.1-23.289.278-.164zM56.28 22.62l.1 23.45s-.013.042-.04.055a.203.203 0 01-.197.001c-.028-.013-.041-.034-.041-.054l-.1-23.288.278-.165zM55.222 23.236l.1 23.451s-.013.04-.04.055a.204.204 0 01-.198 0c-.027-.013-.04-.033-.04-.054l-.1-23.288.278-.164zM54.163 23.853l.1 23.451s-.013.041-.04.055a.204.204 0 01-.198 0c-.027-.013-.04-.033-.041-.054l-.1-23.288.279-.164zM53.11 24.469l.101 23.451s-.013.041-.04.055a.204.204 0 01-.198 0c-.027-.013-.04-.033-.04-.053l-.1-23.288.278-.165zM52.053 25.086l.1 23.452s-.014.04-.04.054a.203.203 0 01-.198.001c-.027-.014-.04-.034-.041-.054l-.1-23.288.279-.165zM50.993 25.703l.1 23.452s-.013.04-.04.054a.204.204 0 01-.197.001c-.027-.013-.041-.034-.041-.054l-.1-23.288.278-.165zM49.935 26.32l.1 23.451s-.013.041-.04.055a.204.204 0 01-.198 0c-.027-.013-.04-.033-.04-.054l-.1-23.288.278-.164zM48.877 26.944l.1 23.444s-.013.041-.04.055a.204.204 0 01-.198 0c-.027-.013-.04-.033-.04-.053l-.1-23.288.278-.165v.007zM47.817 27.553l.1 23.452s-.013.04-.04.054a.203.203 0 01-.197.001c-.027-.013-.041-.034-.041-.054l-.1-23.288.278-.165zM46.759 28.177l.1 23.445s-.013.04-.04.054a.204.204 0 01-.198.001c-.027-.013-.04-.034-.04-.054l-.1-23.288.278-.165v.007zM45.7 28.788l.1 23.451s-.013.04-.04.055a.204.204 0 01-.197 0c-.028-.013-.041-.033-.041-.054l-.1-23.288.278-.164zM44.641 29.41l.1 23.452s-.013.041-.04.055a.203.203 0 01-.197 0c-.027-.013-.041-.033-.041-.054l-.1-23.294.278-.165v.007zM43.583 30.028l.1 23.451s-.014.041-.04.055a.203.203 0 01-.198 0c-.027-.013-.04-.033-.041-.053l-.1-23.295.279-.165v.007z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43.164 52.862l20.176-11.76s.041-.008.068.006a.228.228 0 01.103.17c0 .033-.013.054-.027.06L43.165 53.183l-.001-.326v.006zM43.159 51.638l20.176-11.761s.041-.007.068.006c.055.034.103.109.096.17 0 .034-.013.054-.027.061L43.153 51.958l-.001-.32h.007zM43.153 50.414L63.33 38.652s.04-.007.068.007a.22.22 0 01.096.17c0 .033-.013.054-.027.06L43.148 50.734l-.001-.326.006.007zM43.148 49.188l20.177-11.761s.04-.007.068.006a.227.227 0 01.102.17c0 .034-.013.054-.027.061L43.15 49.508l-.001-.327v.007zM43.143 47.964l20.176-11.768s.041-.007.069 0c.054.033.102.108.096.17 0 .033-.014.054-.027.06l-20.32 11.85v-.326l.006.014zM43.138 46.74L63.314 34.97s.041-.007.068.007a.22.22 0 01.096.17c0 .034-.013.054-.027.06L43.132 47.054l-.001-.327.007.014zM43.132 45.515L63.31 33.747s.04-.007.068 0a.22.22 0 01.096.17c0 .033-.014.054-.027.06l-20.32 11.844v-.326l.006.02zM43.127 44.29l20.177-11.768s.04-.007.068.006a.228.228 0 01.102.17c0 .034-.013.054-.026.061l-20.32 11.844-.001-.327v.014zM43.122 43.065l20.176-11.768s.041-.007.069.007c.054.033.102.108.096.17 0 .033-.014.054-.027.06l-20.32 11.851v-.327l.006.007zM43.117 41.84l20.176-11.767s.04-.007.068.006a.227.227 0 01.103.17c0 .034-.014.054-.027.061l-20.32 11.844v-.32.007zM43.111 40.616l20.177-11.768s.04-.007.068.007a.217.217 0 01.103.17.09.09 0 01-.027.067l-20.32 11.844v-.327.007zM43.106 39.385l20.177-11.761s.04-.007.068.006a.228.228 0 01.102.17c0 .034-.013.054-.027.061l-20.319 11.85-.001-.326zM43.1 38.16l20.177-11.761s.041-.007.068.006a.227.227 0 01.103.17c0 .034-.013.054-.027.061l-20.319 11.85-.001-.326zM43.095 36.936l20.177-11.762s.04-.007.068.007a.227.227 0 01.103.17c0 .034-.014.054-.027.06l-20.32 11.851v-.326zM43.09 35.711L63.267 23.95s.04-.007.068.006a.228.228 0 01.103.17c0 .034-.014.054-.027.061L43.09 36.031v-.327.007zM43.085 34.487l20.177-11.762s.04-.007.068.007c.054.034.102.108.096.17 0 .034-.014.054-.027.06l-20.32 11.844v-.326l.006.007zM43.08 33.261l20.176-11.768s.041-.007.068.007a.228.228 0 01.103.17c0 .034-.013.054-.027.06L43.081 33.582l-.001-.326v.006zM43.075 32.037L63.25 20.27s.04-.007.068.007a.228.228 0 01.103.17c0 .033-.014.054-.027.06L43.075 32.35v-.32.007zM43.07 30.813l20.176-11.769s.04-.007.068.007c.055.034.103.108.096.17 0 .034-.013.054-.027.06L43.064 31.133l-.001-.326.006.006z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "djpaint0_linear_16429_470839",
  x1: 92.741,
  y1: 43.129,
  x2: 5.817,
  y2: 43.129,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F2F2F2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "djpaint1_linear_16429_470839",
  x1: 52.61,
  y1: 27.281,
  x2: 52.61,
  y2: 33.803,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#85FC99"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6E6"
})), /*#__PURE__*/React.createElement("filter", {
  id: "djfilter0_f_16429_470839",
  x: 0.203,
  y: 22.135,
  width: 105.25,
  height: 72.541,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 6.324,
  result: "effect1_foregroundBlur_16429_470839"
}))));

var _ref90 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 24 24",
  id: "icon-house",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.788 4.161L.445 12.263v9.723h5.128v-3.889c0-1.62 1.072-3.079 2.526-3.403 2.066-.405 3.827 1.215 3.827 3.322v4.051h5.128v-9.722L8.788 4.16z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M17.054 21.825v-9.723L8.711 4h7.348l7.654 8.102v9.723h-6.659z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.785 20.867H0v1.199h23.785v-1.2z",
  fill: "currentColor"
}));

var _ref91 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 889 722",
  id: "icon-house-3d",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.04,
  filter: "url(#dlfilter0_f)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M444.882 206.34L72.685 424.775l-30.013 17.641 54.826 32.663 245.479 145.965 54.651 32.519h.088l45.869 27.294 347.284-203.928 54.832-32.23-30.019-17.883-17.053-10.126-54.638-32.526L444.882 206.34z",
  fill: "#211E21"
})), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 287.788l45.734 25.973 46.922 26.565 25.466 14.842 72.395 42 80.926 46.973 60.353 35.1 38.755 22.484 26.728 15.509 45.586 26.566v-5.178l.148-.074v-2.003L0 279.197v8.591z",
  fill: "#F3F3F3"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M443.014 539.34v5.946l47.027-27.073 26.229-14.921 180.695-103.67 72.578-41.629 26.387-15.117 47.019-26.959L889 289.488v-5.832L443.014 539.34z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M445.27 25L33.226 261.766 0 280.888l60.695 35.405 271.76 158.214 60.502 35.249h.097l50.78 29.584 384.463-221.042L889 283.362l-33.234-19.382-18.878-10.977-60.487-35.256L445.27 25z",
  fill: "url(#dlpaint0_linear)"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.065,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M833.934 253.367L388.567 509.549l-.499-.867L833.435 252.5l.499.867zM774.469 217.691L329.102 473.873l-.498-.867L773.97 216.824l.499.867zM719.467 187.961L274.1 444.143l-.498-.867 445.366-256.182.499.867zM665.946 155.255L220.579 411.438l-.499-.867 445.367-256.182.499.866zM610.942 125.525L165.575 381.707l-.499-.867 445.367-256.182.499.867zM557.422 89.85L112.055 346.03l-.498-.866L556.923 88.982l.499.867zM496.471 54.172L51.104 310.353l-.498-.867L495.971 53.305l.499.867z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.065,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M50.605 253.367l445.367 256.182.499-.867L51.104 252.5l-.499.867zM110.07 217.691l445.367 256.182.499-.867-445.367-256.182-.499.867zM165.076 187.961l445.367 256.182.498-.867-445.366-256.182-.499.867zM218.594 155.255L663.96 411.438l.499-.867-445.367-256.182-.498.866zM273.601 125.525l445.367 256.182.499-.867L274.1 124.658l-.499.867zM327.117 89.85L772.484 346.03l.498-.866L327.616 88.982l-.499.867zM388.068 54.172l445.367 256.182.499-.867L388.567 53.305l-.499.867z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M383.01 216.065v10.519l-6.063-3.494-99.195-57.288-27.914-16.119v-10.519l133.172 76.901z",
  fill: "#CFD2D3"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M633.832 154.322v10.519l-30.114 17.395-83.556 48.248v-10.518l113.67-65.644zM624.051 76.883V87.3l-56.253 32.48-5.915-6.999 56.252-32.48 5.916-3.42z",
  fill: "#DBDFE0"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M490.875 0L249.838 139.163l5.915 3.418 21.999 12.702 99.195 57.286 6.063 3.494 64.959-37.506.222-.132 59.432 34.31h.019l6.488 3.755 6.026 3.473 83.557-48.248 24.216-13.975 5.897-3.42-66.03-38.135-5.917-3.403 56.252-32.48 5.916-3.42L490.875 0z",
  fill: "#F3F3F3"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M178 295.923l122.413 70.672 16.065-9.262 27.34 15.787 24.383 14.086h17.95l-9.705-5.601-23.662-13.661-27.341-15.787-104.038-60.06h-.019v-11.203h.019l56.345-32.535V238.34L178 295.923zM468.286 363.194l-4.067 2.329-14.585 8.429h-.019l-9.298-5.36-10.944-6.323 14.604-8.429 3.993-2.311.055-.037 10.962 6.322 9.299 5.38z",
  fill: "#CED1D5"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M376.942 340.953h-51.501l-94.334-54.459-9.705-5.602 56.345-32.535v35.327l99.195 57.269z",
  fill: "#DBDFE0"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M429.377 351.064l-43.22 24.938-23.662-13.661-37.046-21.388h74.073l6.174-3.568 23.681 13.679z",
  fill: "#F8FAFA"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M576.674 302.02v15.14l-49.043 28.32h-47.268l-11.683 6.747-10.944-6.322h-.018l-9.687-5.62-.055-.018v.055l-9.65 5.565-4.048 2.347-4.899 2.829-23.68-13.68-6.175 3.568h-22.571l17.247-9.964 36.455-21.037 17.321-10.001 11.276 6.507h.019l23.68 13.68 31.167 18.005h.019v-.018l17.413-10.057 45.124-26.046z",
  fill: "#DBDFE0"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M603.705 286.402l-27.045 15.621v15.14l-49.044 28.32h-47.267l-11.683 6.746 23.643 13.642 27.119 15.66.035.018 128.83-74.387 9.705-5.601-54.293-31.354v16.195z",
  fill: "#F9FAFB"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M325.438 340.955v11.202l-104.039-60.06h-.018v-11.202h.018l9.705 5.601 94.334 54.459z",
  fill: "#BBBBBC"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M386.157 376.002v11.203l-9.705-5.602-23.662-13.661-27.341-15.786v-11.203l37.046 21.388 23.662 13.661z",
  fill: "#CFD2D3"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M650.033 223.66v11.203l-46.326 26.73v-11.202l36.621-21.13 9.705-5.601z",
  fill: "#DBDFE0"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M468.669 352.229v10.74l-.388.222-9.299-5.379-10.962-6.322-.055-.019v-11.147l.055-.037 9.687 5.62h.018l10.944 6.322z",
  fill: "#C6CACC"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M468.666 363.414l13.938 8.06 36.824 21.259V381.53l-27.119-15.659-23.643-13.642v11.185z",
  fill: "#C6C9CC"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M567.764 137.128l-5.454 3.142-5.453 3.143-5.435-3.143-5.453-3.142 10.888-6.304 10.907 6.304z",
  fill: "#CED1D5"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M562.308 140.27l-5.453 3.142-5.435-3.142-5.453-3.143 10.888-6.304 10.907 6.304-5.454 3.143zm-5.434-18.061l-25.825 14.918 12.921 7.45 12.904 7.45 12.903-7.45 12.903-7.45-25.806-14.918z",
  fill: "#F9FAFB"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M582.67 137.127v14.9l-25.807 14.918v-14.918l12.903-7.45 12.904-7.45zM444.906 252.684l-14.253 8.226-22.201 12.811-14.253-14.252.037-.019 36.417-21.018 14.253 14.252z",
  fill: "#DBDFE0"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M383.016 226.584l-6.063-3.494v117.866l17.247-9.964V259.47l.037-.018 36.418-21.019 14.252 14.253-14.252 8.226v49.043l17.321-10.001V189.076l-64.96 37.508z",
  fill: "#CFD2D3"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M514.135 227.008v111.137h-.018l-31.167-18.006-23.681-13.679h-.018l-11.276-6.507V189.075l.221-.13 59.432 34.31h.019l6.488 3.753zM376.957 223.086v117.866l-99.195-57.269V165.799l99.195 57.287z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M586.99 250.52v45.549l-10.315 5.952-45.124 26.047V260.04l14.252 14.252 41.187-23.772z",
  fill: "#6E6"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#dlfilter1_f)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M586.99 250.52v45.549l-10.315 5.952-45.124 26.047V260.04l14.252 14.252 41.187-23.772z",
  fill: "#6E6"
})), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M601.242 242.292l-14.252 8.226-41.187 23.773-14.252-14.253 55.439-31.999 14.252 14.253z",
  fill: "#F9FAFB"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M603.715 182.234v104.168l-16.729 9.668v-45.549l14.252-8.226-14.252-14.253-55.44 31.999v68.028l-17.413 10.057V227.007l6.026 3.475 83.556-48.248z",
  fill: "#EAEAEA"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M556.87 152.027v14.918l-25.825-14.918v-14.9l12.922 7.45 12.903 7.45z",
  fill: "#CFD2D3"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M430.653 260.907v49.043l-36.454 21.037v-71.522l14.253 14.252 22.201-12.81z",
  fill: "#6E6"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#dlfilter2_f)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M430.653 260.907v49.043l-36.454 21.037v-71.522l14.253 14.252 22.201-12.81z",
  fill: "#6E6"
})), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M429.372 351.066v11.203l-43.22 24.937v-11.202l43.22-24.938zM648.297 307.162l-128.83 74.387-.035.018v11.166l.035.018 9.688-5.603 128.847-74.387v-11.2l-9.705 5.601z",
  fill: "#DBDFE0"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M650.033 223.64v.018l-9.705 5.601-36.621 21.13v-53.498l46.326 26.749z",
  fill: "#F9FAFB"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M447.97 340.322v11.203l-3.993 2.31-14.604 8.43v-11.202l4.899-2.829 4.048-2.348 9.65-5.564z",
  fill: "#CED1D2"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M448.195 178.424v10.518l-.222.13-64.959 37.507v-10.518l64.959-37.508.222-.129z",
  fill: "#DBDFE0"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M520.165 219.962v10.518l-6.027-3.475-6.488-3.753h-.019l-59.432-34.31v-10.518l71.966 41.538z",
  fill: "#CFD2D3"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "dlfilter0_f",
  x: 1.89,
  y: 165.558,
  width: 884.594,
  height: 556.081,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 20.391,
  result: "effect1_foregroundBlur"
})), /*#__PURE__*/React.createElement("filter", {
  id: "dlfilter1_f",
  x: 515.551,
  y: 234.52,
  width: 87.439,
  height: 109.548,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 8,
  result: "effect1_foregroundBlur"
})), /*#__PURE__*/React.createElement("filter", {
  id: "dlfilter2_f",
  x: 378.199,
  y: 243.465,
  width: 68.454,
  height: 103.522,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 8,
  result: "effect1_foregroundBlur"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "dlpaint0_linear",
  x1: 842,
  y1: 282,
  x2: -32,
  y2: 282,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F2F2F2"
}))));

var _ref92 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 38 45",
  id: "icon-inclinated-pv",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#dmclip0_5463_339935)"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#dmfilter0_d_5463_339935)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.963 39.13L3.864 30.682l14.733-7.861 15.539 8.155-15.173 8.154z",
  fill: "#D8D8D8",
  fillOpacity: 0.07,
  shapeRendering: "crispEdges"
})), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.073 39.138l-.177-14.966 15.24-8.191v15.13l-15.063 8.027z",
  fill: "url(#dmpaint0_linear_5463_339935)"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#dmfilter1_d_5463_339935)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.963 23.971l-7.55-10.746-7.549 2.298 14.733-7.861 7.77-2.445 7.769 10.6-15.173 8.154z",
  fill: "url(#dmpaint1_linear_5463_339935)"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#dmfilter2_d_5463_339935)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.143 23.971l-7.55-10.746 7.55-3.768 7.403-4.24 7.769 10.6-15.172 8.154z",
  fill: "#5DE273"
})), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.938 30.86V15.667l7.53-2.29L19 24.13l.073 14.971L3.938 30.86z",
  fill: "#4B464B"
}), /*#__PURE__*/React.createElement("g", {
  opacity: 0.4
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#dmfilter3_d_5463_339935)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.39 21.85l15.172-8.154",
  stroke: "#000",
  strokeWidth: 0.1
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#dmfilter4_d_5463_339935)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.102 19.894l15.172-8.155",
  stroke: "#000",
  strokeWidth: 0.1
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#dmfilter5_d_5463_339935)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.813 17.938l15.173-8.155",
  stroke: "#000",
  strokeWidth: 0.1
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#dmfilter6_d_5463_339935)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.525 15.981l15.173-8.155",
  stroke: "#000",
  strokeWidth: 0.1
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#dmfilter7_d_5463_339935)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M30.956 17.773l-7.77-10.6",
  stroke: "#000",
  strokeWidth: 0.1
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#dmfilter8_d_5463_339935)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M32.888 16.469l-7.77-10.6",
  stroke: "#000",
  strokeWidth: 0.1
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#dmfilter9_d_5463_339935)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M29.024 18.425l-7.77-10.599",
  stroke: "#000",
  strokeWidth: 0.1
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#dmfilter10_d_5463_339935)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M27.735 19.73l-7.769-10.6",
  stroke: "#000",
  strokeWidth: 0.1
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#dmfilter11_d_5463_339935)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24.515 21.686l-7.77-10.599",
  stroke: "#000",
  strokeWidth: 0.1
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#dmfilter12_d_5463_339935)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.65 22.99l-7.769-10.599",
  stroke: "#000",
  strokeWidth: 0.1
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#dmfilter13_d_5463_339935)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.583 22.338l-7.77-10.599",
  stroke: "#000",
  strokeWidth: 0.1
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#dmfilter14_d_5463_339935)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M25.803 20.382l-7.77-10.6",
  stroke: "#000",
  strokeWidth: 0.1
})))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "dmfilter0_d_5463_339935",
  x: -0.136,
  y: 22.821,
  width: 38.271,
  height: 24.31,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_5463_339935"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_5463_339935",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "dmfilter1_d_5463_339935",
  x: -2.136,
  y: -0.783,
  width: 42.271,
  height: 30.754,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.4 0 0 0 0 0.933333 0 0 0 0 0.4 0 0 0 0.6 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_5463_339935"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_5463_339935",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "dmfilter2_d_5463_339935",
  x: 5.593,
  y: -0.783,
  width: 34.722,
  height: 30.754,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.4 0 0 0 0 0.933333 0 0 0 0 0.4 0 0 0 0.6 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_5463_339935"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_5463_339935",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "dmfilter3_d_5463_339935",
  x: 11.366,
  y: 7.652,
  width: 27.22,
  height: 20.243,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.4 0 0 0 0 0.933333 0 0 0 0 0.4 0 0 0 0.6 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_5463_339935"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_5463_339935",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "dmfilter4_d_5463_339935",
  x: 10.078,
  y: 5.695,
  width: 27.22,
  height: 20.243,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.4 0 0 0 0 0.933333 0 0 0 0 0.4 0 0 0 0.6 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_5463_339935"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_5463_339935",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "dmfilter5_d_5463_339935",
  x: 8.79,
  y: 3.739,
  width: 27.22,
  height: 20.243,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.4 0 0 0 0 0.933333 0 0 0 0 0.4 0 0 0 0.6 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_5463_339935"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_5463_339935",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "dmfilter6_d_5463_339935",
  x: 7.502,
  y: 1.782,
  width: 27.22,
  height: 20.243,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.4 0 0 0 0 0.933333 0 0 0 0 0.4 0 0 0 0.6 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_5463_339935"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_5463_339935",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "dmfilter7_d_5463_339935",
  x: 17.146,
  y: 1.144,
  width: 19.85,
  height: 22.658,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.4 0 0 0 0 0.933333 0 0 0 0 0.4 0 0 0 0.6 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_5463_339935"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_5463_339935",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "dmfilter8_d_5463_339935",
  x: 19.078,
  y: -0.16,
  width: 19.85,
  height: 22.658,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.4 0 0 0 0 0.933333 0 0 0 0 0.4 0 0 0 0.6 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_5463_339935"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_5463_339935",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "dmfilter9_d_5463_339935",
  x: 15.214,
  y: 1.797,
  width: 19.85,
  height: 22.658,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.4 0 0 0 0 0.933333 0 0 0 0 0.4 0 0 0 0.6 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_5463_339935"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_5463_339935",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "dmfilter10_d_5463_339935",
  x: 13.926,
  y: 3.101,
  width: 19.85,
  height: 22.658,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.4 0 0 0 0 0.933333 0 0 0 0 0.4 0 0 0 0.6 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_5463_339935"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_5463_339935",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "dmfilter11_d_5463_339935",
  x: 10.705,
  y: 5.058,
  width: 19.85,
  height: 22.658,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.4 0 0 0 0 0.933333 0 0 0 0 0.4 0 0 0 0.6 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_5463_339935"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_5463_339935",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "dmfilter12_d_5463_339935",
  x: 6.841,
  y: 6.362,
  width: 19.85,
  height: 22.658,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.4 0 0 0 0 0.933333 0 0 0 0 0.4 0 0 0 0.6 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_5463_339935"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_5463_339935",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "dmfilter13_d_5463_339935",
  x: 8.773,
  y: 5.71,
  width: 19.85,
  height: 22.658,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.4 0 0 0 0 0.933333 0 0 0 0 0.4 0 0 0 0.6 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_5463_339935"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_5463_339935",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "dmfilter14_d_5463_339935",
  x: 11.994,
  y: 3.753,
  width: 19.85,
  height: 22.658,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.4 0 0 0 0 0.933333 0 0 0 0 0.4 0 0 0 0.6 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_5463_339935"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_5463_339935",
  result: "shape"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "dmpaint0_linear_5463_339935",
  x1: 19.184,
  y1: 39.138,
  x2: 25.997,
  y2: 14.04,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#211E21"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#211E21",
  stopOpacity: 0.94
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "dmpaint1_linear_5463_339935",
  x1: 29.263,
  y1: 13.284,
  x2: 6.352,
  y2: 14.419,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#6E6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#87FC87"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "dmclip0_5463_339935"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h38v45H0z"
}))));

var _ref93 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 38 45",
  id: "icon-inclinated-pv-white",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#dnclip0_6538_144423)"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#dnfilter0_d_6538_144423)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.963 39.13L3.864 30.682l14.733-7.861 15.538 8.155-15.172 8.154z",
  fill: "#D8D8D8",
  fillOpacity: 0.07,
  shapeRendering: "crispEdges"
})), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.073 39.137l-.177-14.965 15.24-8.191v15.13l-15.063 8.026z",
  fill: "url(#dnpaint0_linear_6538_144423)"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#dnfilter1_d_6538_144423)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.963 23.971l-7.55-10.746-7.549 2.298 14.733-7.861 7.77-2.445 7.768 10.6-15.172 8.154z",
  fill: "url(#dnpaint1_linear_6538_144423)"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#dnfilter2_d_6538_144423)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.143 23.971l-7.55-10.746 7.55-3.768 7.403-4.24 7.769 10.6-15.172 8.154z",
  fill: "#5DE273"
})), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.938 30.86V15.667l7.53-2.29L19 24.13l.073 14.971L3.937 30.86z",
  fill: "#FBF9F9"
}), /*#__PURE__*/React.createElement("g", {
  opacity: 0.4
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#dnfilter3_d_6538_144423)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.39 21.85l15.172-8.154",
  stroke: "#000",
  strokeWidth: 0.1
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#dnfilter4_d_6538_144423)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.102 19.894l15.172-8.155",
  stroke: "#000",
  strokeWidth: 0.1
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#dnfilter5_d_6538_144423)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.813 17.937l15.173-8.154",
  stroke: "#000",
  strokeWidth: 0.1
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#dnfilter6_d_6538_144423)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.525 15.98l15.173-8.154",
  stroke: "#000",
  strokeWidth: 0.1
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#dnfilter7_d_6538_144423)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M30.956 17.773l-7.77-10.6",
  stroke: "#000",
  strokeWidth: 0.1
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#dnfilter8_d_6538_144423)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M32.888 16.469l-7.77-10.6",
  stroke: "#000",
  strokeWidth: 0.1
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#dnfilter9_d_6538_144423)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M29.024 18.425l-7.77-10.599",
  stroke: "#000",
  strokeWidth: 0.1
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#dnfilter10_d_6538_144423)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M27.736 19.73l-7.77-10.6",
  stroke: "#000",
  strokeWidth: 0.1
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#dnfilter11_d_6538_144423)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24.515 21.686l-7.77-10.6",
  stroke: "#000",
  strokeWidth: 0.1
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#dnfilter12_d_6538_144423)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.65 22.99l-7.769-10.599",
  stroke: "#000",
  strokeWidth: 0.1
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#dnfilter13_d_6538_144423)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.583 22.338l-7.77-10.599",
  stroke: "#000",
  strokeWidth: 0.1
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#dnfilter14_d_6538_144423)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M25.803 20.382l-7.77-10.6",
  stroke: "#000",
  strokeWidth: 0.1
})))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "dnfilter0_d_6538_144423",
  x: -0.136,
  y: 22.821,
  width: 38.271,
  height: 24.31,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_6538_144423"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_6538_144423",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "dnfilter1_d_6538_144423",
  x: -2.136,
  y: -0.783,
  width: 42.271,
  height: 30.754,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.4 0 0 0 0 0.933333 0 0 0 0 0.4 0 0 0 0.6 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_6538_144423"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_6538_144423",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "dnfilter2_d_6538_144423",
  x: 5.593,
  y: -0.783,
  width: 34.722,
  height: 30.754,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.4 0 0 0 0 0.933333 0 0 0 0 0.4 0 0 0 0.6 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_6538_144423"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_6538_144423",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "dnfilter3_d_6538_144423",
  x: 11.366,
  y: 7.652,
  width: 27.219,
  height: 20.243,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.4 0 0 0 0 0.933333 0 0 0 0 0.4 0 0 0 0.6 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_6538_144423"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_6538_144423",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "dnfilter4_d_6538_144423",
  x: 10.078,
  y: 5.695,
  width: 27.219,
  height: 20.243,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.4 0 0 0 0 0.933333 0 0 0 0 0.4 0 0 0 0.6 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_6538_144423"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_6538_144423",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "dnfilter5_d_6538_144423",
  x: 8.79,
  y: 3.739,
  width: 27.219,
  height: 20.243,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.4 0 0 0 0 0.933333 0 0 0 0 0.4 0 0 0 0.6 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_6538_144423"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_6538_144423",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "dnfilter6_d_6538_144423",
  x: 7.502,
  y: 1.782,
  width: 27.219,
  height: 20.243,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.4 0 0 0 0 0.933333 0 0 0 0 0.4 0 0 0 0.6 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_6538_144423"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_6538_144423",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "dnfilter7_d_6538_144423",
  x: 17.146,
  y: 1.144,
  width: 19.85,
  height: 22.658,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.4 0 0 0 0 0.933333 0 0 0 0 0.4 0 0 0 0.6 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_6538_144423"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_6538_144423",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "dnfilter8_d_6538_144423",
  x: 19.078,
  y: -0.16,
  width: 19.85,
  height: 22.658,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.4 0 0 0 0 0.933333 0 0 0 0 0.4 0 0 0 0.6 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_6538_144423"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_6538_144423",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "dnfilter9_d_6538_144423",
  x: 15.214,
  y: 1.796,
  width: 19.85,
  height: 22.658,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.4 0 0 0 0 0.933333 0 0 0 0 0.4 0 0 0 0.6 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_6538_144423"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_6538_144423",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "dnfilter10_d_6538_144423",
  x: 13.926,
  y: 3.101,
  width: 19.85,
  height: 22.658,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.4 0 0 0 0 0.933333 0 0 0 0 0.4 0 0 0 0.6 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_6538_144423"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_6538_144423",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "dnfilter11_d_6538_144423",
  x: 10.705,
  y: 5.057,
  width: 19.85,
  height: 22.658,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.4 0 0 0 0 0.933333 0 0 0 0 0.4 0 0 0 0.6 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_6538_144423"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_6538_144423",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "dnfilter12_d_6538_144423",
  x: 6.841,
  y: 6.362,
  width: 19.85,
  height: 22.658,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.4 0 0 0 0 0.933333 0 0 0 0 0.4 0 0 0 0.6 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_6538_144423"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_6538_144423",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "dnfilter13_d_6538_144423",
  x: 8.773,
  y: 5.71,
  width: 19.85,
  height: 22.658,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.4 0 0 0 0 0.933333 0 0 0 0 0.4 0 0 0 0.6 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_6538_144423"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_6538_144423",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "dnfilter14_d_6538_144423",
  x: 11.993,
  y: 3.753,
  width: 19.85,
  height: 22.658,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.4 0 0 0 0 0.933333 0 0 0 0 0.4 0 0 0 0.6 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_6538_144423"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_6538_144423",
  result: "shape"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "dnpaint0_linear_6538_144423",
  x1: 20.25,
  y1: 17.193,
  x2: 37.012,
  y2: 21.311,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EAEAEA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.605,
  stopColor: "#D3D3DB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B6B6C4"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "dnpaint1_linear_6538_144423",
  x1: 29.263,
  y1: 13.284,
  x2: 6.352,
  y2: 14.419,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#6E6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#87FC87"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "dnclip0_6538_144423"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h38v45H0z"
}))));

var _ref94 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 24 24",
  id: "icon-info",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1 12c0 6.075 4.925 11 11 11s11-4.925 11-11S18.075 1 12 1 1 5.925 1 12zm20 0a9 9 0 11-18 0 9 9 0 0118 0zm-7.996 1.998h.999v2h-4v-2h1v-2h-1v-2h3v4zm-.003-6a1 1 0 11-2 0 1 1 0 012 0z",
  fill: "currentColor"
}));

var _ref95 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 14 14",
  id: "icon-info-antialias",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M.499 7a6.5 6.5 0 1013 0 6.5 6.5 0 00-13 0zm11.375 0a4.875 4.875 0 11-9.75 0 4.875 4.875 0 019.75 0zm-4.06 2.436H6.19v-3.25h1.625v3.25zm-.002-4.875a.813.813 0 11-1.625 0 .813.813 0 011.625 0z",
  fill: "#1641F7"
}));

var _ref96 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 13 12",
  id: "icon-info-thick",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M.73 6c0 3.314 2.702 6 6.035 6s6.036-2.686 6.036-6-2.703-6-6.036-6C3.432 0 .73 2.686.73 6zm10.562 0c0 2.485-2.027 4.5-4.527 4.5S2.238 8.485 2.238 6s2.027-4.5 4.527-4.5 4.527 2.015 4.527 4.5zm-3.77 2.249h-1.51v-3h1.51v3zm-.002-4.5c0 .414-.338.75-.755.75a.752.752 0 01-.754-.75c0-.415.338-.75.754-.75.417 0 .755.335.755.75z",
  fill: "currentcolor"
}));

var _ref97 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 63 27",
  id: "icon-landing-logo-dark",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FC1355",
  d: "M34.557 16h15.246v4H34.557zM58.008 9v-.5h-.316l-.136.286.452.214zM62 9l.447.225.366-.725H62V9zm-3.992.5H62v-1h-3.992v1zm3.546-.725l-4.547 9 .893.45 4.547-9-.893-.45zm-6.956 8.57l3.861-8.13-.903-.43-3.86 8.13.902.43z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.804 27l4.093-8.988L49.901 9h3.985l4.05 9.014L53.896 27h-4.093z",
  fill: "#FC1355"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.226 20l-3.244-1.299-2.106-1.92-1.302-2.455L0 11.987V8.015l.572-2.393L1.85 3.216 4.043 1.27 7.226 0h3.362l3.19 1.068 1.449 1.013 1.727 1.902-3.026 2.382-1.332-1.534-.825-.564-1.84-.566H8.005l-1.671.7-1.166 1.062-.775 1.363-.378 1.603v3.114l.378 1.605.803 1.415 1.11 1.01 1.7.726H9.97l1.338-.551 1.084-.842.729-1.092.171-.668v-.53H8.466V8.941h8.813v4.46l-.344 1.699-1.353 2.076-2.155 1.715L10.718 20H7.226zM23.283 20l-3.134-.93-1.733-1.179-1.137-1.387 2.737-2.555.972 1.187.935.59 2.032.573h1.993l1.619-.618.385-.461.263-.5v-1.1l-.407-.79-.898-.469c-.858-.215-1.727-.46-2.58-.7-.854-.24-1.755-.483-2.638-.709l-.07-.02-2.303-1.563L18.302 7.8l-.405-2.46.824-2.517 1.93-1.962L23.363 0h2.994l3.178.79 1.867 1.578 1.123 1.57-2.812 2.275-.98-1.142-1.272-.997-1.653-.38h-1.894l-1.171.371-.719.717-.237.843.18.833.138.252 1.08.744 5.481 1.475 2.367 1.584.951 2.281v2.822l-.775 1.59-1.468 1.654L26.563 20h-3.28z",
  fill: "#FBF9F9"
}));

var _ref98 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 63 27",
  id: "icon-landing-logo-white",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FC1355",
  d: "M34.557 16h15.246v4H34.557zM58.008 9v-.5h-.316l-.136.286.452.214zM62 9l.447.225.366-.725H62V9zm-3.992.5H62v-1h-3.992v1zm3.546-.725l-4.547 9 .893.45 4.547-9-.893-.45zm-6.956 8.57l3.861-8.13-.903-.43-3.86 8.13.902.43z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.804 27l4.093-8.988L49.901 9h3.985l4.05 9.014L53.896 27h-4.093z",
  fill: "#FC1355"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.226 20l-3.244-1.299-2.106-1.92-1.302-2.455L0 11.987V8.015l.572-2.393L1.85 3.216 4.043 1.27 7.226 0h3.362l3.19 1.068 1.449 1.013 1.727 1.902-3.026 2.382-1.332-1.534-.825-.564-1.84-.566H8.005l-1.671.7-1.166 1.062-.775 1.363-.378 1.603v3.114l.378 1.605.803 1.415 1.11 1.01 1.7.726H9.97l1.338-.551 1.084-.842.729-1.092.171-.668v-.53H8.466V8.941h8.813v4.46l-.344 1.699-1.353 2.076-2.155 1.715L10.718 20H7.226zM23.283 20l-3.134-.93-1.733-1.179-1.137-1.387 2.737-2.555.972 1.187.935.59 2.032.573h1.993l1.619-.618.385-.461.263-.5v-1.1l-.407-.79-.898-.469c-.858-.215-1.727-.46-2.58-.7a123.48 123.48 0 00-2.638-.709l-.07-.02-2.303-1.563L18.302 7.8l-.405-2.46.824-2.517 1.93-1.962L23.363 0h2.994l3.178.79 1.867 1.578 1.123 1.57-2.812 2.275-.98-1.142-1.272-.997-1.653-.38h-1.894l-1.171.371-.719.717-.237.843.18.833.138.252 1.08.744 5.481 1.475 2.367 1.584.951 2.281v2.822l-.775 1.59-1.468 1.654L26.563 20h-3.28z",
  fill: "#34363F"
}));

var _ref99 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 24 24",
  id: "icon-lightning",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.92 15H9v7.85L20.08 9H15V1.15L3.92 15zM11 13H8.08L13 6.85V11h2.92L11 17.15V13z",
  fill: "currentColor"
}));

var _ref100 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 14 14",
  id: "icon-lightning-no",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.792 5.617L.754 1.579 1.58.754 13.246 12.42l-.825.825L8.474 9.3l-3.224 4.03V8.75H2.286l2.506-3.132zm2.852 2.852L5.622 6.447l-.908 1.136h1.703v2.42L7.644 8.47zM6.25 3.795L8.75.67v4.58h2.964L9.932 7.477l-.83-.83.184-.23h-.415L7.583 5.128V3.996l-.503.63-.83-.83z",
  fill: "currentColor"
}));

var _ref101 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 18 19",
  id: "icon-linkedin",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.028 18.938H.296V6.461h3.732v12.476zM2.163 4.757c-.428 0-.846-.132-1.202-.38A2.232 2.232 0 01.165 3.37 2.33 2.33 0 01.042 2.07C.125 1.634.33 1.234.634.92A2.14 2.14 0 011.74.303c.42-.087.855-.042 1.25.128s.733.458.97.828c.238.37.365.804.365 1.249-.003 1.241-.971 2.248-2.163 2.248zM18 18.937h-3.729V12.87c0-1.448-.025-3.307-1.94-3.307-1.94 0-2.238 1.575-2.238 3.202v6.172H6.367V6.463h3.578v1.706h.05c.497-.98 1.714-2.016 3.53-2.016 3.78 0 4.475 2.585 4.475 5.943v6.842z",
  fill: "currentColor"
}));

var _ref102 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 17 17",
  id: "icon-linkedin-outline",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.288.735h12.424c.858 0 1.553.695 1.553 1.553v12.424c0 .858-.695 1.553-1.553 1.553H2.288a1.553 1.553 0 01-1.553-1.553V2.288c0-.858.695-1.553 1.553-1.553zm0 1.553v12.424h12.424V2.288H2.288zM9.277 6.17c-.403 0-.827.123-1.202.352l-.351-.352h-.777v5.436H8.5V8.5c0-.447.461-.777.777-.777h.776c.315 0 .777.33.777.777v3.106h1.553V8.5c0-1.439-1.247-2.33-2.33-2.33h-.776zm-3.883-.776a.777.777 0 100-1.553.777.777 0 000 1.553zm-.777.776v5.436H6.17V6.17H4.617z",
  fill: "currentColor"
}));

var _ref103 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 15 15",
  id: "icon-list",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.981 3.821c0 .64.525 1.158 1.172 1.158.648 0 1.172-.519 1.172-1.158 0-.64-.524-1.158-1.172-1.158-.647 0-1.172.519-1.172 1.158zm11.72-.579V4.4H5.496V3.242H13.7zm0 3.473H5.496v1.158H13.7V6.715zm-8.204 4.63H13.7v-1.157H5.497v1.157zm-3.516-.578c0 .639.525 1.157 1.172 1.157.648 0 1.172-.518 1.172-1.157 0-.64-.524-1.158-1.172-1.158-.647 0-1.172.518-1.172 1.158zM3.153 8.45a1.165 1.165 0 01-1.172-1.157c0-.64.525-1.158 1.172-1.158.648 0 1.172.518 1.172 1.158 0 .64-.524 1.157-1.172 1.157z",
  fill: "currentColor"
}));

var _ref104 = /*#__PURE__*/React.createElement("symbol", {
  viewBox: "0 0 26 26",
  id: "icon-locate",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "nonzero",
  d: "M2.107 1.265l7.145 7.146-.842.842-7.146-7.146zM17.59 16.747l7.145 7.146-.843.842-7.145-7.146zM8.41 16.747l.842.842-7.145 7.146-.843-.842zM23.892 1.265l.843.842-7.146 7.146-.842-.842z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.09 13C1.09 6.423 6.424 1.09 13 1.09S24.91 6.424 24.91 13 19.576 24.91 13 24.91 1.09 19.576 1.09 13zm22.628 0c0-5.92-4.799-10.718-10.718-10.718C7.08 2.282 2.28 7.08 2.28 13S7.08 23.718 13 23.718c5.92 0 10.718-4.798 10.718-10.718z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.236 13a4.764 4.764 0 119.527 0 4.764 4.764 0 01-9.527 0zm8.336 0a3.573 3.573 0 10-7.145 0 3.573 3.573 0 007.145 0z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.88 13a1.88 1.88 0 11-3.76 0 1.88 1.88 0 013.76 0z",
  fill: "currentColor",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: 0.2,
  d: "M2.107 1.265l7.145 7.146-.842.842-7.146-7.146zM17.59 16.747l7.145 7.146-.843.842-7.145-7.146zM8.41 16.747l.842.842-7.145 7.146-.843-.842zM23.892 1.265l.843.842-7.146 7.146-.842-.842z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.09 13C1.09 6.423 6.424 1.09 13 1.09S24.91 6.424 24.91 13 19.576 24.91 13 24.91 1.09 19.576 1.09 13zm22.628 0c0-5.92-4.799-10.718-10.718-10.718C7.08 2.282 2.28 7.08 2.28 13S7.08 23.718 13 23.718c5.92 0 10.718-4.798 10.718-10.718z",
  stroke: "currentColor",
  strokeWidth: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.236 13a4.764 4.764 0 119.527 0 4.764 4.764 0 01-9.527 0zm8.336 0a3.573 3.573 0 10-7.145 0 3.573 3.573 0 007.145 0z",
  stroke: "currentColor",
  strokeWidth: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.88 13a1.88 1.88 0 11-3.76 0 1.88 1.88 0 013.76 0z",
  stroke: "currentColor",
  strokeWidth: 0.2
})));

var _ref105 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 24 24",
  id: "icon-location",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1 13h2.055A9.004 9.004 0 0011 20.945V23h2v-2.055A9.004 9.004 0 0020.945 13H23v-2h-2.055A9.004 9.004 0 0013 3.055V1h-2v2.055A9.004 9.004 0 003.055 11H1v2zm4-1a7 7 0 1114 0 7 7 0 01-14 0zm7-4a4 4 0 110 8 4 4 0 010-8zm-2 4a2 2 0 114 0 2 2 0 01-4 0z",
  fill: "currentColor"
}));

var _ref106 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 10 12",
  id: "icon-lock",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2 3v1.5c-.801 0-1.5.582-1.5 1.375v4.75C.5 11.418 1.199 12 2 12h6c.801 0 1.5-.582 1.5-1.375v-4.75C9.5 5.082 8.801 4.5 8 4.5V3a3 3 0 00-6 0zm4.5 0v1.5h-3V3a1.5 1.5 0 113 0zM2 10.5V6h6v4.5H2zm3.75-2.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0z",
  fill: "currentColor"
}));

var _ref107 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 25 17",
  id: "icon-logo-minimal",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.102 6.495H0v3.361h14.102v-3.36z",
  fill: "#34363F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.277 8.175L20.928 0h3.492l-3.568 8.176-3.575-.001z",
  fill: "#A0A0AC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.277 8.175L20.928 0h3.492l-3.568 8.176-3.575-.001z",
  fill: "url(#ebpaint0_linear_6743:220803)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.658 16.32l3.62-8.145L13.745.008h3.527l3.582 8.168-3.573 8.144h-3.622z",
  fill: "#34363F"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "ebpaint0_linear_6743:220803",
  x1: 20.218,
  y1: 4.407,
  x2: 16.178,
  y2: 6.333,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.798
}))));

var _ref108 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 14 14",
  id: "icon-map",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.885.88a.893.893 0 00-.906-.88H.906C.406 0 0 .394 0 .88v12.24c0 .486.405.88.906.88h12.073c.5 0 .906-.394.906-.88V.88zM2.479.88h8.724l-.023.01-.162.064-.255.1-.27.106-.239.092-.356.135-.5.189-1.319.49-.416.157-.334.127-.264.1-.202.079-.243.095-.232.091-.178.072-.215.087-.167.069-.162.068-.157.066-.192.083-.15.066-.11.05-.145.065-.108.05-.142.066-.141.067-.106.05-.018.01-.02-.026-.083-.102-.121-.149-.117-.145-.075-.095-.074-.094-.107-.137-.07-.09-.068-.09-.067-.088-.065-.087-.095-.129-.062-.085-.06-.084-.06-.083-.057-.083-.057-.082-.056-.082-.027-.04-.054-.081-.054-.08-.052-.081-.026-.04-.05-.08-.05-.08-.05-.08-.048-.08-.048-.081-.048-.08L2.53.969 2.484.888 2.479.88zm10.497.196l.004-.002v5.303h-.003l-.14.001H12.63l-.102-.002h-.068l-.138-.004-.14-.003-.11-.004-.15-.006-.199-.008-.258-.013-.335-.019-.74-.043-.277-.015-.296-.014-.17-.007c-1.03-.036-1.856 0-2.75.146a1.644 1.644 0 00-.102.02l-.098-.118-.17-.201-.13-.154-.23-.268-.794-.922-.209-.244-.182-.215.077-.037.138-.064.14-.064.178-.08.108-.048.148-.065.113-.048.154-.065.198-.083.164-.068.213-.086.222-.088.232-.091.293-.114.31-.119L8 3.04l.47-.177 1.35-.503.43-.162.394-.15.275-.106.26-.102.206-.081.197-.08.153-.062.184-.076.144-.06.14-.06.138-.06.135-.058.134-.06.166-.075.1-.046.1-.046zM1.456.88h-.55v11.465l.009-.01.269-.299 1.437-1.611.387-.432.18-.2.216-.238.211-.231.138-.15.136-.148.135-.145.133-.143.133-.141.13-.139.131-.137.13-.136.065-.068.13-.134.13-.134.083-.084.036-.038.038-.04.061-.068.246-.278.074-.083.047-.051.045-.048.043-.046.042-.043.041-.041.02-.02.04-.038.04-.037.04-.036.039-.034.02-.017.022-.019-.03-.035-.166-.197-.295-.345-.763-.886-.217-.253-.156-.184-.151-.178-.146-.173-.14-.169-.092-.11-.133-.16-.086-.106-.126-.155-.121-.15-.118-.148-.076-.097-.074-.095-.073-.094-.07-.093-.07-.092-.068-.09-.067-.09-.065-.089-.064-.088-.063-.087-.061-.087-.06-.086-.06-.085-.057-.085-.057-.085-.056-.084-.055-.084-.054-.084L2.04 1.9l-.052-.084-.052-.084-.05-.084-.05-.084-.05-.085-.05-.085-.048-.085-.048-.086-.047-.087-.047-.087-.047-.088L1.456.88zm11.382 6.378l.142-.001v5.864H1.41l.133-.148.213-.236.282-.314 1.387-1.557.372-.413.214-.237.21-.231.138-.15.136-.147.133-.145.133-.142.13-.14.13-.138.13-.136.192-.202.128-.133.128-.132.152-.155.048-.051.05-.054.053-.058.028-.03.143-.163.103-.116.045-.05.044-.048.043-.045.041-.043.04-.04.04-.04.037-.035.037-.035.036-.032.017-.015.035-.03.034-.026a.9.9 0 01.421-.2c.528-.086 1.032-.131 1.58-.143l-.073.66-.03.283-.006.09-.002.045v.161l.005.367.003.679v1.161l-.002.387-.002.252a.446.446 0 00.449.444.447.447 0 00.456-.436l.001-.09.002-.355.002-.33v-.928l-.005-.96-.002-.168v.003-.043l-.001-.087v-.035l.003-.048.007-.087.023-.214.083-.745.083.002.16.007.082.003.137.007.235.012.899.052.337.019.176.008.167.008.234.01.15.004.144.004.142.002.106.002h.249z",
  fill: "currentColor"
}));

var _ref109 = /*#__PURE__*/React.createElement("symbol", {
  viewBox: "0 0 22 23",
  id: "icon-market",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M7.402 2.633v3.05h2.692V.06H1.3v5.624h2.692V2.633z"
}), /*#__PURE__*/React.createElement("path", {
  fillOpacity: 0.68,
  fill: "currentColor",
  d: "M10.034 5.624V0h2.454v5.624z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M7.402 8.257v3.11h2.692V5.685H1.3v5.684h2.692V8.316h3.41z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#85FC99",
  d: "M10.034 11.248V5.624h2.454v5.624z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M7.402 13.88v3.052h2.692v-5.564H1.3v5.624h2.692v-3.051h3.41z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#85FC99",
  d: "M10.034 16.872v-5.624h2.454v5.624z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M7.402 19.505v3.051h2.692v-5.624H1.299v5.624H3.99v-3.05z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#85FC99",
  d: "M10.034 22.556v-5.624h2.453v5.624z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M16.017 8.257v3.11h2.693V5.685H9.915v5.684h2.692V8.316h3.41z"
}), /*#__PURE__*/React.createElement("path", {
  fillOpacity: 0.68,
  fill: "currentColor",
  d: "M18.71 11.248V5.624h2.453v5.624z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M16.017 13.88v3.051h2.692v-5.564H9.914v5.624h2.693V13.94h3.41z"
}), /*#__PURE__*/React.createElement("path", {
  fillOpacity: 0.68,
  fill: "currentColor",
  d: "M18.71 16.872v-5.624h2.453v5.624z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M16.017 19.506v3.05h2.692v-5.623H9.914v5.624h2.693v-3.051z"
}), /*#__PURE__*/React.createElement("path", {
  fillOpacity: 0.68,
  fill: "currentColor",
  d: "M18.71 22.555v-5.624h2.453v5.624z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M22 21.835H.521V23h21.48z"
})));

var _ref110 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 17 16",
  id: "icon-market-list",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.19.334a7.738 7.738 0 015.61 3.973l-1.925.677A5.726 5.726 0 009.19 2.378V.334z",
  fill: "#A0A0AC"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.972.08A.333.333 0 019.24.005a8.071 8.071 0 015.853 4.146.333.333 0 01-.183.472l-1.924.676a.333.333 0 01-.396-.14 5.392 5.392 0 00-3.47-2.454.333.333 0 01-.264-.326V.334c0-.097.043-.19.116-.253zm.55.653v1.38a6.065 6.065 0 013.49 2.47l1.3-.458A7.414 7.414 0 009.522.733z",
  fill: "#A0A0AC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.85.333v2.044a5.649 5.649 0 00-4.512 5.554 5.688 5.688 0 005.682 5.682A5.688 5.688 0 0013.7 7.931c0-.242-.017-.487-.051-.74l1.925-.677c.088.47.132.945.132 1.417 0 4.24-3.448 7.687-7.687 7.687-4.238 0-7.687-3.448-7.687-7.687A7.662 7.662 0 016.85.333z",
  fill: "#A0A0AC"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.067.08a.333.333 0 01.116.253v2.044c0 .158-.11.295-.265.327A5.315 5.315 0 002.672 7.93c0 2.95 2.399 5.349 5.348 5.349s5.348-2.4 5.348-5.349c0-.226-.016-.456-.048-.695a.333.333 0 01.22-.36l1.924-.676a.333.333 0 01.438.253c.092.49.138.985.138 1.478 0 4.423-3.597 8.02-8.02 8.02S0 12.355 0 7.932A7.995 7.995 0 016.8.004a.333.333 0 01.267.077zm-.55.651a7.328 7.328 0 00-5.85 7.2c0 4.055 3.299 7.354 7.353 7.354 4.055 0 7.354-3.299 7.354-7.354 0-.323-.022-.647-.065-.97l-1.298.456c.016.173.024.344.024.514a6.021 6.021 0 01-6.015 6.015 6.021 6.021 0 01-6.015-6.015 5.98 5.98 0 014.512-5.818V.73z",
  fill: "#A0A0AC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.247 6.803a.335.335 0 00-.334.334v2.952c0 .183.15.334.334.334H8.45c.187 0 .333-.15.333-.334V7.137a.333.333 0 00-.333-.334H7.247zM9.827 5.667A.333.333 0 009.493 6v4.088c0 .183.147.334.334.334h1.203c.187 0 .333-.15.333-.334V6a.333.333 0 00-.333-.334H9.827zM4.667 8.013a.335.335 0 00-.334.334v1.742c0 .183.15.334.334.334h1.206c.184 0 .334-.15.334-.334V8.347a.335.335 0 00-.334-.334H4.667z",
  fill: "#A0A0AC"
}));

var _ref111 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 33 32",
  id: "icon-markets",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#efclip0)",
  fill: "currentColor",
  stroke: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.493 7.828a.604.604 0 00-.604.602v3.011h-1.815a.604.604 0 00-.605.602V27.7c0 .333.27.602.605.602h1.815v2.409a.604.604 0 001.21 0V28.3h1.814c.334 0 .605-.27.605-.602V12.043a.604.604 0 00-.605-.602h-1.815v-3.01a.604.604 0 00-.605-.603zm1.815 4.817v14.452h-3.63V12.645h3.63zM27.544 5.42a.604.604 0 00-.605.602v3.01h-1.814a.604.604 0 00-.605.603v15.656c0 .332.27.602.605.602h1.814v2.409c0 .332.271.602.605.602.334 0 .605-.27.605-.602v-2.409h1.815c.334 0 .605-.27.605-.602V9.635a.604.604 0 00-.605-.602h-1.815v-3.01a.604.604 0 00-.605-.603zm1.815 4.817V24.69h-3.63V10.237h3.63zM5.443 0a.604.604 0 00-.605.602v3.01H3.023a.604.604 0 00-.605.603v15.656c0 .332.27.602.605.602h1.815v2.409c0 .332.27.602.605.602.334 0 .605-.27.605-.602v-2.409h1.814c.334 0 .605-.27.605-.602V4.215a.604.604 0 00-.605-.602H6.048V.603A.604.604 0 005.443 0zm1.814 4.817V19.27h-3.63V4.817h3.63z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "efclip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h33v32H0z"
}))));

var _ref112 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 16 14",
  id: "icon-medium",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16 1.036l-1.275 1.27a.392.392 0 00-.144.37v9.34a.386.386 0 00.144.37l1.25 1.27v.281H9.7v-.269l1.29-1.302c.129-.133.129-.172.129-.37V4.44l-3.594 9.466h-.484L2.859 4.439v6.346a.885.885 0 00.235.727l1.681 2.114v.282H0v-.282l1.681-2.114a.878.878 0 00.219-.727V3.448a.643.643 0 00-.203-.542L.203 1.036V.754h4.64l3.582 8.165L11.578.76H16v.276z",
  fill: "currentColor"
}));

var _ref113 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 19 16",
  id: "icon-medium-outline",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M.554 1.511c0-.343.278-.62.621-.62H6.13c.241 0 .46.139.563.357l3.225 6.896 2.828-6.863a.621.621 0 01.574-.384h4.722c.343 0 .62.278.62.62v.277a.621.621 0 01-.196.454l-1.318 1.23v9.268l1.295 1.233c.123.118.193.28.193.45v.283a.621.621 0 01-.621.621h-5.923a.621.621 0 01-.622-.62v-.27c0-.171.07-.335.195-.452l1.32-1.25V6.145h1.243v6.643c0 .072.002.234-.05.388a1.018 1.018 0 01-.275.409l-.006.006-.53.5h3.392l-.482-.457a.996.996 0 01-.371-.884V3.475c-.035-.337.104-.67.371-.884l.485-.452h-3.026l-3.208 7.784a.621.621 0 01-1.137.027L5.735 2.133H2.28l.938 1.101c.271.257.421.62.39 1.005v7.272a1.449 1.449 0 01-.395 1.19l-1.153 1.36h3.07l-.875-1.458 1.066-.639 1.268 2.117a.621.621 0 01.089.319v.283a.621.621 0 01-.621.621H.958a.621.621 0 01-.62-.621V14.4c0-.147.051-.29.147-.402l1.795-2.116a.642.642 0 01.033-.036.223.223 0 00.054-.089.206.206 0 00.008-.098.621.621 0 01-.01-.103V4.209a.62.62 0 01.004-.066.622.622 0 01-.072-.073L.702 2.196a.621.621 0 01-.148-.403v-.283zm5.011 3.976l4.248 8.926-1.122.534L4.443 6.02l1.122-.534z",
  fill: "currentColor"
}));

var _ref114 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 23 27",
  id: "icon-members",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.78 26a.595.595 0 01-.431-.183.624.624 0 01-.178-.442v-5.002a.64.64 0 01.178-.442.607.607 0 01.43-.183h3.043c.322 0 .632-.132.86-.367a1.27 1.27 0 00.357-.884v-3.126a.64.64 0 01.178-.442.607.607 0 01.43-.183h1.45l-1.994-4.097a.64.64 0 01-.064-.28 8.242 8.242 0 00-2.317-5.747 7.805 7.805 0 00-5.594-2.38c-2.098 0-4.11.856-5.594 2.38a8.242 8.242 0 00-2.317 5.748c0 2.279.532 4.32 1.095 6.481.658 2.527 1.34 5.141 1.34 8.524a.634.634 0 01-.18.442.6.6 0 01-.86 0 .634.634 0 01-.178-.442c0-3.218-.66-5.751-1.298-8.2C1.552 14.931 1 12.812 1 10.37a9.511 9.511 0 012.65-6.6A9.009 9.009 0 0110.056 1 9 9 0 0116.5 3.665a9.503 9.503 0 012.753 6.555l2.372 4.872a.64.64 0 01-.027.608.597.597 0 01-.517.297h-1.826v2.5c0 .663-.258 1.3-.714 1.768a2.404 2.404 0 01-1.72.733h-2.434v4.377a.64.64 0 01-.179.442.608.608 0 01-.43.183v0z",
  fill: "#FBF9F9",
  stroke: "#FBF9F9",
  strokeWidth: 0.7
}));

var _ref115 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 10 2",
  id: "icon-minimize",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("rect", {
  width: 10,
  height: 2,
  rx: 1,
  fill: "#A0A0AC"
}));

var _ref116 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 17 17",
  id: "icon-minus",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.26 8.13a.74.74 0 010 1.479H.74a.74.74 0 010-1.479h15.52z",
  fill: "currentColor"
}));

var _ref117 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 15 3",
  id: "icon-minus-thick",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M.375 2.688V.312h14.25v2.376H.375z",
  fill: "currentColor"
}));

var _ref118 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 892 799",
  id: "icon-mkt-maker-3d",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.04,
  filter: "url(#emfilter0_f)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M443.882 283.34L71.685 501.775l-30.013 17.641 54.826 32.663 245.479 145.965 54.651 32.519h.088l45.869 27.294 347.284-203.928 54.832-32.23-30.019-17.883-17.053-10.126-54.638-32.526L443.882 283.34z",
  fill: "#211E21"
})), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3 376.804l45.734 25.972 46.921 26.565 25.466 14.841 72.394 42.001 80.925 46.972 60.353 35.099 38.754 22.484 26.728 15.509 45.585 26.566v-5.178l.149-.074v-2.003L3 368.213v8.591z",
  fill: "#E4E4E4"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M446.01 628.329v5.946l47.026-27.072 26.23-14.921 180.692-103.669 72.578-41.628 26.386-15.118 47.019-26.958 46.051-26.429v-5.832L446.01 628.329z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M448.265 114.004L36.225 350.768 3 369.89l60.695 35.404 271.757 158.213 60.501 35.247h.097l50.779 29.585 384.459-221.041 60.702-34.934-33.233-19.383-18.878-10.977-60.486-35.255-331.128-192.745z",
  fill: "url(#empaint0_linear)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M395.911 578.731a.176.176 0 00.09.024c.032 0 .063.009.09.025l44.737 26.064a12.003 12.003 0 0012.022.034l421.188-242.182c7.993-4.6 8.026-16.121.06-20.766L454.263 97.496a12.001 12.001 0 00-12.016-.033L20.95 339.56c-7.992 4.599-8.026 16.12-.06 20.766L395.91 578.731zM65.71 381.84l271.754 158.211h.001l60.066 34.994c.197.078.389.171.574.279l44.737 26.063a7.997 7.997 0 008.014.023l378.437-217.577.001-.001 42.749-24.603c5.328-3.066 5.35-10.747.04-13.844l-15.34-8.947-.002-.001-79.361-46.23-.001-.001L452.25 100.953a8 8 0 00-8.01-.022L38.22 334.236l-.002.001-15.273 8.79c-5.328 3.066-5.35 10.746-.04 13.844L65.71 381.84z",
  fill: "#5DE273"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M395.911 558.731a.176.176 0 00.09.024c.032 0 .063.009.09.025l44.737 26.064a12.003 12.003 0 0012.022.034l421.188-242.182c7.993-4.6 8.026-16.121.06-20.766L454.263 77.496a12.001 12.001 0 00-12.016-.033L20.95 319.56c-7.992 4.599-8.026 16.12-.06 20.766L395.91 558.731zM64.701 363.566v.001l271.757 158.212 60.22 35.084c.145.048.286.111.42.189l44.737 26.063a9.996 9.996 0 0010.018.029L830.29 365.566l42.751-24.603c6.66-3.834 6.688-13.434.05-17.306l-94.705-55.178-325.13-189.254a9.998 9.998 0 00-10.012-.028L37.223 312.502l-.001.001-15.274 8.79c-6.66 3.833-6.689 13.434-.051 17.305L64.7 363.566z",
  fill: "#5DE273"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M335.955 490.644l60.325 35.145c.11.027.216.069.315.127l44.736 26.063a11 11 0 0011.021.032l421.187-242.182c7.327-4.216 7.357-14.777.055-19.036l-15.341-8.947L453.759 46.36a11 11 0 00-11.014-.03L21.449 288.427c-7.326 4.216-7.357 14.776-.056 19.035l314.562 183.182zM20.889 308.326c-7.965-4.646-7.931-16.167.06-20.766L442.248 45.463a12.001 12.001 0 0112.016.033L874.098 289.93c7.966 4.645 7.933 16.166-.06 20.766L452.85 552.878a12.003 12.003 0 01-12.022-.034l-44.737-26.064a.177.177 0 00-.09-.025.176.176 0 01-.09-.024L20.889 308.326z",
  fill: "#5DE273"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.95 257.56c-7.992 4.599-8.026 16.12-.06 20.766L335.45 461.508l60.46 35.223a.176.176 0 00.09.024c.032 0 .063.009.09.025l44.737 26.064a12.003 12.003 0 0012.022.034l421.188-242.182c7.993-4.6 8.026-16.121.06-20.766L454.263 15.496a12.001 12.001 0 00-12.016-.033L20.95 257.56zM396.1 496.263a.666.666 0 01.243.085l44.737 26.063a11.5 11.5 0 0011.521.034l421.188-242.182c7.659-4.408 7.691-15.449.057-19.901L454.011 15.928a11.5 11.5 0 00-11.515-.032L36.475 249.202l-15.276 8.791c-7.659 4.408-7.691 15.448-.058 19.901l314.562 183.182 60.397 35.187z",
  fill: "#5DE273"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.065,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M836.966 342.382l-445.362 256.18-.499-.867 445.363-256.179.498.866zM777.488 306.695l-445.362 256.18-.499-.867 445.362-256.18.499.867zM722.425 276.937l-445.362 256.18-.499-.867 445.363-256.18.498.867zM668.952 244.273L223.59 500.453l-.498-.867 445.362-256.18.498.867zM613.931 214.533L168.569 470.712l-.499-.866 445.362-256.18.499.867zM560.458 178.865L115.096 435.044l-.498-.866 445.362-256.18.498.867zM499.427 143.177L54.065 399.357l-.499-.867 445.362-256.179.499.866z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.065,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M53.542 342.382l445.362 256.18.498-.867L54.04 341.516l-.498.866zM113.02 306.695l445.362 256.18.499-.867-445.362-256.18-.499.867zM168.083 276.937l445.362 256.18.498-.867-445.362-256.18-.498.867zM221.555 244.273l445.362 256.18.499-.867-445.362-256.18-.499.867zM276.618 214.533L721.98 470.712l.499-.866-445.363-256.18-.498.867zM330.13 178.865l445.362 256.179.498-.866-445.362-256.18-.498.867zM391.081 143.177l445.362 256.18.498-.867-445.362-256.179-.498.866z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M498.844 332.429l63.078 36.43V72.851L498.844 36.42v296.009z",
  fill: "#59D76D"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M618.081 272.415l-49.249 28.45v-7.991l42.339-24.444 6.91 3.985z",
  fill: "#85FC99"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M625 146.42v86.66l-6.92-3.995v-70.688l-6.91 3.985-42.339 24.454v70.698l-6.909 3.996v-78.679L625 146.42z",
  fill: "#5DE273"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M561.922 72.977v295.881l63.077-36.43V36.633l-63.077 36.344z",
  fill: "#5DE273"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M561.922 0l-63.078 36.42 63.078 36.431 63.077-36.43L561.922 0z",
  fill: "#85FC99"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M483.078 296L420 332.431l63.078 36.43h78.845l-63.078-36.43V296h-15.767z",
  fill: "#5DE273"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M401.844 388.429l63.078 36.43V178.851l-63.078-36.431v246.009z",
  fill: "#59D76D"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M521.081 328.415l-49.249 28.45v-7.991l42.339-24.444 6.91 3.985z",
  fill: "#F9FAFB"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M528 202.42v86.66l-6.92-3.995v-70.688l-6.91 3.985-42.339 24.454v70.698l-6.909 3.996v-78.679L528 202.42z",
  fill: "#CFD2D3"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M464.922 178.977v245.881l63.077-36.43V142.633l-63.077 36.344z",
  fill: "#5DE273"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M464.922 106l-63.078 36.421 63.078 36.43 63.077-36.43L464.922 106z",
  fill: "#85FC99"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M386.078 352L323 388.431l63.078 36.43h78.845l-63.078-36.43V352h-15.767z",
  fill: "#CED1D5"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M296.844 449.429l63.078 36.43V299.851l-63.078-36.431v186.009z",
  fill: "#59D76D"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M416.081 389.415l-49.249 28.45v-7.991l42.339-24.444 6.91 3.985z",
  fill: "#F9FAFB"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M423 263.42v86.66l-6.92-3.995v-70.688l-6.91 3.985-42.339 24.454v70.698l-6.909 3.996v-78.679L423 263.42z",
  fill: "#CFD2D3"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M359.922 299.977v185.881l63.077-36.43V263.633l-63.077 36.344z",
  fill: "#5DE273"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M359.922 227l-63.078 36.421 63.078 36.43 63.077-36.43L359.922 227z",
  fill: "#85FC99"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M281.078 413L218 449.431l63.078 36.43h78.845l-63.078-36.43V413h-15.767z",
  fill: "#CED1D5"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "empaint0_linear",
  x1: 844.991,
  y1: 371.001,
  x2: -29,
  y2: 371.001,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F2F2F2"
})), /*#__PURE__*/React.createElement("filter", {
  id: "emfilter0_f",
  x: 0.89,
  y: 242.558,
  width: 884.594,
  height: 556.081,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 20.391,
  result: "effect1_foregroundBlur"
}))));

var _ref119 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 12 20",
  id: "icon-money",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.5 9.063h-3c-.828 0-1.5-.644-1.5-1.438V6.188c0-.794.672-1.438 1.5-1.438h3c.828 0 1.5.644 1.5 1.438 0 .794.672 1.437 1.5 1.437S12 6.982 12 6.188c0-2.382-2.015-4.313-4.5-4.313V.438C7.5-.356 6.829-1 6-1 5.172-1 4.5-.356 4.5.438v1.437c-2.485 0-4.5 1.93-4.5 4.313v1.437c0 2.382 2.015 4.313 4.5 4.313h3c.828 0 1.5.643 1.5 1.437v1.438c0 .793-.672 1.437-1.5 1.437h-3c-.828 0-1.5-.644-1.5-1.438 0-.793-.672-1.437-1.5-1.437S0 14.019 0 14.813c0 2.381 2.015 4.312 4.5 4.312v1.438C4.5 21.355 5.172 22 6 22s1.5-.644 1.5-1.438v-1.437c2.485 0 4.5-1.93 4.5-4.312v-1.438c0-2.382-2.015-4.312-4.5-4.312z",
  fill: "currentColor"
}));

var _ref120 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 24 24",
  id: "icon-more-horizontal",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5 14a2 2 0 110-4 2 2 0 010 4zm7 0a2 2 0 110-4 2 2 0 010 4zm5-2a2 2 0 104 0 2 2 0 00-4 0z",
  fill: "currentColor"
}));

var _ref121 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 38 38",
  id: "icon-move-to-collaboration",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M26.454 27.312a4.02 4.02 0 004.007-4.007 4.02 4.02 0 00-4.007-4.008 4.02 4.02 0 00-4.007 4.008 4.01 4.01 0 004.007 4.007zM19.048 8.546c-2.149 0-3.906 1.803-3.906 4.007 0 2.204 1.757 4.008 3.906 4.008 2.148 0 3.906-1.804 3.906-4.008 0-2.204-1.758-4.007-3.906-4.007zM11.54 27.312a4.02 4.02 0 004.008-4.007 4.02 4.02 0 00-4.008-4.008 4.02 4.02 0 00-4.007 4.008 4.02 4.02 0 004.007 4.007z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19 2.375C9.818 2.375 2.375 9.818 2.375 19S9.818 35.625 19 35.625 35.625 28.182 35.625 19 28.182 2.375 19 2.375zM0 19C0 8.507 8.507 0 19 0s19 8.507 19 19-8.507 19-19 19S0 29.493 0 19z",
  fill: "currentColor"
}));

var _ref122 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 892 812",
  id: "icon-multi-party-house-3d",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.04,
  filter: "url(#eqfilter0_f)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M443.882 296.34L71.685 514.775l-30.013 17.641 54.826 32.663 245.479 145.965 54.651 32.519h.088l45.869 27.294 347.284-203.928 54.832-32.23-30.019-17.883-17.053-10.127-54.637-32.525-299.11-177.824z",
  fill: "#211E21"
})), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3 375.804l45.734 25.972 46.921 26.565 25.466 14.841 72.394 42.001 80.925 46.972 60.353 35.099 38.754 22.484 26.728 15.509 45.585 26.566v-5.178l.149-.074v-2.003L3 367.213v8.591z",
  fill: "#E4E4E4"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M446.01 627.331v5.946l47.026-27.072 26.23-14.921 180.692-103.669 72.578-41.628 26.386-15.118 47.019-26.958 46.051-26.429v-5.832L446.01 627.331z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M448.265 113.006L36.225 349.77 3 368.892l60.695 35.404 271.757 158.213 60.501 35.247h.097l50.779 29.585L831.288 406.3l60.702-34.934-33.233-19.383-18.878-10.977-60.486-35.255-331.128-192.745z",
  fill: "url(#eqpaint0_linear)"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.065,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M836.966 341.384l-445.362 256.18-.499-.867 445.363-256.179.498.866zM777.488 305.697L332.126 561.876l-.499-.866 445.362-256.18.499.867zM722.425 275.937l-445.362 256.18-.499-.867 445.363-256.18.498.867zM668.952 243.273L223.59 499.453l-.498-.867 445.362-256.18.498.867zM613.931 213.535L168.569 469.714l-.499-.866 445.362-256.18.499.867zM560.458 177.867L115.096 434.046l-.498-.866L559.96 177l.498.867zM499.427 142.179L54.065 398.359l-.499-.867 445.362-256.18.499.867z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.065,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M53.542 341.384l445.362 256.18.498-.867L54.04 340.518l-.498.866zM113.02 305.697l445.362 256.179.499-.866-445.362-256.18-.499.867zM168.083 275.937l445.362 256.18.498-.867-445.362-256.18-.498.867zM221.555 243.273l445.362 256.18.499-.867-445.362-256.18-.499.867zM276.618 213.535L721.98 469.714l.499-.866-445.363-256.18-.498.867zM330.13 177.867l445.362 256.179.498-.866L330.628 177l-.498.867zM391.081 142.179l445.362 256.18.498-.867-445.362-256.18-.498.867z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M362.67 385.563l109.342 63.149V126.281L362.67 63.131v322.432z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M569.357 281.534l-85.369 49.315v-13.852l73.391-42.372 11.978 6.909zM566.078 332.43l-13.384 7.725-11.977 6.908-12.185 7.03-.851.486-13.661 7.899-13.383-13.384 8.766-5.068 43.291-24.979 13.384 13.383z",
  fill: "#F9FAFB"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M581.352 63.13v150.22l-11.995-6.926V83.891l-11.977 6.91-73.391 42.388v122.55l-11.977 6.926V126.281l109.34-63.15zM569.357 238.727v42.806l-85.37 49.315v-47.441l14.652-8.453-14.652-8.454-11.975 6.926v175.285l28.624-16.525v-83.095l8.766-5.068 43.291-24.979 13.384 13.383-13.384 7.725v61.952l13.384-7.725 15.273-8.818v-153.76l-11.993 6.926z",
  fill: "#CFD2D3"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M472.012 0L362.67 63.132l109.342 63.15 109.339-63.15L472.012 0z",
  fill: "#F9FAFB"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M557.379 90.8v108.716l-73.391 42.372V133.19l73.391-42.39z",
  fill: "#6E6"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M569.358 83.894v122.533l-11.977-6.908V90.803l11.977-6.909z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#eqfilter1_f)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M516.117 142.665v122.532L486 246.715V138l30.117 4.665z",
  fill: "url(#eqpaint1_linear)"
})), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M483.988 241.889v13.852l18.662 10.763 78.701-45.479 6.649-3.837-6.649-3.836-11.993-6.926-11.979-6.908-73.391 42.371z",
  fill: "#F9FAFB"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M581.35 221.024l-78.702 45.479v10.762l54.73-31.612 11.979-6.924 11.993-6.926 6.648-3.836v-10.779l-6.648 3.836z",
  fill: "#DBDFE0"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M502.649 266.502v10.763l-4.01-2.309-14.651-8.454V255.74l18.661 10.762z",
  fill: "#CFD2D3"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M557.379 245.654v28.971l-73.391 42.372v-33.588l14.651-8.454 4.01 2.309 54.73-31.61z",
  fill: "#6E6"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M569.358 238.729v42.805l-11.977-6.908v-28.971l11.977-6.926z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#eqfilter2_f)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M500 273v57.5L484 318v-36.345L500 273z",
  fill: "url(#eqpaint2_linear)"
})), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M552.694 340.154v61.952l-11.977-7.151v-47.892l11.977-6.909z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#eqfilter3_f)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M533.785 344v75.452L501 409.455v-47.892L533.785 344z",
  fill: "url(#eqpaint3_linear)"
})), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M335.34 322.416L226 385.566l109.34 63.149h136.673l-109.342-63.149v-63.15H335.34z",
  fill: "#CED1D5"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M540.717 361.349v33.606l-40.08 23.138v-68.999l13.383 13.383 13.661-7.898.851-.486 9.859 5.867 2.326 1.389z",
  fill: "#6E6"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#eqfilter4_f)",
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#6E6"
}, /*#__PURE__*/React.createElement("path", {
  d: "M557.379 90.8v108.716l-73.391 42.372V133.19l73.391-42.39zM557.379 245.654v28.971l-73.391 42.372v-33.588l14.651-8.454 4.01 2.309 54.73-31.61zM540.717 361.349v33.606l-40.08 23.138v-68.999l13.383 13.383 13.661-7.898.851-.486 9.859 5.867 2.326 1.389z"
})), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M483.989 255.74v10.762l-11.977 6.926v-10.762l11.977-6.926z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M552.693 402.107l-11.977-7.152-40.08 23.139v14.093l-28.624 16.527h23.468l12.95-7.481h17.566l40.081-23.139v-23.713l-13.384 7.726z",
  fill: "#CED1D5"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M540.715 347.061v14.285l-2.326-1.388-9.86-5.867 12.186-7.03z",
  fill: "#5DE273"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "eqfilter0_f",
  x: 0.89,
  y: 255.558,
  width: 884.594,
  height: 556.081,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 20.391,
  result: "effect1_foregroundBlur"
})), /*#__PURE__*/React.createElement("filter", {
  id: "eqfilter1_f",
  x: 475,
  y: 127,
  width: 52.117,
  height: 149.197,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5.5,
  result: "effect1_foregroundBlur"
})), /*#__PURE__*/React.createElement("filter", {
  id: "eqfilter2_f",
  x: 473,
  y: 262,
  width: 38,
  height: 79.5,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5.5,
  result: "effect1_foregroundBlur"
})), /*#__PURE__*/React.createElement("filter", {
  id: "eqfilter3_f",
  x: 490,
  y: 333,
  width: 54.785,
  height: 97.452,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5.5,
  result: "effect1_foregroundBlur"
})), /*#__PURE__*/React.createElement("filter", {
  id: "eqfilter4_f",
  x: 469.988,
  y: 76.801,
  width: 101.391,
  height: 355.292,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 7,
  result: "effect1_foregroundBlur"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "eqpaint0_linear",
  x1: 844.991,
  y1: 370.003,
  x2: -29,
  y2: 370.003,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F2F2F2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "eqpaint1_linear",
  x1: 485.617,
  y1: 203.697,
  x2: 516.617,
  y2: 205.197,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#85FC99"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#85FC99",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "eqpaint2_linear",
  x1: 485.117,
  y1: 296,
  x2: 510.117,
  y2: 298,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#85FC99"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#85FC99",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "eqpaint3_linear",
  x1: 501.285,
  y1: 385.5,
  x2: 525.285,
  y2: 385.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#85FC99"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#85FC99",
  stopOpacity: 0
}))));

var _ref123 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 27 27",
  id: "icon-net-energy",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("rect", {
  opacity: 0.3,
  width: 27,
  height: 27,
  rx: 5,
  fill: "#A0A0AC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.336 12.332a.287.287 0 00-.245-.135h-3.167V7.88a.288.288 0 00-.544-.13l-3.454 6.91a.288.288 0 00.256.417h3.166v4.318a.288.288 0 00.545.13l3.454-6.91a.29.29 0 00-.011-.282zm-3.412 5.841v-3.385a.288.288 0 00-.288-.288H9.648l2.7-5.4v3.385a.288.288 0 00.288.288h2.989l-2.7 5.4z",
  fill: "#000",
  stroke: "#000",
  strokeWidth: 0.3
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.663 8.622a1.436 1.436 0 00-.106-1.906l-.815-.815a.295.295 0 00-.406 0l-.204.204-.815-.814-.406.406.815.814-.409.41-.814-.816-.406.406.814.815-.204.204a.288.288 0 000 .406l.815.815a1.42 1.42 0 001.698.242 7.968 7.968 0 011.477 4.643 8.067 8.067 0 01-11.118 7.462l-.219.533a8.643 8.643 0 0011.913-7.995 8.54 8.54 0 00-1.61-5.014zm-.512-.277a.872.872 0 01-1.223 0l-.61-.613 1.223-1.22.61.61a.867.867 0 010 1.223zM12.636 5A8.647 8.647 0 004 13.636a8.541 8.541 0 001.61 5.015 1.436 1.436 0 00.106 1.906l.814.815a.277.277 0 00.202.083.285.285 0 00.204-.083l.205-.205.814.815.406-.406-.814-.815.408-.408.815.814.406-.406-.815-.814.205-.205a.288.288 0 000-.406l-.815-.814a1.436 1.436 0 00-1.698-.242 7.968 7.968 0 01-1.477-4.644 8.07 8.07 0 018.06-8.06 7.983 7.983 0 013.058.601l.218-.535A8.616 8.616 0 0012.636 5zM6.122 18.928a.872.872 0 011.223 0l.61.613-1.223 1.22-.61-.61a.867.867 0 010-1.223z",
  fill: "#000",
  stroke: "#000",
  strokeWidth: 0.3
}));

var _ref124 = /*#__PURE__*/React.createElement("symbol", {
  viewBox: "0 0 11 25",
  fill: "none",
  id: "icon-notifications",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M-.601.708C1.571 1.343 3.25 3.456 3.25 6.5c0 1.968.399 3.077 1.137 3.883.125.136.465.45.69.659.105.095.184.169.207.192l.216.219v2.558H.906a2.957 2.957 0 01-1.34 1.806 3.006 3.006 0 01-3.132 0c-.781-.477-1.214-1.01-1.368-1.806H-9.5v-2.558l.216-.219c.025-.025.108-.102.215-.2.226-.208.56-.515.683-.65.738-.802 1.136-1.909 1.136-3.884 0-3.053 1.677-5.161 3.851-5.793A1.5 1.5 0 01-.6.708zm-2.765 13.303h2.669c-.121.21-.295.39-.519.526a1.506 1.506 0 01-1.568 0c-.295-.18-.476-.33-.582-.526z",
  fill: "#DADADA"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3.294,
  cy: 2.706,
  r: 2.647,
  fill: "#6E6"
}));

var _ref125 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 18 18",
  id: "icon-notifications-active",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.25 7.5c0-3.044-1.679-5.157-3.851-5.792a1.5 1.5 0 00-2.798-.001C5.427 2.339 3.75 4.447 3.75 7.5c0 1.975-.398 3.082-1.136 3.884a16.96 16.96 0 01-.683.65c-.107.098-.19.175-.215.2l-.216.219v2.558h4.566c.154.796.587 1.329 1.368 1.806.962.587 2.17.587 3.132 0a2.957 2.957 0 001.34-1.806H16.5v-2.558l-.216-.219c-.023-.023-.102-.097-.206-.192a17.132 17.132 0 01-.691-.66c-.738-.805-1.137-1.914-1.137-3.882zm-3.947 7.51H7.633c.106.198.287.347.582.527a1.506 1.506 0 002.087-.526zm3.977-2.614c.158.172.496.487.72.693v.422H3v-.422c.222-.203.561-.518.719-.69C4.72 11.31 5.25 9.84 5.25 7.5 5.25 4.665 7 3.01 9 3.01c1.995 0 3.75 1.663 3.75 4.49 0 2.33.53 3.803 1.53 4.896z",
  fill: "#FBF9F9"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 14.294,
  cy: 3.706,
  r: 2.647,
  fill: "#6E6"
}));

var _ref126 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 14 12",
  id: "icon-operating",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.27.497l.86.789a5.231 5.231 0 00-1.38 3.547c0 1.368.523 2.614 1.38 3.548l-.86.788A6.394 6.394 0 01.583 4.833c0-1.671.64-3.194 1.687-4.336zm9.46 0a6.394 6.394 0 011.686 4.336c0 1.672-.639 3.194-1.686 4.336l-.86-.788a5.231 5.231 0 001.38-3.548 5.231 5.231 0 00-1.38-3.547l.86-.788zM5.087 11.834l.389-1.166h3.048l.389 1.166h1.23l-1.918-5.75a1.75 1.75 0 10-2.451 0l-1.917 5.75h1.23zM5.865 9.5l.388-1.167h1.493L8.135 9.5h-2.27zm1.492-2.333l-.197-.59a1.77 1.77 0 01-.32 0l-.198.59h.715zm.226-2.334a.583.583 0 11-1.167 0 .583.583 0 011.167 0zm3.5 0a4.069 4.069 0 00-1.073-2.759l-.86.789c.476.519.766 1.21.766 1.97s-.29 1.452-.766 1.971l.86.789a4.069 4.069 0 001.073-2.76zM4.85 2.863l-.86-.789a4.069 4.069 0 00-1.074 2.76c0 1.063.407 2.032 1.074 2.758l.86-.788a2.906 2.906 0 01-.767-1.97c0-.76.29-1.453.767-1.972z",
  fill: "#3E3855"
}));

var _ref127 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 8 10",
  id: "icon-pause",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  width: 3,
  height: 10,
  rx: 1,
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("rect", {
  x: 4.5,
  width: 3,
  height: 10,
  rx: 1,
  fill: "currentColor"
}));

var _ref128 = /*#__PURE__*/React.createElement("symbol", {
  fill: "currentColor",
  viewBox: "0 0 24 24",
  id: "icon-payment",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19 14V6c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zm-2 0H3V6h14v8zm-7-7c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm13 0v11c0 1.1-.9 2-2 2H4v-2h17V7h2z"
}));

var _ref129 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 24 24",
  id: "icon-pencil-create",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.437 2c.655 0 1.283.261 1.741.723l3.101 3.101a2.462 2.462 0 010 3.482L9.958 20.624c-.699.806-1.69 1.3-2.823 1.378H2v-1l.003-4.215c.085-1.054.576-2.035 1.323-2.694l11.37-11.368A2.456 2.456 0 0116.436 2zM7.064 20.005c.534-.038 1.031-.287 1.43-.743l7.563-7.562-3.755-3.755-7.606 7.605c-.405.358-.656.86-.696 1.318v3.135l3.064.002zM13.717 6.53l3.754 3.755 2.394-2.394a.462.462 0 000-.653L16.76 4.135a.456.456 0 00-.647 0L13.717 6.53z",
  fill: "currentColor"
}));

var _ref130 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 17 17",
  id: "icon-pencil-edit",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.584 14.167V9.208h-1.417v4.959H2.834V2.833h4.958V1.417H2.834c-.783 0-1.417.634-1.417 1.416v11.334c0 .782.634 1.416 1.417 1.416h11.333c.782 0 1.417-.634 1.417-1.416zm-2-12.238a1.738 1.738 0 00-2.466 0L5.19 7.859a2.867 2.867 0 00-.937 1.908l-.003 2.277v.709H7.18a2.868 2.868 0 002-.977l5.894-5.892a1.744 1.744 0 000-2.466L13.585 1.93zM7.13 11.337c.378-.027.73-.203 1.013-.527l4.294-4.294-1.95-1.95L6.16 8.888a1.467 1.467 0 00-.493.934v1.512l1.462.002zm4.358-7.773l1.951 1.95.633-.632a.327.327 0 000-.463l-1.49-1.49a.323.323 0 00-.459 0l-.635.635z",
  fill: "currentColor"
}));

var _ref131 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 24 24",
  id: "icon-person",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.917 23.917C5.335 23.917 0 18.58 0 12 0 5.419 5.335.083 11.917.083 18.498.083 23.833 5.42 23.833 12c0 6.581-5.335 11.917-11.916 11.917zm8.016-6.365A9.705 9.705 0 0021.667 12c0-5.385-4.366-9.75-9.75-9.75-5.385 0-9.75 4.365-9.75 9.75 0 2.063.64 3.976 1.734 5.552 1.219-1.61 4.084-2.302 8.016-2.302 3.931 0 6.797.691 8.016 2.302zm-1.555 1.75c-.317-1.14-2.595-1.885-6.461-1.885-3.867 0-6.145.744-6.462 1.884a9.713 9.713 0 006.462 2.449 9.713 9.713 0 006.461-2.449zM11.917 5.5c-2.623 0-4.334 1.902-4.334 4.333 0 3.713 1.908 5.417 4.334 5.417 2.403 0 4.333-1.647 4.333-5.2 0-2.468-1.718-4.55-4.333-4.55zM9.75 9.833c0 2.459.886 3.25 2.167 3.25 1.276 0 2.166-.76 2.166-3.033 0-1.354-.85-2.383-2.166-2.383-1.372 0-2.167.883-2.167 2.166z",
  fill: "#A0A0AC"
}));

var _ref132 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 36 47",
  id: "icon-pin",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18 0C8.1 0 0 7.8 0 17.4c0 3.8 1.3 7.4 3.6 10.4L18 46.65 32.4 27.8c2.3-3 3.6-6.6 3.6-10.4C36 7.8 27.9 0 18 0zm1.3 24.2c-.9.2-1.8.2-2.7 0-3.8-.8-6.3-4.4-5.5-8.2.8-3.8 4.4-6.3 8.2-5.5 2.8.6 5 2.7 5.5 5.5.7 3.8-1.8 7.5-5.5 8.2z",
  fill: "currentColor"
}));

var _ref133 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 24 24",
  id: "icon-pin-empty",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 23.328l.658-.575C18.188 17.923 21 13.707 21 10c0-5.25-4.097-9-9-9s-9 3.75-9 9c0 3.707 2.811 7.924 8.342 12.753l.658.575zm0-2.665C7.307 16.433 5 12.85 5 10c0-4.103 3.164-7 7-7s7 2.897 7 7c0 2.85-2.307 6.433-7 10.663zM12 5a5 5 0 110 10 5 5 0 010-10zm-3 5a3 3 0 116 0 3 3 0 01-6 0z",
  fill: "currentColor"
}));

var _ref134 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 15 15",
  id: "icon-pin-outline",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.5 14.58l.411-.36c3.457-3.018 5.214-5.653 5.214-7.97 0-3.28-2.56-5.625-5.625-5.625-3.064 0-5.625 2.344-5.625 5.625 0 2.317 1.757 4.952 5.214 7.97l.411.36zm0-1.665C4.567 10.27 3.125 8.03 3.125 6.25c0-2.565 1.978-4.375 4.375-4.375 2.397 0 4.375 1.81 4.375 4.375 0 1.78-1.442 4.021-4.375 6.665zm0-9.79a3.125 3.125 0 110 6.25 3.125 3.125 0 010-6.25zM5.625 6.25a1.875 1.875 0 113.75 0 1.875 1.875 0 01-3.75 0z",
  fill: "#FC1355"
}));

var _ref135 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 8 11",
  id: "icon-play",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 9.5v-9A.5.5 0 01.77.08l7 4.5a.5.5 0 010 .841l-7 4.5a.5.5 0 01-.77-.42z",
  fill: "currentColor"
}));

var _ref136 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 24 24",
  id: "icon-plug",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.905 2v4.18M14.796 2v4.18",
  stroke: "currentColor",
  strokeWidth: 1.201,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.297 5.816v8.953l-4.168 2.99H9.478L5.404 14.77V5.816h12.893zM9.68 22.7v-4.34h4.245v4.34H9.68z",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.601
}));

var _ref137 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 892 841",
  id: "icon-plug-3d",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.04,
  filter: "url(#fffilter0_f)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M443.882 325.344L71.685 543.778 41.672 561.42l54.826 32.663 245.479 145.965 54.651 32.519h.088l45.869 27.294 347.284-203.928 54.832-32.231-30.019-17.882-17.053-10.127-54.637-32.526-299.11-177.823z",
  fill: "#211E21"
})), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3 414.798l45.734 25.972 46.921 26.566 25.466 14.841 72.394 42 80.925 46.972 60.353 35.099 38.754 22.484 26.728 15.509 45.585 26.566v-5.178l.149-.074v-2.003L3 406.207v8.591z",
  fill: "#E4E4E4"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M446.01 666.325v5.946l47.026-27.072 26.23-14.921 180.692-103.669 72.578-41.628 26.386-15.118 47.019-26.958 46.051-26.429v-5.831L446.01 666.325z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M448.265 152L36.225 388.764 3 407.886l60.695 35.404 271.757 158.213 60.501 35.248h.097l50.779 29.584 384.459-221.04 60.702-34.935-33.233-19.383L839.879 380l-60.486-35.255L448.265 152z",
  fill: "url(#ffpaint0_linear)"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.065,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M836.966 380.379L391.604 636.558l-.499-.867 445.363-256.179.498.867zM777.488 344.691l-445.362 256.18-.499-.867 445.362-256.18.499.867zM722.425 314.931l-445.362 256.18-.499-.867 445.363-256.18.498.867zM668.952 282.267L223.59 538.447l-.498-.867L668.454 281.4l.498.867zM613.931 252.529L168.569 508.708l-.499-.866 445.362-256.18.499.867zM560.458 216.861L115.096 473.04l-.498-.866 445.362-256.18.498.867zM499.427 181.173L54.065 437.353l-.499-.867 445.362-256.179.499.866z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.065,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M53.542 380.379l445.362 256.179.498-.867L54.04 379.512l-.498.867zM113.02 344.691l445.362 256.18.499-.867-445.362-256.18-.499.867zM168.083 314.931l445.362 256.18.498-.867-445.362-256.18-.498.867zM221.555 282.267l445.362 256.18.499-.867L222.054 281.4l-.499.867zM276.618 252.529L721.98 508.708l.499-.866-445.363-256.18-.498.867zM330.13 216.861L775.492 473.04l.498-.866-445.362-256.18-.498.867zM391.081 181.173l445.362 256.18.498-.867-445.362-256.179-.498.866z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M454.291 371.826l-.354-23.363h-.957l7.656-2.871 13.396 5.263c-.319 7.017 0 23.444 0 35.884 0 5.774-2.256 12.033-5.125 17.492-4.986 9.485-13.604 16.269-22.311 22.515l-8.927 6.404-21.052-16.268c3.668-1.754 17.225-9.856 24.88-14.832 4.826-3.137 8.321-8.973 10.485-14.178 2.098-5.045 2.392-10.583 2.309-16.046z",
  fill: "#EFEFF1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M446.635 372.783l-.354-23.363h-.956l7.655-2.871 13.397 5.263c-.319 7.017 0 23.444 0 35.884 0 5.511-1.85 10.744-4.311 15.154-4.696 8.413-13.264 13.599-21.587 18.454l-10.465 6.105-15.311-11.483c3.668-1.755 12.448-6.706 19.139-12.919 4.166-3.868 7.776-9.402 10.141-14.3 2.376-4.921 2.735-10.461 2.652-15.924z",
  fill: "#A0A0AC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M428.578 339.373V321.67l60.286-35.406v53.109c-7.655 11.004-16.253 15.439-34.449 14.832-14.354-.478-23.285-9.569-25.837-14.832z",
  fill: "#D1CFCF"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M456.329 305.371l-27.751 16.298v17.703c2.552 5.263 11.483 14.354 25.837 14.832.65.022 1.288.037 1.914.046v-48.879z",
  fill: "#A0A0AC"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M480.252 348.478c3.22-2.296 5.972-5.31 8.613-9.105v-53.109l-8.613 5.058v57.156z",
  fill: "#EFEFF1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M398.846 206.144l-63.429-36.722-.385 117.54c-.02 5.979 3.294 11.461 8.535 14.34 20.688 11.363 51.523 29.612 51.523 29.612s10.433 7.094 15.857 5.425l-12.101-130.195z",
  fill: "#D1CFCF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M398.428 320.568V206.143l158.154-90.135.334 110.745a46.998 46.998 0 01-23.692 40.956L419.37 332.725c-9.333 5.33-20.942-1.409-20.942-12.157z",
  fill: "#FBF9F9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M398.847 206.143l157.736-90.135-63.845-37.557-157.32 90.97 63.429 36.722z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M397.176 201.553l153.565-85.545-58.421-33.801-150.195 87.424 55.051 31.922z",
  fill: "#EFEFF1"
}), /*#__PURE__*/React.createElement("g", {
  opacity: 0.12,
  filter: "url(#fffilter1_f)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M361.194 496L557 387.049 482.509 344 291 455.344 361.194 496z",
  fill: "#34363F"
})), /*#__PURE__*/React.createElement("ellipse", {
  cx: 407.608,
  cy: 164.833,
  rx: 17.526,
  ry: 10.432,
  fill: "#D1CFCF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M407.608 173.179c-9.824 0-14.327-4.312-15.44-7.512l.395-104.188a6 6 0 016-5.977h18.09a6 6 0 016 5.977l.389 102.763c.004.932-.231 1.858-.775 2.615-1.702 2.367-5.624 6.322-14.659 6.322z",
  fill: "#FBF9F9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M407.608 110.585c-9.824 0-14.327-4.312-15.44-7.512l.365-41.624a6 6 0 016-5.947h18.15a6 6 0 016 5.947l.365 41.624-.01.016c-1.124 1.826-4.612 7.496-15.43 7.496z",
  fill: "#6E6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M422.131 59.008c0 2.22-1.516 4.317-4.155 5.887-2.629 1.563-6.293 2.546-10.368 2.546-4.074 0-7.738-.983-10.367-2.546-2.639-1.57-4.155-3.667-4.155-5.886 0-2.22 1.516-4.317 4.155-5.887 2.629-1.563 6.293-2.546 10.367-2.546 4.075 0 7.739.983 10.368 2.546 2.639 1.57 4.155 3.667 4.155 5.886z",
  fill: "#85FC99",
  stroke: "#82EA93"
}), /*#__PURE__*/React.createElement("mask", {
  id: "ffa",
  maskUnits: "userSpaceOnUse",
  x: 375,
  y: 40,
  width: 35,
  height: 140
}, /*#__PURE__*/React.createElement("path", {
  fill: "#C4C4C4",
  d: "M375.895 40.06h33.383v139.376h-33.383z"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#ffa)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 406.774,
  cy: 164.833,
  rx: 17.526,
  ry: 10.432,
  fill: "#D1CFCF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M406.774 173.179c-9.824 0-14.327-4.312-15.44-7.512l.395-104.188a6 6 0 016-5.977h18.09a6 6 0 016 5.977l.389 102.763c.004.932-.231 1.858-.775 2.615-1.702 2.367-5.624 6.322-14.659 6.322z",
  fill: "#EFEFF1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M406.774 110.585c-9.824 0-14.327-4.312-15.44-7.512l.365-41.624a6 6 0 016-5.947h18.15a6 6 0 016 5.947l.365 41.624-.01.016c-1.123 1.826-4.612 7.496-15.43 7.496z",
  fill: "#60D760"
}), /*#__PURE__*/React.createElement("path", {
  d: "M421.297 59.008c0 2.22-1.516 4.317-4.155 5.887-2.629 1.563-6.293 2.546-10.367 2.546-4.075 0-7.739-.983-10.368-2.546-2.639-1.57-4.155-3.667-4.155-5.886 0-2.22 1.516-4.317 4.155-5.887 2.629-1.563 6.293-2.546 10.368-2.546 4.074 0 7.738.983 10.367 2.546 2.639 1.57 4.155 3.667 4.155 5.886z",
  fill: "#6E6",
  stroke: "#82EA93"
})), /*#__PURE__*/React.createElement("ellipse", {
  cx: 486.893,
  cy: 124.772,
  rx: 17.526,
  ry: 10.432,
  fill: "#D1CFCF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M486.893 133.118c-9.824 0-14.327-4.312-15.44-7.511l.395-104.188a6 6 0 016-5.978h18.09a6 6 0 016 5.978l.389 102.762c.004.932-.231 1.859-.775 2.615-1.702 2.367-5.624 6.322-14.659 6.322z",
  fill: "#FBF9F9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M486.893 70.524c-9.824 0-14.327-4.312-15.44-7.511l.365-41.624a6 6 0 016-5.948h18.15a6 6 0 016 5.948l.365 41.624-.01.016c-1.123 1.825-4.612 7.495-15.43 7.495z",
  fill: "#6E6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M501.416 18.948c0 2.22-1.516 4.317-4.155 5.886-2.629 1.563-6.293 2.546-10.367 2.546-4.074 0-7.739-.983-10.367-2.546-2.64-1.57-4.156-3.666-4.156-5.886s1.516-4.317 4.156-5.886c2.628-1.563 6.293-2.546 10.367-2.546 4.074 0 7.738.983 10.367 2.546 2.639 1.569 4.155 3.666 4.155 5.886z",
  fill: "#85FC99",
  stroke: "#82EA93"
}), /*#__PURE__*/React.createElement("mask", {
  id: "ffb",
  maskUnits: "userSpaceOnUse",
  x: 455,
  y: 0,
  width: 34,
  height: 140
}, /*#__PURE__*/React.createElement("path", {
  fill: "#C4C4C4",
  d: "M455.18 0h33.383v139.376H455.18z"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#ffb)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 486.06,
  cy: 124.772,
  rx: 17.526,
  ry: 10.432,
  fill: "#D1CFCF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M486.059 133.118c-9.824 0-14.327-4.312-15.44-7.511l.395-104.188a6 6 0 016-5.978h18.09a6 6 0 016 5.978l.389 102.762c.004.932-.231 1.859-.775 2.615-1.702 2.367-5.624 6.322-14.659 6.322z",
  fill: "#EFEFF1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M486.059 70.524c-9.824 0-14.327-4.312-15.44-7.511l.365-41.624a6 6 0 016-5.948h18.15a6 6 0 016 5.948l.365 41.624-.01.016c-1.123 1.825-4.612 7.495-15.43 7.495z",
  fill: "#60D760"
}), /*#__PURE__*/React.createElement("path", {
  d: "M500.582 18.948c0 2.22-1.516 4.317-4.155 5.886-2.629 1.563-6.293 2.546-10.367 2.546-4.074 0-7.739-.983-10.367-2.546-2.64-1.57-4.156-3.666-4.156-5.886s1.516-4.317 4.156-5.886c2.628-1.563 6.293-2.546 10.367-2.546 4.074 0 7.738.983 10.367 2.546 2.639 1.569 4.155 3.666 4.155 5.886z",
  fill: "#6E6",
  stroke: "#82EA93"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "fffilter0_f",
  x: 0.89,
  y: 284.562,
  width: 884.594,
  height: 556.081,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 20.391,
  result: "effect1_foregroundBlur"
})), /*#__PURE__*/React.createElement("filter", {
  id: "fffilter1_f",
  x: 227,
  y: 280,
  width: 394,
  height: 280,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 32,
  result: "effect1_foregroundBlur"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ffpaint0_linear",
  x1: 844.991,
  y1: 408.997,
  x2: -29,
  y2: 408.997,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F2F2F2"
}))));

var _ref138 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 24 24",
  id: "icon-plus",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 0a.8.8 0 00-.8.8v10.4H.8a.8.8 0 100 1.6h10.4v10.4a.8.8 0 001.6 0V12.8h10.4a.8.8 0 000-1.6H12.8V.8A.8.8 0 0012 0z",
  fill: "currentColor"
}));

var _ref139 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 15 15",
  id: "icon-plus-circle",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.5 13.75a6.25 6.25 0 100-12.5 6.25 6.25 0 000 12.5zm0 1.25a7.5 7.5 0 100-15 7.5 7.5 0 000 15z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.125 6.875h3.125v1.25H8.125v3.125h-1.25V8.125H3.75v-1.25h3.125V3.75h1.25v3.125z",
  fill: "currentColor"
}));

var _ref140 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 15 15",
  id: "icon-plus-thick",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.688 6.313h5.937v2.375H8.687v5.937H6.313V8.687H.375V6.313h5.938V.375h2.375v5.938z",
  fill: "currentColor"
}));

var _ref141 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 892 787",
  id: "icon-power-plant-3d",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.04,
  filter: "url(#fjfilter0_f)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M443.388 271.34L71.607 489.531l-29.98 17.622 54.765 32.627 245.205 145.801 54.591 32.483h.087l45.818 27.264 346.896-203.701 54.772-32.194-29.987-17.863-17.033-10.115-54.577-32.49L443.388 271.34z",
  fill: "#211E21"
})), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.002 376.136l45.683 25.943 46.869 26.536 25.437 14.825 72.314 41.953 80.834 46.92 60.285 35.06 38.712 22.459 26.698 15.492 45.534 26.535v-5.171l.148-.074v-2.002L3.002 367.555v8.581z",
  fill: "#E4E4E4"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M445.523 627.374v5.94l46.975-27.043 26.2-14.904 180.491-103.553 72.497-41.582 26.356-15.101 46.967-26.928 45.999-26.399v-5.825L445.523 627.374z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M447.77 113.623l-411.58 236.5-33.188 19.1 60.627 35.365 271.454 158.036 60.434 35.209h.096l50.723 29.551 384.03-220.794L891 371.695l-33.196-19.361-18.857-10.965-60.419-35.216-330.758-192.53z",
  fill: "url(#fjpaint0_linear)"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.065,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M836.043 341.747L391.178 597.641l-.498-.866 444.865-255.894.498.866zM776.621 306.094L331.756 561.988l-.498-.866 444.865-255.893.498.865zM721.621 276.381L276.756 532.275l-.498-.866 444.865-255.893.498.865zM668.207 243.745L223.342 499.638l-.498-.865 444.865-255.894.498.866zM613.252 214.053L168.387 469.947l-.498-.866 444.865-255.893.498.865zM559.838 178.422L114.973 434.316l-.498-.866L559.34 177.557l.498.865zM498.873 142.77L54.008 398.664l-.498-.866 444.865-255.894.498.866z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.065,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M53.488 341.747l444.866 255.894.498-.866L53.986 340.881l-.498.866zM112.91 306.094l444.865 255.894.498-.866-444.865-255.893-.498.865zM167.889 276.381l444.865 255.894.498-.866-444.865-255.893-.498.865zM221.324 243.745l444.865 255.893.499-.865-444.866-255.894-.498.866zM276.322 214.053l444.865 255.894.499-.866L276.82 213.188l-.498.865zM329.779 178.422l444.866 255.894.498-.866-444.866-255.893-.498.865zM390.635 142.77L835.5 398.664l.498-.866-444.865-255.894-.498.866z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M272.102 313.898l-20.846-3.407V19.641c.029 2.2 1.479 4.384 4.35 6.05 2.929 1.703 6.761 2.554 10.608 2.554 3.839 0 7.686-.851 10.63-2.554 2.478-1.43 3.913-3.236 4.305-5.102 0-.015.008-.03.008-.052.007-.014.007-.03.015-.044v-.015c0-.015.007-.022.007-.037v-.015c0-.014.007-.022.007-.037v-.022c.008-.007.008-.015.008-.03 0-.007.007-.014.007-.022v-.022c0-.015.008-.022.008-.037v-.015c0-.014.007-.03.007-.037v-.015c0-.014.007-.03.007-.044v-.007c.023-.186.037-.37.037-.563v286.283c.008 2.236-1.472 4.48-4.416 6.184-1.406.812-3.026 1.428-4.742 1.856z",
  fill: "url(#fjpaint1_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M255.701 13.38c-5.896 3.405-5.925 8.914-.096 12.298 5.851 3.406 15.35 3.406 21.238 0 5.866-3.384 5.896-8.893.045-12.299-5.83-3.39-15.328-3.39-21.187 0z",
  fill: "#F1F1F1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M266.216 26.492c-3.078 0-6.148-.681-8.485-2.043-4.668-2.718-4.639-7.123.074-9.848 2.345-1.355 5.422-2.029 8.485-2.029 3.07 0 6.14.674 8.47 2.029 4.683 2.725 4.66 7.13-.037 9.848-2.353 1.362-5.437 2.043-8.507 2.043",
  fill: "url(#fjpaint2_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M251.256 294.226c.007 2.206 1.457 4.414 4.35 6.094 5.851 3.404 15.349 3.404 21.238 0 2.952-1.703 4.424-3.939 4.416-6.175v-10.988c.008 2.236-1.464 4.472-4.416 6.175-5.889 3.404-15.387 3.404-21.238 0-2.893-1.68-4.343-3.881-4.35-6.094v10.988zm0-29.29c.007 2.207 1.457 4.41 4.35 6.091 5.851 3.402 15.349 3.402 21.238 0 2.952-1.71 4.424-3.945 4.416-6.181v-10.988c.008 2.245-1.464 4.48-4.416 6.184-5.889 3.405-15.387 3.405-21.238 0-2.893-1.684-4.343-3.89-4.35-6.094v10.988zm0-29.299c.007 2.207 1.457 4.411 4.35 6.094 5.851 3.404 15.349 3.404 21.238 0 2.952-1.703 4.424-3.939 4.416-6.175v-10.987c.008 2.235-1.464 4.471-4.416 6.18-5.889 3.398-15.387 3.398-21.238 0-2.893-1.689-4.343-3.887-4.35-6.1v10.988zm0-29.293c.007 2.207 1.457 4.413 4.35 6.094 5.851 3.399 15.349 3.399 21.238 0 2.952-1.704 4.424-3.945 4.416-6.181v-10.988c.008 2.243-1.464 4.479-4.416 6.182-5.889 3.407-15.387 3.407-21.238 0-2.893-1.681-4.343-3.887-4.35-6.094v10.987zm0-29.297c.007 2.206 1.457 4.413 4.35 6.093 5.851 3.406 15.349 3.406 21.238 0 2.952-1.703 4.424-3.939 4.416-6.175v-10.988c.008 2.236-1.464 4.473-4.416 6.183-5.889 3.398-15.387 3.398-21.238 0-2.893-1.681-4.343-3.887-4.35-6.094v10.981zm0-29.291c.007 2.206 1.457 4.413 4.35 6.093 5.851 3.406 15.349 3.406 21.238 0 2.952-1.703 4.424-3.946 4.416-6.182v-10.988c.008 2.243-1.464 4.479-4.416 6.182-5.889 3.406-15.387 3.406-21.238 0-2.893-1.68-4.343-3.887-4.35-6.093v10.988zm0-29.299c.007 2.214 1.457 4.413 4.35 6.094 5.851 3.406 15.349 3.406 21.238 0 2.952-1.703 4.424-3.939 4.416-6.175v-10.988c.008 2.236-1.464 4.479-4.416 6.182-5.889 3.399-15.387 3.399-21.238 0-2.893-1.688-4.343-3.887-4.35-6.093v10.98zm0-29.291c.007 2.206 1.457 4.413 4.35 6.094 5.851 3.406 15.349 3.406 21.238 0 2.952-1.703 4.424-3.94 4.416-6.183v-10.98c.008 2.236-1.464 4.472-4.416 6.175-5.889 3.406-15.387 3.406-21.238 0-2.893-1.681-4.343-3.887-4.35-6.094v10.988zm0-29.299c.007 2.214 1.457 4.413 4.35 6.094 5.851 3.406 15.349 3.406 21.238 0 2.952-1.703 4.424-3.939 4.416-6.175V48.798c.008 2.236-1.464 4.48-4.416 6.183-5.889 3.406-15.387 3.406-21.238 0-2.893-1.681-4.343-3.888-4.35-6.094v10.98z",
  fill: "url(#fjpaint3_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M210.061 385.316l-20.846-3.407V91.06c.029 2.199 1.479 4.383 4.35 6.049 2.929 1.703 6.761 2.555 10.608 2.555 3.839 0 7.686-.852 10.63-2.555 2.478-1.429 3.913-3.236 4.305-5.102 0-.014.008-.03.008-.051.007-.015.007-.03.014-.045v-.014c0-.015.008-.023.008-.038v-.014c0-.015.007-.023.007-.037v-.023c.008-.007.008-.014.008-.03 0-.007.007-.014.007-.021v-.023c0-.014.007-.022.007-.037v-.014c0-.015.008-.03.008-.037v-.015c0-.015.007-.03.007-.045v-.007c.022-.185.037-.37.037-.563v286.283c.008 2.236-1.472 4.48-4.416 6.184-1.406.812-3.026 1.428-4.742 1.856z",
  fill: "url(#fjpaint4_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M193.66 84.797c-5.896 3.406-5.926 8.915-.096 12.299 5.851 3.406 15.35 3.406 21.238 0 5.866-3.384 5.896-8.893.045-12.299-5.83-3.39-15.328-3.39-21.187 0z",
  fill: "#F1F1F1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M204.194 97.912c-3.077 0-6.147-.681-8.485-2.043-4.668-2.718-4.638-7.123.074-9.848 2.345-1.355 5.422-2.029 8.485-2.029 3.07 0 6.14.674 8.47 2.029 4.683 2.725 4.661 7.13-.037 9.848-2.352 1.362-5.437 2.043-8.507 2.043",
  fill: "url(#fjpaint5_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M189.215 365.644c.007 2.206 1.457 4.414 4.35 6.094 5.851 3.404 15.349 3.404 21.238 0 2.951-1.703 4.424-3.939 4.416-6.175v-10.988c.008 2.236-1.465 4.472-4.416 6.175-5.889 3.404-15.387 3.404-21.238 0-2.893-1.68-4.343-3.881-4.35-6.094v10.988zm0-29.29c.007 2.207 1.457 4.41 4.35 6.091 5.851 3.402 15.349 3.402 21.238 0 2.951-1.71 4.424-3.945 4.416-6.181v-10.988c.008 2.245-1.465 4.48-4.416 6.184-5.889 3.405-15.387 3.405-21.238 0-2.893-1.684-4.343-3.89-4.35-6.094v10.988zm0-29.299c.007 2.207 1.457 4.411 4.35 6.094 5.851 3.404 15.349 3.404 21.238 0 2.951-1.703 4.424-3.939 4.416-6.175v-10.987c.008 2.235-1.465 4.471-4.416 6.18-5.889 3.398-15.387 3.398-21.238 0-2.893-1.689-4.343-3.887-4.35-6.1v10.988zm0-29.293c.007 2.207 1.457 4.413 4.35 6.094 5.851 3.399 15.349 3.399 21.238 0 2.951-1.703 4.424-3.945 4.416-6.181v-10.988c.008 2.243-1.465 4.479-4.416 6.182-5.889 3.407-15.387 3.407-21.238 0-2.893-1.681-4.343-3.887-4.35-6.094v10.987zm0-29.297c.007 2.206 1.457 4.413 4.35 6.093 5.851 3.406 15.349 3.406 21.238 0 2.951-1.702 4.424-3.939 4.416-6.175v-10.988c.008 2.237-1.465 4.473-4.416 6.183-5.889 3.398-15.387 3.398-21.238 0-2.893-1.681-4.343-3.887-4.35-6.094v10.981zm0-29.291c.007 2.206 1.457 4.413 4.35 6.093 5.851 3.406 15.349 3.406 21.238 0 2.951-1.703 4.424-3.946 4.416-6.182v-10.988c.008 2.243-1.465 4.48-4.416 6.182-5.889 3.406-15.387 3.406-21.238 0-2.893-1.68-4.343-3.887-4.35-6.093v10.988zm0-29.299c.007 2.214 1.457 4.413 4.35 6.094 5.851 3.406 15.349 3.406 21.238 0 2.951-1.703 4.424-3.939 4.416-6.175v-10.988c.008 2.236-1.465 4.479-4.416 6.182-5.889 3.399-15.387 3.399-21.238 0-2.893-1.688-4.343-3.887-4.35-6.093v10.98zm0-29.291c.007 2.207 1.457 4.413 4.35 6.094 5.851 3.406 15.349 3.406 21.238 0 2.951-1.703 4.424-3.939 4.416-6.183v-10.98c.008 2.236-1.465 4.472-4.416 6.175-5.889 3.406-15.387 3.406-21.238 0-2.893-1.681-4.343-3.887-4.35-6.094v10.988zm0-29.299c.007 2.214 1.457 4.413 4.35 6.094 5.851 3.406 15.349 3.406 21.238 0 2.951-1.703 4.424-3.939 4.416-6.175v-10.988c.008 2.236-1.465 4.48-4.416 6.183-5.889 3.406-15.387 3.406-21.238 0-2.893-1.681-4.343-3.887-4.35-6.094v10.98z",
  fill: "url(#fjpaint6_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M530.893 239.232c-45.192-27.038-119.513-27.794-166.005-1.68-46.486 26.112-47.545 69.198-2.353 96.237 45.192 27.04 119.513 27.794 165.998 1.68 46.493-26.11 47.552-69.196 2.36-96.237",
  fill: "#5F5F64"
}), /*#__PURE__*/React.createElement("path", {
  d: "M514.325 167.455c.3-10.028-6.032-20.135-19.044-27.926-25.929-15.512-68.568-15.939-95.237-.962-13.831 7.766-20.65 18.154-20.396 28.515-.534-21.956-1.06-43.907-1.593-65.862-.04-1.795-.1-4.19-.147-5.984l-.287-11.976c-.04-1.794-.1-4.19-.146-5.991-.14-5.984-.287-11.969-.434-17.96-.086-3.589-.239-8.38-.286-11.975-.26-10.855 6.885-21.743 21.376-29.882 27.955-15.698 72.635-15.245 99.803 1.014 13.638 8.16 20.27 18.754 19.957 29.261-1.186 39.91-2.38 79.819-3.566 119.728",
  fill: "url(#fjpaint7_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M554.635 264.624c-3.106-6.458-6.039-12.564-9.945-21.93-4.919-11.804-7.979-21.037-8.005-21.123-2.547-7.818-4.746-14.57-6.246-20.609a641.27 641.27 0 01-4.526-19.694c-.666-3.169-1.393-7.432-1.88-10.635-1.979-12.968-3.892-28.334-4.459-52.724-.426-18.38-.013-38.128 1.533-72.867-.48 10.781-7.945 21.45-22.343 29.535-29.228 16.412-75.953 15.945-104.362-1.054-13.524-8.093-20.463-18.474-20.863-28.894 1.193 32.25 1.7 52.331 1.127 72.54-.7 24.643-2.753 40.329-4.666 52.424-.5 3.169-1.227 7.393-1.9 10.528a635.954 635.954 0 01-4.586 19.66c-1.593 6.333-4.199 14.203-6.292 20.529-.033.089-3.08 9.262-8.385 21.83-4.42 10.467-8.672 19.046-10.072 21.868-10.765 21.69-1.72 46.063 27.382 63.474 43.213 25.852 114.294 26.574 158.753 1.6 30.661-17.218 40.653-42.156 29.735-64.458",
  fill: "url(#fjpaint8_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M492.981 71.105c25.942-14.57 26.528-38.615 1.313-53.7-25.216-15.09-66.689-15.51-92.631-.94-25.942 14.57-26.535 38.615-1.313 53.706 25.216 15.084 66.688 15.505 92.631.934zm5.779 3.463c-29.229 16.412-75.954 15.945-104.362-1.055-28.416-17.005-27.749-44.092 1.479-60.504 29.229-16.418 75.954-15.945 104.369 1.054 28.409 17 27.749 44.086-1.486 60.505",
  fill: "#F1F1F1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M422.379 121.401c-6.812-.495-12.068 5.595-11.744 13.606.324 8.01 6.111 14.907 12.919 15.408 6.812.494 12.068-5.595 11.744-13.604-.325-8.012-6.111-14.91-12.919-15.41",
  fill: "#646262"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M340.556 351.218v39.325l-107.984-63.329v-39.329l107.984 63.333z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M309.194 235.043l-78.426 45.282 109.792 63.842 78.436-45.292-109.802-63.832z",
  fill: "#F7F7F7"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M340.568 344.161v7.05l78.436-45.293v-7.049l-78.436 45.292z",
  fill: "#DBDFE0"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M340.558 344.172v7.048l-24.382-14.086-85.365-50.125v-7.048l109.747 64.211z",
  fill: "#CFD2D3"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M391.137 321.995l-1.01.581-16.357 9.448-.172.1-15.695 9.062-.834.481-16.524 9.543v39.325l7.038-4.062v-35.196l5.405-3.119 4.081-2.358v28.158l7.039-4.066v-28.158l5.409-3.124 4.081-2.357v28.158l7.039-4.062V332.19l5.409-3.123 4.081-2.358v28.158l7.039-4.066v-28.158l5.405-3.12 4.081-2.357v28.158l6.095 3.519.943-.542v-39.33l-22.553 13.024z",
  fill: "#CFD2D3"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M373.61 336.26v28.158l-4.081-2.357v-23.444l4.081-2.357zM357.083 345.811v28.158l-4.081-2.358v-23.443l4.081-2.357zM406.648 317.156v28.159l-4.082-2.357v-23.444l4.082-2.358z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M402.579 319.533v23.444l-5.405 3.119v-23.444l5.405-3.119z",
  fill: "#5DE273"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M390.14 326.729v28.157l-4.081-2.357v-23.443l4.081-2.357z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M386.076 329.062v23.444l-5.41 3.124v-23.444l5.41-3.124zM369.527 338.615v23.444l-5.41 3.124v-23.444l5.41-3.124zM352.993 348.166v23.443l-5.405 3.119v-23.443l5.405-3.119z",
  fill: "#5DE273"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M417.452 351.562l-59.073 34.11-4.7-2.714-6.091-3.519v-4.715l5.405-3.119 4.081 2.357 7.038-4.066v-4.715l5.41-3.124 4.081 2.357 7.038-4.062v-4.714l5.41-3.124 4.081 2.357 7.039-4.067v-4.714l5.404-3.119 4.082 2.357 6.095 3.519 4.7 2.715z",
  fill: "#F9FAFB"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M358.373 385.665v7.038l59.073-34.11v-7.038l-59.073 34.11z",
  fill: "#DBDFE0"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M347.588 386.48l10.791 6.234v-7.038l-4.701-2.715-6.09-3.52v7.039z",
  fill: "#CFD2D3"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M340.556 306.873v39.325l-107.984-63.329v-39.33l107.984 63.334z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M309.194 190.697l-78.426 45.283 109.792 63.842 78.436-45.292-109.802-63.833z",
  fill: "#F7F7F7"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M340.568 299.815v7.049l78.436-45.291v-7.05l-78.436 45.292z",
  fill: "#DBDFE0"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M340.558 299.828v7.048l-24.382-14.086-85.365-50.125v-7.048l109.747 64.211z",
  fill: "#CFD2D3"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M391.137 277.649l-1.01.581-16.357 9.448-.172.1-15.695 9.062-.834.481-16.524 9.544v39.325l7.038-4.062v-35.197l5.405-3.119 4.081-2.357v28.158l7.039-4.067v-28.158l5.409-3.124 4.081-2.357v28.158l7.039-4.062v-28.158l5.409-3.124 4.081-2.357v28.158l7.039-4.067v-28.158l5.405-3.119 4.081-2.357v28.158l6.095 3.519.943-.543v-39.33l-22.553 13.024z",
  fill: "#CFD2D3"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M373.61 291.914v28.158l-4.081-2.357v-23.444l4.081-2.357zM357.083 301.467v28.158l-4.081-2.357v-23.444l4.081-2.357zM406.648 272.811v28.157l-4.082-2.357v-23.443l4.082-2.357z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M402.579 275.188v23.443l-5.405 3.119v-23.443l5.405-3.119z",
  fill: "#5DE273"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M390.14 282.363v28.158l-4.081-2.357v-23.443l4.081-2.358z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M386.076 284.738v23.444l-5.41 3.124v-23.444l5.41-3.124zM369.527 294.289v23.443l-5.41 3.124v-23.443l5.41-3.124zM352.993 303.82v23.444l-5.405 3.119v-23.444l5.405-3.119z",
  fill: "#5DE273"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M340.556 262.546v39.325l-107.984-63.328v-39.33l107.984 63.333z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M309.194 146.371l-78.426 45.282 109.792 63.842 78.436-45.292-109.802-63.832z",
  fill: "#F7F7F7"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M340.568 255.489v7.05l78.436-45.292v-7.05l-78.436 45.292z",
  fill: "#DBDFE0"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M340.558 255.502v7.048l-24.382-14.086-85.365-50.125v-7.048l109.747 64.211z",
  fill: "#CFD2D3"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M391.137 233.321l-1.01.581-16.357 9.448-.172.1-15.695 9.062-.834.481-16.524 9.543v39.325l7.038-4.062v-35.196l5.405-3.119 4.081-2.357v28.158l7.039-4.067V253.06l5.409-3.124 4.081-2.357v28.158l7.039-4.062v-28.158l5.409-3.124 4.081-2.357v28.158l7.039-4.067v-28.158l5.405-3.119 4.081-2.358v28.158l6.095 3.52.943-.543v-39.33l-22.553 13.024z",
  fill: "#CFD2D3"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M373.61 247.588v28.158l-4.081-2.357v-23.444l4.081-2.357zM357.083 257.139v28.158l-4.081-2.358v-23.443l4.081-2.357zM406.648 228.484v28.158l-4.082-2.357v-23.443l4.082-2.358z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M402.579 230.861v23.444l-5.405 3.119V233.98l5.405-3.119z",
  fill: "#5DE273"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M390.14 238.057v28.158l-4.081-2.357v-23.444l4.081-2.357z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M386.076 240.391v23.443l-5.41 3.124v-23.443l5.41-3.124zM369.527 249.943v23.444l-5.41 3.124v-23.444l5.41-3.124zM352.993 259.494v23.444l-5.405 3.119v-23.444l5.405-3.119z",
  fill: "#5DE273"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M221.218 345.419v4.143l-2.388-1.376-39.067-22.562-10.993-6.349v-4.142l52.448 30.286z",
  fill: "#CFD2D3"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M319.992 321.117v4.143l-11.86 6.851-32.907 19.002v-4.143l44.767-25.853z",
  fill: "#DBDFE0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M168.77 315.143l70.445-40.682 52.448 30.279v.013l2.331 1.34 26.004 15.019-2.322 1.347-9.537 5.504-32.908 19.001-2.373-1.368-2.556-1.478h-.007l-23.407-13.513-.087.052-25.583 14.771-2.388-1.376-39.067-22.561-8.664-5.002-2.329-1.346z",
  fill: "#F7F7F7"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M218.824 394.625h-20.283l-37.152-21.447-3.823-2.206 22.191-12.814v13.913l39.067 22.554z",
  fill: "#DBDFE0"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M239.497 398.585l-17.022 9.821-9.319-5.38-14.59-8.424h29.173l2.432-1.405 9.326 5.388z",
  fill: "#F8FAFA"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M297.496 379.267v5.962l-19.315 11.154h-18.616l-4.602 2.658-4.31-2.49h-.007l-3.815-2.214-.022-.007v.022l-3.8 2.191-1.595.925-1.929 1.114-9.326-5.388-2.432 1.405h-8.889l6.793-3.924 14.357-8.285 6.821-3.939 4.441 2.563h.008l9.326 5.388 12.275 7.091h.007v-.007l6.858-3.961 17.772-10.258z",
  fill: "#DBDFE0"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M308.139 373.121l-10.652 6.152v5.962l-19.315 11.154h-18.616l-4.601 2.657 9.312 5.372 10.68 6.168.014.007 50.738-29.296 3.822-2.206-21.382-12.349v6.379z",
  fill: "#F9FAFB"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M198.548 394.621v4.412l-40.974-23.654h-.008v-4.412h.008l3.822 2.206 37.152 21.448z",
  fill: "#BBBBBC"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M222.475 408.409v4.412l-3.822-2.206-9.319-5.38-10.768-6.218v-4.412l14.59 8.424 9.319 5.38z",
  fill: "#CFD2D3"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M254.943 399.066v4.23l-.153.087-3.662-2.118-4.317-2.49-.022-.007v-4.39l.022-.015 3.815 2.213h.007l4.31 2.49z",
  fill: "#C6CACC"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M254.955 403.456l5.49 3.175 14.502 8.372v-4.412l-10.68-6.167-9.312-5.373v4.405z",
  fill: "#C6C9CC"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M245.609 359.853l-5.613 3.24-8.744 5.045-5.613-5.613.014-.007 14.343-8.278 5.613 5.613z",
  fill: "#DBDFE0"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M221.226 349.581l-2.388-1.376v46.42l6.792-3.924v-28.168l.015-.008 14.342-8.278 5.614 5.614-5.614 3.24v19.315l6.822-3.939v-43.668l-25.583 14.772z",
  fill: "#CFD2D3"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M272.866 349.754v43.77h-.008l-12.275-7.091-9.326-5.387h-.007l-4.441-2.563v-43.668l.087-.051 23.407 13.512h.007l2.556 1.478zM218.838 348.193v46.42l-39.067-22.555v-46.427l39.067 22.562z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M301.547 358.994v17.939l-4.063 2.345-17.771 10.258v-26.792l5.613 5.613 16.221-9.363z",
  fill: "#5DE273"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#fjfilter1_f)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M301.547 358.994v17.939l-4.063 2.345-17.771 10.258v-26.792l5.613 5.613 16.221-9.363z",
  fill: "#5DE273"
})), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M307.16 355.762l-5.613 3.239-16.221 9.363-5.613-5.613 21.834-12.603 5.613 5.614z",
  fill: "#F9FAFB"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M308.148 332.102v41.024l-6.589 3.808v-17.939l5.613-3.24-5.613-5.613-21.834 12.603v26.791l-6.858 3.961v-43.762l2.374 1.368 32.907-19.001z",
  fill: "#EAEAEA"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M239.996 363.085V382.4l-14.357 8.286v-28.168l5.613 5.613 8.744-5.046z",
  fill: "#5DE273"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#fjfilter2_f)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M239.996 363.085V382.4l-14.357 8.286v-28.168l5.613 5.613 8.744-5.046z",
  fill: "#5DE273"
})), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M239.49 398.59v4.412l-17.021 9.821v-4.412l17.021-9.821z",
  fill: "#DBDFE0"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M325.711 381.315l-50.738 29.297-.014.007v4.398l.014.007 3.815-2.207 50.745-29.296v-4.412l-3.822 2.206z",
  fill: "#CFD2D3"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M246.806 394.363v4.412l-1.572.911-5.752 3.32v-4.413l1.93-1.114 1.594-.924 3.8-2.192z",
  fill: "#CED1D2"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M246.907 330.605v4.143l-.087.051-25.584 14.772v-4.142l25.584-14.773.087-.051z",
  fill: "#DBDFE0"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M275.241 346.965v4.142l-2.373-1.369-2.556-1.478h-.007l-23.407-13.512v-4.143l28.343 16.36z",
  fill: "#CFD2D3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M703.35 315.6c-45.192-27.038-119.513-27.794-166.005-1.681-46.486 26.113-47.545 69.199-2.353 96.237 45.192 27.041 119.513 27.794 165.998 1.681 46.493-26.111 47.552-69.197 2.36-96.237",
  fill: "#5F5F64"
}), /*#__PURE__*/React.createElement("path", {
  d: "M686.76 293.102c.3-10.028-6.032-20.135-19.043-27.927-25.929-15.511-68.568-15.939-95.237-.962-13.831 7.766-20.65 18.154-20.397 28.516-.533-21.956-1.06-43.907-1.593-65.863-.04-1.794-.1-4.189-.146-5.984l-.287-11.975c-.04-1.795-.1-4.19-.147-5.992-.14-5.984-.286-11.968-.433-17.959-.087-3.59-.24-8.38-.287-11.976-.26-10.854 6.886-21.742 21.377-29.882 27.955-15.698 72.634-15.244 99.803 1.014 13.638 8.16 20.27 18.754 19.957 29.262-1.187 39.909-2.38 79.818-3.567 119.728",
  fill: "url(#fjpaint9_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M727.092 340.971c-3.106-6.458-6.039-12.563-9.945-21.93-4.919-11.803-7.979-21.036-8.005-21.122-2.547-7.818-4.746-14.57-6.246-20.609a641.948 641.948 0 01-4.526-19.694c-.666-3.169-1.393-7.432-1.879-10.635-1.98-12.969-3.893-28.334-4.46-52.724-.426-18.38-.013 11.144 1.533-23.595-.48 10.781-7.945 21.449-22.343 29.535-29.228 16.412-75.953 15.945-104.362-1.054-13.524-8.093-20.463-18.474-20.863-28.894 1.193 32.25 1.7 3.059 1.127 23.268-.7 24.643-2.753 40.329-4.666 52.423-.5 3.169-1.227 7.394-1.9 10.529a635.954 635.954 0 01-4.586 19.66c-1.593 6.333-4.199 14.203-6.292 20.529-.033.088-3.08 9.262-8.385 21.83-4.42 10.467-8.672 19.046-10.072 21.868-10.765 21.69-1.72 46.063 27.382 63.473 43.213 25.853 114.294 26.574 158.753 1.601 30.662-17.219 40.653-42.156 29.735-64.459z",
  fill: "url(#fjpaint10_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M665.438 196.75c25.942-14.571 26.528-38.615 1.313-53.7-25.216-15.091-66.689-15.511-92.631-.94-25.942 14.57-26.535 38.614-1.313 53.706 25.216 15.084 66.688 15.504 92.631.934zm5.779 3.462c-29.229 16.412-75.954 15.945-104.362-1.054-28.416-17.006-27.749-44.092 1.479-60.504 29.229-16.419 75.954-15.945 104.369 1.054 28.409 16.999 27.749 44.085-1.486 60.504",
  fill: "#F1F1F1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M594.836 239.651c-6.812-.495-12.068 5.595-11.744 13.606.324 8.01 6.111 14.907 12.918 15.408 6.813.494 12.068-5.595 11.744-13.604-.324-8.012-6.111-14.91-12.918-15.41",
  fill: "#646262"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "fjpaint0_linear",
  x1: 844.053,
  y1: 370.334,
  x2: -28.962,
  y2: 370.334,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F2F2F2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "fjpaint1_linear",
  x1: 251.256,
  y1: 167.052,
  x2: 281.259,
  y2: 167.052,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DEDEDE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.073,
  stopColor: "#EDECEC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EAEAEA"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "fjpaint2_linear",
  x1: 254.246,
  y1: 19.532,
  x2: 278.255,
  y2: 19.532,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C7C7C7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.927,
  stopColor: "#B5B5B5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B5B5B5"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "fjpaint3_linear",
  x1: 251.256,
  y1: 175.832,
  x2: 281.257,
  y2: 175.832,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DFDFDF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.073,
  stopColor: "#B1B1B1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D7D6D6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "fjpaint4_linear",
  x1: 189.215,
  y1: 238.47,
  x2: 219.218,
  y2: 238.47,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DEDEDE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.073,
  stopColor: "#EDECEC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EAEAEA"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "fjpaint5_linear",
  x1: 192.225,
  y1: 90.952,
  x2: 216.234,
  y2: 90.952,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C7C7C7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.927,
  stopColor: "#B5B5B5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B5B5B5"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "fjpaint6_linear",
  x1: 189.215,
  y1: 247.25,
  x2: 219.216,
  y2: 247.25,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DFDFDF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.073,
  stopColor: "#B1B1B1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D7D6D6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "fjpaint7_linear",
  x1: 376.748,
  y1: 86.716,
  x2: 517.902,
  y2: 86.716,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C2C2C2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.927,
  stopColor: "#AEAEAE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#AEAEAE"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "fjpaint8_linear",
  x1: 356.075,
  y1: 195.993,
  x2: 537.239,
  y2: 195.993,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D9D9D9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.073,
  stopColor: "#DFDFDF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F7F7F7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "fjpaint9_linear",
  x1: 549.184,
  y1: 212.362,
  x2: 690.338,
  y2: 212.362,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C2C2C2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.927,
  stopColor: "#AEAEAE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#AEAEAE"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "fjpaint10_linear",
  x1: 528.533,
  y1: 272.34,
  x2: 709.696,
  y2: 272.34,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D9D9D9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.073,
  stopColor: "#DFDFDF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F7F7F7"
})), /*#__PURE__*/React.createElement("filter", {
  id: "fjfilter0_f",
  x: 0.845,
  y: 230.558,
  width: 883.698,
  height: 555.552,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 20.391,
  result: "effect1_foregroundBlur"
})), /*#__PURE__*/React.createElement("filter", {
  id: "fjfilter1_f",
  x: 233.105,
  y: 312.386,
  width: 115.05,
  height: 123.758,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 23.304,
  result: "effect1_foregroundBlur"
})), /*#__PURE__*/React.createElement("filter", {
  id: "fjfilter2_f",
  x: 179.031,
  y: 315.91,
  width: 107.573,
  height: 121.384,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 23.304,
  result: "effect1_foregroundBlur"
}))));

var _ref142 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 24 24",
  id: "icon-pv",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.426 14.828H9.574l-.146 4.167h5.144l-.146-4.167zM2.81 11l-.314 2.995h5.946L8.547 11H2.81zM14.094 6H9.906l-.146 4.167h4.48L14.094 6zM14.28 11H9.72l-.106 2.995h4.771L14.281 11zM2.373 14.828l-.37 3.52a.586.586 0 00.583.647h5.67l.145-4.167H2.373zM21.997 18.348l-.37-3.52H15.6l.146 4.167h5.67a.586.586 0 00.582-.647zM3.898 6c-.3 0-.551.226-.583.525l-.382 3.642h5.655L8.734 6H3.898zM20.685 6.525A.586.586 0 0020.102 6h-4.836l.146 4.167h5.655l-.382-3.642zM21.19 11h-5.737l.105 2.995h5.946L21.19 11zM14.852 22.14h-2.266v-2.312h-1.172v2.311H9.148a.586.586 0 00-.585.586v.673c0 .324.262.586.585.586h5.704a.586.586 0 00.585-.586v-.673a.586.586 0 00-.585-.586zM12.8 1.8V.972C12.8.546 12.442.2 12 .2c-.442 0-.8.346-.8.772V1.8a6.242 6.242 0 011.6 0zM8.683 3.4c.262-.343.573-.655.917-.917l-.493-.493a.648.648 0 00-.917.917l.493.493zM15.317 3.4l.493-.493a.649.649 0 00-.917-.917l-.493.493c.343.262.655.573.917.917zM15.2 5c-.278-1.36-1.606-2.4-3.2-2.4-1.591 0-2.922 1.038-3.2 2.4h6.4z",
  fill: "currentColor"
}));

var _ref143 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 18 17",
  id: "icon-question-mark",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M.972 8.03a8.028 8.028 0 1016.056 0 8.028 8.028 0 00-16.056 0zm14.596 0a6.568 6.568 0 11-13.136 0 6.568 6.568 0 0113.136 0zM9 11.678a.73.73 0 100-1.46.73.73 0 000 1.46zm-.73-2.189h1.46c0-.582.091-.69.691-.989 1.042-.521 1.498-1.053 1.498-2.295 0-1.59-1.252-2.554-2.919-2.554a2.92 2.92 0 00-2.92 2.92h1.46c0-.807.654-1.46 1.46-1.46.932 0 1.46.406 1.46 1.094 0 .583-.092.69-.692.99-1.042.52-1.498 1.052-1.498 2.294z",
  fill: "currentColor"
}));

var _ref144 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 12 12",
  id: "icon-refresh",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.887 3.33H2.844c.73-1.019 1.831-1.59 3.116-1.59 2.371 0 4.293 1.897 4.293 4.239h1.074c0-2.927-2.403-5.3-5.367-5.3-1.505 0-2.83.627-3.757 1.734V.68H1.13v3.709h3.757v-1.06zm2.146 5.298h2.043c-.73 1.018-1.831 1.59-3.116 1.59-2.371 0-4.293-1.898-4.293-4.24H.593c0 2.927 2.403 5.3 5.367 5.3 1.505 0 2.83-.627 3.757-1.733v1.732h1.073V7.569H7.033v1.06z",
  fill: "currentColor"
}));

var _ref145 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 24 24",
  id: "icon-refresh-ccw",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10 7H6.193C7.553 5.079 9.606 4 12 4a8 8 0 018 8h2c0-5.523-4.477-10-10-10-2.804 0-5.275 1.183-7 3.27V2H3v7h7V7zm4 10h3.807c-1.36 1.921-3.413 3-5.807 3a8 8 0 01-8-8H2c0 5.523 4.477 10 10 10 2.804 0 5.275-1.183 7-3.27V22h2v-7h-7v2z",
  fill: "currentColor"
}));

var _ref146 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 11 13",
  id: "icon-rocket",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.792 4.334v1.895L.625 7.854v2.98h2.167c0 .598.485 1.083 1.083 1.083h1.083v.542h1.084v-.542h1.083c.598 0 1.083-.485 1.083-1.083h2.167v-2.98L8.208 6.23V4.334C8.208 2.624 7.172.542 5.5.542c-1.672 0-2.708 2.082-2.708 3.792zm3.25 6.5h1.083v-6.5c0-1.188-.757-2.709-1.625-2.709s-1.625 1.52-1.625 2.709v6.5h1.083v-3.25h1.084v3.25zM1.708 8.396l1.084-.812V9.75H1.708V8.396zm6.5 1.354V7.584l1.084.812V9.75H8.208zM5.5 5.96a1.083 1.083 0 110-2.167 1.083 1.083 0 010 2.167z",
  fill: "currentColor"
}));

var _ref147 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 15 15",
  id: "icon-round-grid",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.505 14.383c3.547 0 6.422-2.843 6.422-6.35 0-3.507-2.875-6.35-6.422-6.35-3.546 0-6.421 2.843-6.421 6.35 0 3.507 2.875 6.35 6.421 6.35z",
  stroke: "currentColor",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.504 2.741c.591 0 1.07-.473 1.07-1.058 0-.584-.479-1.058-1.07-1.058-.59 0-1.07.474-1.07 1.058 0 .585.48 1.058 1.07 1.058zM2.974 11.49a1.057 1.057 0 00-.745-1.302 1.072 1.072 0 00-1.318.737 1.057 1.057 0 00.745 1.302c.57.157 1.16-.173 1.318-.736zM13.341 12.23c.571-.152.91-.732.757-1.296-.153-.565-.74-.9-1.31-.749-.572.151-.91.732-.758 1.296.153.565.74.9 1.311.749z",
  fill: "currentColor",
  stroke: "currentColor",
  strokeMiterlimit: 10
}));

var _ref148 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 24 24",
  id: "icon-search",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10 18a8 8 0 116.32-3.094l5.387 5.387-1.414 1.414-5.387-5.387A7.965 7.965 0 0110 18zm6-8a6 6 0 11-12 0 6 6 0 0112 0z",
  fill: "currentColor"
}));

var _ref149 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 10 10",
  id: "icon-select-all",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M.667 2.75v6.583H7.25V2.75H.667zm-.25-.667A.417.417 0 000 2.5v7.083c0 .23.187.417.417.417H7.5c.23 0 .417-.187.417-.417V2.5a.417.417 0 00-.417-.417H.417z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M.667 2.75v6.583H7.25V2.75H.667zm-.25-.667A.417.417 0 000 2.5v7.083c0 .23.187.417.417.417H7.5c.23 0 .417-.187.417-.417V2.5a.417.417 0 00-.417-.417H.417z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.856 4.02l.544.536-3.138 3.09L1.52 5.931l.543-.535 1.199 1.18 2.594-2.555z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.749 2.083V.667h6.583V7.25H7.915v.667h1.667c.23 0 .417-.187.417-.417V.417A.417.417 0 009.582 0H2.499a.417.417 0 00-.417.417v1.666h.667z",
  fill: "currentColor"
}));

var _ref150 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 24 24",
  id: "icon-send",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.74 2.252l1.365 9.555.772.193-.772.193-1.365 9.555L22.236 12 2.74 2.252zm3.155 7.941L5.26 5.748 17.764 12 5.26 18.252l.635-4.445L13.123 12l-7.228-1.807z",
  fill: "currentColor"
}));

var _ref151 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 24 24",
  id: "icon-settings",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.656 20.897l2.217-2.217-.78-2.837.34-.813L23 13.582v-3.136l-2.56-1.454-.335-.811.791-2.839-2.219-2.215-2.837.78-.81-.34L13.58 1h-3.135L8.991 3.56l-.811.334-2.838-.791-2.215 2.215.78 2.838-.34.81L1 10.416v3.134l2.558 1.458.335.811-.791 2.838 2.216 2.216 2.838-.78.81.34 1.45 2.566h3.134l1.457-2.558.811-.334 2.838.79zm.197-7.271l-.872 2.082.655 2.38-.568.569-2.376-.662-2.083.86-1.222 2.144h-.804l-1.212-2.146-2.08-.872-2.382.655-.567-.567.662-2.376-.86-2.083L3 12.388v-.805l2.147-1.212.872-2.08-.655-2.382.566-.566 2.376.663 2.084-.86L11.61 3h.803l1.211 2.147 2.08.872 2.383-.655.569.568-.662 2.375.86 2.084L21 11.61v.803l-2.147 1.212zM12 16a4 4 0 110-8 4 4 0 010 8zm2-4a2 2 0 11-4 0 2 2 0 014 0z",
  fill: "currentColor"
}));

var _ref152 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 18 18",
  id: "icon-share",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.5 4.5c0 .216.023.426.066.628L6.763 7.03a3 3 0 100 3.94l3.803 1.902a3 3 0 10.671-1.341L7.434 9.628a3.012 3.012 0 000-1.258l3.803-1.901A3 3 0 1010.5 4.5zM6 9a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm7.5-3a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm1.5 7.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z",
  fill: "currentColor"
}));

var _ref153 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 24 24",
  id: "icon-share-arrow",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13 16V5.414l3.293 3.293 1.414-1.414L12 1.586 6.293 7.293l1.414 1.414L11 5.414V16h2zm8 4v-9h-2v9H5v-9H3v9a2 2 0 002 2h14a2 2 0 002-2z",
  fill: "currentColor"
}));

var _ref154 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 8 12",
  id: "icon-side-arrow",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.862 12L1.741 7.627a2 2 0 010-3.254L7.862 0v12z",
  fill: "#211E21",
  fillOpacity: 0.94
}));

var _ref155 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 11 11",
  id: "icon-simulation",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.542 4.33v4.048c0 1.443 2.132 2.531 4.958 2.531s4.958-1.088 4.958-2.53v-4.05c0-.87-.776-1.611-2.014-2.062l-.817.807c1.149.309 1.805.837 1.805 1.255 0 .635-1.496 1.519-3.932 1.519-2.437 0-3.933-.884-3.933-1.519 0-.599 1.337-1.419 3.54-1.508l-.995.982.724.715 1.881-1.856a.503.503 0 000-.715L4.837.09l-.725.715 1.012.992C2.487 1.898.542 2.951.542 4.33zM5.5 6.86c1.638 0 3.04-.366 3.932-.953v2.471c0 .635-1.496 1.519-3.932 1.519-2.437 0-3.933-.884-3.933-1.519V5.907c.893.587 2.295.953 3.933.953z",
  fill: "currentColor"
}));

var _ref156 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 14 14",
  id: "icon-slack",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.802 8.867a1.4 1.4 0 11-1.401-1.4h1.4v1.4zM6.534 12.6a1.4 1.4 0 01-2.802 0V8.867a1.4 1.4 0 012.802 0V12.6zM5.135 6.533H1.404a1.4 1.4 0 110-2.8h3.731a1.4 1.4 0 110 2.8zm0-3.733a1.404 1.404 0 01-1.4-1.4 1.4 1.4 0 012.801 0v1.4h-1.4zm2.331-1.4a1.4 1.4 0 012.802 0v3.733a1.4 1.4 0 01-2.802 0V1.4zM8.867 14a1.4 1.4 0 01-1.4-1.4v-1.4h1.4a1.4 1.4 0 110 2.8zm3.732-3.733H8.867a1.404 1.404 0 01-1.4-1.4 1.4 1.4 0 011.4-1.4H12.6a1.4 1.4 0 110 2.8zm0-3.734h-1.4v-1.4a1.4 1.4 0 111.4 1.4z",
  fill: "currentColor"
}));

var _ref157 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 11 11",
  id: "icon-slack-color",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#fzclip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.053 5.799c-.638 0-1.155.517-1.155 1.155v2.89a1.156 1.156 0 002.31 0v-2.89c0-.638-.517-1.155-1.155-1.155zM.009 6.954a1.157 1.157 0 002.312 0V5.798H1.166h-.001c-.639 0-1.156.518-1.156 1.156z",
  fill: "#E91E63"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.054 0h-.001a1.157 1.157 0 000 2.312h1.155V1.156v-.002C5.208.516 4.691 0 4.054 0zM1.157 5.21h2.896a1.157 1.157 0 000-2.312H1.157a1.157 1.157 0 000 2.313z",
  fill: "#00BCD4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.834 2.898c-.637 0-1.154.517-1.154 1.154V5.211h1.156a1.157 1.157 0 000-2.313h-.002zM5.794 1.156v2.899a1.156 1.156 0 002.31 0v-2.9a1.156 1.156 0 00-2.31 0z",
  fill: "#4CAF50"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.104 9.843c0-.638-.517-1.155-1.155-1.155H5.793v1.156a1.155 1.155 0 002.311-.001zM9.844 5.798H6.95a1.157 1.157 0 000 2.312h2.895a1.157 1.157 0 000-2.312z",
  fill: "#FF9800"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "fzclip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h11v11H0z"
}))));

var _ref158 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 24 24",
  id: "icon-smart-meter",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#gaclip0_17302_450757)",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 21.616c-6.066 0-11-4.849-11-10.808C1 4.848 5.934 0 12 0s11 4.848 11 10.808-4.934 10.808-11 10.808zM12 .854c-5.586 0-10.131 4.465-10.131 9.954 0 5.488 4.545 9.954 10.131 9.954s10.131-4.466 10.131-9.954C22.131 5.319 17.586.854 12 .854z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10 14.421L12.756 11l.064.028-.625 2.496H14L11.201 17l-.038-.025c.197-.784.386-1.568.597-2.349.051-.192-.005-.212-.17-.21-.514.008-1.028.003-1.587.003L10 14.42zM16.705 16.764c-.051-.022-.06-.064-.06-.113v-3.06h-.537c-.042 0-.08-.004-.1-.048-.02-.044.001-.077.031-.108l.84-.906c.063-.066.104-.066.166 0 .284.303.569.605.85.909a.14.14 0 01.04.082c.001.046-.039.07-.098.07h-.544v3.062c0 .05-.009.091-.06.113h-.529l.001-.001zM7.229 12.479c.051.022.06.064.06.113v3.06h.537c.042 0 .08.004.1.047.02.045 0 .078-.03.109-.282.302-.561.604-.841.906-.062.066-.104.066-.166 0-.284-.303-.568-.605-.85-.909A.14.14 0 016 15.722c-.002-.045.038-.07.097-.07h.545v-.056-3.005c0-.05.008-.091.06-.113h.528-.001zM16.322 4.636L14.45 7.518c1.282.798 2.133 2.203 2.133 3.805h3.478c0-2.812-1.491-5.281-3.739-6.687zM12 3.402c-1.587 0-3.068.451-4.315 1.23l1.872 2.882A4.619 4.619 0 0112 6.82c.899 0 1.695.242 2.391.66l1.872-2.88a8.126 8.126 0 00-4.262-1.198zM3.939 11.322h3.478c0-1.58.829-2.968 2.08-3.771L7.625 4.669C5.407 6.08 3.939 8.532 3.939 11.322zM12 24c1.699 0 3.076-1.353 3.076-3.023 0-1.67-1.377-3.023-3.076-3.023-1.7 0-3.077 1.354-3.077 3.023C8.923 22.647 10.301 24 12 24z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.287 20.877A2.318 2.318 0 0012 20.481c-.538 0-.971.187-1.288.396a.275.275 0 00-.042.426c.096.095.248.11.36.033.257-.174.582-.311.97-.311.386 0 .711.137.968.311a.286.286 0 00.36-.033.274.274 0 00-.042-.426h.002z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.897 20.324a3.062 3.062 0 00-3.794 0 .263.263 0 00-.023.395.274.274 0 00.355.024 2.602 2.602 0 011.566-.534c.684 0 1.212.271 1.565.534.108.08.26.07.356-.024a.263.263 0 00-.024-.395h-.001zM12.656 21.466a1.371 1.371 0 00-.656-.17c-.249 0-.468.07-.656.17a.275.275 0 00-.066.44c.087.085.22.107.329.05.118-.06.249-.098.392-.098.144 0 .274.037.393.099a.284.284 0 00.328-.052c.133-.13.1-.35-.065-.439h.001zM12 22.74a.311.311 0 00.314-.308.31.31 0 00-.314-.308.31.31 0 00-.314.308c0 .17.14.309.314.309z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "gaclip0_17302_450757"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  transform: "translate(1)",
  d: "M0 0h22v24H0z"
}))));

var _ref159 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 924 706",
  id: "icon-smart-meter-3d",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.1,
  filter: "url(#gbfilter0_f_17535_72857)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M458.237 180.171L71.386 407.206 40.19 425.542l56.984 33.949L352.32 611.203l56.803 33.799h.09l47.676 28.369 360.957-211.958 56.991-33.499-31.202-18.586-17.724-10.526-56.788-33.806-310.886-184.825z",
  fill: "#211E21"
})), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M50.879 252.082l42.259 23.999 43.357 24.547 23.53 13.714 66.895 38.809 74.777 43.403 55.767 32.433 35.81 20.776 24.697 14.331 42.122 24.547v-4.784l.138-.069v-1.851L50.879 244.144v7.938z",
  fill: "#E4E4E4"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M460.229 484.502v5.494l43.454-25.015 24.237-13.788 166.965-95.792 67.064-38.466 24.381-13.969 43.447-24.91 42.552-24.421v-5.389l-412.1 236.256z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M462.323 9.251L81.588 228.027l-30.701 17.669 56.083 32.715 251.111 146.193 55.905 32.569h.089l46.922 27.337 355.25-204.247 56.09-32.281-30.708-17.91-17.444-10.143-55.891-32.576L462.323 9.251z",
  fill: "url(#gbpaint0_linear_17535_72857)"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.065,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M821.484 220.279L409.958 456.996l-.461-.8 411.526-236.717.461.8zM766.516 187.304L354.99 424.021l-.461-.801 411.527-236.717.46.801zM715.644 159.801L304.117 396.518l-.461-.801L715.183 159l.461.801zM666.226 129.622L254.7 366.339l-.461-.801 411.526-236.717.461.801zM615.391 102.138L203.865 338.855l-.461-.801L614.93 101.337l.461.801zM565.984 69.187L154.457 305.903l-.46-.8L565.523 68.386l.461.8zM509.588 36.208L98.062 272.925l-.46-.801L509.127 35.407l.46.801z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.065,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M97.573 220.279L509.1 456.996l.461-.8L98.034 219.479l-.46.8zM152.533 187.304l411.526 236.717.461-.801-411.527-236.717-.46.801zM203.426 159.801l411.527 236.717.46-.801L203.887 159l-.461.801zM252.834 129.622L664.36 366.339l.461-.801-411.527-236.717-.46.801zM303.707 102.138l411.526 236.717.461-.801-411.526-236.717-.461.801zM353.152 69.187l411.527 236.716.46-.8L353.613 68.386l-.461.8zM409.483 36.208L821.01 272.925l.461-.801L409.944 35.407l-.461.801z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("g", {
  opacity: 0.12,
  filter: "url(#gbfilter1_f_17535_72857)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M421.085 490.286l181.133-100.787-68.909-39.823-177.158 103.001 64.934 37.609z",
  fill: "#34363F"
})), /*#__PURE__*/React.createElement("ellipse", {
  cx: 460.783,
  cy: 222.491,
  rx: 141.71,
  ry: 140.41,
  fill: "url(#gbpaint1_linear_17535_72857)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M461.656 50.879c-94.545 0-171.185 76.63-171.185 171.162 0 94.532 76.64 171.161 171.185 171.161s171.185-76.629 171.185-171.161S556.188 50.879 461.656 50.879zm0 323.52c-84.153 0-152.379-68.217-152.379-152.358 0-84.142 68.214-152.37 152.379-152.37 84.165 0 152.378 68.216 152.378 152.357s-68.226 152.358-152.378 152.358v.013z",
  fill: "url(#gbpaint2_linear_17535_72857)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M461.656 61.796c-88.51 0-160.255 71.735-160.255 160.232 0 88.498 71.745 160.233 160.255 160.233 88.509 0 160.254-71.735 160.254-160.233 0-88.497-71.757-160.232-160.254-160.232zm0 300.647c-77.554 0-140.422-62.859-140.422-140.402 0-77.544 62.868-140.415 140.422-140.415s140.421 62.859 140.421 140.402c0 77.544-62.867 140.403-140.421 140.403v.012z",
  fill: "url(#gbpaint3_linear_17535_72857)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M514.145 373.362c.583 28.999-22.457 52.98-51.461 53.563-29.004.582-52.988-22.455-53.571-51.455-.582-29 22.458-52.981 51.462-53.563 29.004-.582 52.988 22.455 53.57 51.455z",
  fill: "url(#gbpaint4_linear_17535_72857)",
  stroke: "#FBF9F9",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M461.643 365.258c8.938 0 16.253 2.915 21.765 6.337l1.074.704a4.42 4.42 0 01.688 6.875l-.002.002c-1.559 1.547-4.035 1.783-5.851.542l-.002-.001c-4.668-3.158-10.611-5.682-17.684-5.682-7.072 0-13.016 2.511-17.684 5.682-1.833 1.232-4.297 1.004-5.854-.541l-.001-.001a4.429 4.429 0 01.688-6.877h0c5.625-3.716 13.318-7.04 22.863-7.04z",
  fill: "url(#gbpaint5_linear_17535_72857)",
  stroke: "url(#gbpaint6_linear_17535_72857)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M461.631 350.611c15.891 0 27.392 6.71 33.784 11.724 2.032 1.605 2.197 4.547.384 6.35a4.425 4.425 0 01-5.734.381l-.002-.001c-6.406-4.763-16.011-9.689-28.432-9.689s-22.039 4.913-28.434 9.689v.001c-1.745 1.305-4.196 1.145-5.734-.38a4.225 4.225 0 01.381-6.35l.001-.001c6.392-5.014 17.893-11.724 33.786-11.724z",
  fill: "url(#gbpaint7_linear_17535_72857)",
  stroke: "url(#gbpaint8_linear_17535_72857)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M461.643 379.918c4.372 0 8.211 1.204 11.524 2.977l-.004.018c2.677 1.445 3.198 4.978 1.063 7.091-1.404 1.381-3.575 1.749-5.328.838h-.001c-2.189-1.133-4.621-1.834-7.279-1.834-2.658 0-5.09.701-7.279 1.834l-.002.001c-1.739.909-3.909.543-5.314-.839-2.137-2.127-1.612-5.657 1.061-7.09 3.335-1.772 7.174-2.996 11.559-2.996z",
  fill: "url(#gbpaint9_linear_17535_72857)",
  stroke: "url(#gbpaint10_linear_17535_72857)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M466.765 399.838c0 2.771-2.285 5.034-5.134 5.034-2.838 0-5.135-2.264-5.135-5.034s2.297-5.033 5.135-5.033c2.838 0 5.134 2.263 5.134 5.033z",
  fill: "url(#gbpaint11_linear_17535_72857)",
  stroke: "url(#gbpaint12_linear_17535_72857)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M569.322 159.72a124.92 124.92 0 00-45.513-45.507c-18.293-10.579-39.516-16.638-62.166-16.638s-43.873 6.059-62.166 16.638a124.92 124.92 0 00-45.513 45.507c-10.58 18.291-16.64 39.511-16.64 62.158h44.324a79.557 79.557 0 0110.73-39.986 80.423 80.423 0 0129.274-29.27 79.575 79.575 0 0139.991-10.729 79.581 79.581 0 0139.992 10.729 80.428 80.428 0 0129.273 29.27 79.547 79.547 0 0110.731 39.986h44.324c0-22.647-6.06-43.867-16.641-62.158z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M461.656 97.587c-22.65 0-43.873 6.059-62.166 16.638l22.174 38.409a79.578 79.578 0 0139.992-10.729 79.575 79.575 0 0139.991 10.729l22.175-38.409c-18.293-10.579-39.516-16.638-62.166-16.638z",
  fill: "url(#gbpaint13_linear_17535_72857)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M569.322 159.72a124.92 124.92 0 00-45.513-45.507l-22.174 38.409a80.426 80.426 0 0129.273 29.269 79.551 79.551 0 0110.731 39.987h44.324c0-22.648-6.06-43.868-16.641-62.158z",
  fill: "#A0A0AC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M399.49 114.225a124.915 124.915 0 00-45.514 45.507c-10.58 18.29-16.64 39.51-16.64 62.157h44.324a79.56 79.56 0 0110.73-39.986 80.439 80.439 0 0129.274-29.27l-22.174-38.408z",
  fill: "#EFEFF1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M539.122 177.484a89.826 89.826 0 00-32.742-32.738 89.033 89.033 0 00-44.724-11.993 89.04 89.04 0 00-44.725 11.993 89.841 89.841 0 00-32.742 32.738c-7.562 13.07-11.932 28.218-11.995 44.393h9.479a79.557 79.557 0 0110.73-39.986 80.423 80.423 0 0129.274-29.27 79.575 79.575 0 0139.991-10.729 79.578 79.578 0 0139.992 10.729 80.431 80.431 0 0129.274 29.27 79.557 79.557 0 0110.73 39.986h9.478c-.062-16.175-4.42-31.323-11.995-44.393h-.025z",
  fill: "#919191"
}), /*#__PURE__*/React.createElement("path", {
  d: "M353.976 164.715a124.925 124.925 0 0145.514-45.508c18.293-10.578 39.515-16.637 62.166-16.637 22.65 0 43.873 6.059 62.166 16.637a124.923 124.923 0 0145.513 45.508c9.804 16.938 15.713 36.393 16.527 57.174h.113c0-22.647-6.06-43.867-16.64-62.157a124.928 124.928 0 00-45.513-45.507c-18.293-10.579-39.516-16.638-62.166-16.638-22.651 0-43.873 6.059-62.166 16.638a124.93 124.93 0 00-45.514 45.507c-10.58 18.29-16.64 39.51-16.64 62.157h.113c.826-20.769 6.736-40.236 16.527-57.174z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M565.704 256.931h-11.031v49.413h-14.462v-49.413h-11.03l18.267-26.315 18.256 26.315z",
  fill: "#FF739A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M565.704 256.931h-11.031v49.413h-7.225v-75.728l18.256 26.315z",
  fill: "#FC1355",
  opacity: 0.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M357.532 282.396h11.019v-49.413h14.461v49.413h11.031l-18.255 26.316-18.256-26.316z",
  fill: "#85FC99"
}), /*#__PURE__*/React.createElement("path", {
  d: "M357.532 282.396h11.019v-49.413h7.237v75.729l-18.256-26.316z",
  fill: "#6E6",
  opacity: 0.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M460.402 260.692v-.071h-32.755c-1.501 0-2.446-1.607-1.714-2.918l42.717-76.089c1.04-1.855 3.876-.957 3.652 1.158l-4.833 46.622v.071h32.756c1.5 0 2.446 1.607 1.713 2.918l-42.717 76.089c-1.04 1.855-3.876.957-3.652-1.158l4.833-46.622z",
  fill: "url(#gbpaint14_linear_17535_72857)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M465.117 256.532l-.65 4.655-3.757 36.284-3.64 11.945c-.874-.212-1.619-.992-1.5-2.103l4.833-46.622 4.714-4.159z",
  fill: "url(#gbpaint15_linear_17535_72857)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M471.026 180.727l-3.841 11.886-35.887 63.919-5.364 3.084a1.943 1.943 0 010-1.903l42.717-76.088c.531-.957 1.548-1.182 2.363-.886l.012-.012z",
  fill: "url(#gbpaint16_linear_17535_72857)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M501.962 230.48l-5.365 3.072h-33.831l4.715-4.088h32.767a1.95 1.95 0 011.725 1.028l-.011-.012z",
  fill: "url(#gbpaint17_linear_17535_72857)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M464.467 261.19l.65-4.656h-33.819l35.875-63.919-3.757 36.284-.65 4.655h33.819l-35.875 63.92 3.757-36.284z",
  fill: "#EFEFF1"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "gbpaint0_linear_17535_72857",
  x1: 828.909,
  y1: 246.723,
  x2: 21.318,
  y2: 246.723,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F2F2F2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "gbpaint1_linear_17535_72857",
  x1: 460.683,
  y1: 97.132,
  x2: 460.693,
  y2: 319.148,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.81,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "gbpaint2_linear_17535_72857",
  x1: 320.879,
  y1: 68.791,
  x2: 671.328,
  y2: 199.658,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B6B6C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.605,
  stopColor: "#D3D3DB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E5E5E7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "gbpaint3_linear_17535_72857",
  x1: 311.272,
  y1: 234.625,
  x2: 576.557,
  y2: 83.349,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.39,
  stopColor: "#EAEAEA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.624,
  stopColor: "#D3D3DB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B6B6C4"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "gbpaint4_linear_17535_72857",
  x1: 408.123,
  y1: 374.405,
  x2: 661.43,
  y2: 374.168,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BABABA"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "gbpaint5_linear_17535_72857",
  x1: 440.77,
  y1: 365.608,
  x2: 465.864,
  y2: 394.855,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.112,
  stopColor: "#B6B6C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.605,
  stopColor: "#D3D3DB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EAEAEA"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "gbpaint6_linear_17535_72857",
  x1: 440.77,
  y1: 365.608,
  x2: 465.864,
  y2: 394.855,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EAEAEA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.605,
  stopColor: "#D3D3DB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B6B6C4"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "gbpaint7_linear_17535_72857",
  x1: 432.086,
  y1: 351.175,
  x2: 462.667,
  y2: 391.519,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.109,
  stopColor: "#B6B6C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.605,
  stopColor: "#D3D3DB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EAEAEA"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "gbpaint8_linear_17535_72857",
  x1: 432.086,
  y1: 351.175,
  x2: 462.667,
  y2: 391.519,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EAEAEA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.605,
  stopColor: "#D3D3DB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B6B6C4"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "gbpaint9_linear_17535_72857",
  x1: 449.763,
  y1: 380.068,
  x2: 468.971,
  y2: 396.721,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.005,
  stopColor: "#B6B6C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.605,
  stopColor: "#D3D3DB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EAEAEA"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "gbpaint10_linear_17535_72857",
  x1: 449.763,
  y1: 380.068,
  x2: 468.971,
  y2: 396.721,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EAEAEA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.605,
  stopColor: "#D3D3DB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B6B6C4"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "gbpaint11_linear_17535_72857",
  x1: 456.997,
  y1: 394.884,
  x2: 468.481,
  y2: 399.25,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.283,
  stopColor: "#B6B6C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.605,
  stopColor: "#D3D3DB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EAEAEA"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "gbpaint12_linear_17535_72857",
  x1: 456.997,
  y1: 394.884,
  x2: 468.481,
  y2: 399.25,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EAEAEA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.605,
  stopColor: "#D3D3DB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B6B6C4"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "gbpaint13_linear_17535_72857",
  x1: 399.49,
  y1: 103.988,
  x2: 509.08,
  y2: 195.295,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EEE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.937,
  stopColor: "#E2E2EB"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "gbpaint14_linear_17535_72857",
  x1: 432.476,
  y1: 187.351,
  x2: 517.533,
  y2: 206.206,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EAEAEA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.605,
  stopColor: "#D3D3DB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B6B6C4"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "gbpaint15_linear_17535_72857",
  x1: 456.406,
  y1: 259.299,
  x2: 467.506,
  y2: 260.049,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EAEAEA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.605,
  stopColor: "#D3D3DB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B6B6C4"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "gbpaint16_linear_17535_72857",
  x1: 429.712,
  y1: 184.751,
  x2: 480.273,
  y2: 195.586,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EAEAEA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.605,
  stopColor: "#D3D3DB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B6B6C4"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "gbpaint17_linear_17535_72857",
  x1: 466.248,
  y1: 229.678,
  x2: 469.556,
  y2: 241.524,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EAEAEA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.605,
  stopColor: "#D3D3DB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B6B6C4"
})), /*#__PURE__*/React.createElement("filter", {
  id: "gbfilter0_f_17535_72857",
  x: 7.766,
  y: 147.746,
  width: 899.497,
  height: 558.05,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 16.213,
  result: "effect1_foregroundBlur_17535_72857"
})), /*#__PURE__*/React.createElement("filter", {
  id: "gbfilter1_f_17535_72857",
  x: 292.151,
  y: 285.676,
  width: 374.068,
  height: 268.61,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 32,
  result: "effect1_foregroundBlur_17535_72857"
}))));

var _ref160 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 892 818",
  id: "icon-solar-3d",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.04,
  filter: "url(#gcfilter0_f)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M443.882 302.344L71.685 520.778 41.672 538.42l54.826 32.663 245.479 145.965 54.651 32.519h.088l45.869 27.294 347.284-203.928 54.832-32.231-30.019-17.882-17.053-10.127-54.638-32.526-299.109-177.823z",
  fill: "#211E21"
})), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3 391.798l45.734 25.972 46.921 26.566 25.466 14.841 72.394 42 80.925 46.972 60.353 35.099 38.754 22.484 26.728 15.509 45.585 26.566v-5.178l.149-.074v-2.003L3 383.207v8.591z",
  fill: "#E4E4E4"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M446.01 643.325v5.946l47.026-27.072 26.23-14.921 180.692-103.669 72.578-41.628 26.386-15.118 47.019-26.958 46.051-26.429v-5.831L446.01 643.325z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M448.265 129L36.225 365.764 3 384.886l60.695 35.404 271.757 158.213 60.501 35.248h.097l50.779 29.584 384.459-221.04 60.702-34.935-33.233-19.383L839.879 357l-60.486-35.255L448.265 129z",
  fill: "url(#gcpaint0_linear)"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.065,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M836.966 357.379L391.604 613.558l-.499-.867 445.363-256.179.498.867zM777.488 321.691l-445.362 256.18-.499-.867 445.362-256.18.499.867zM722.425 291.931l-445.362 256.18-.499-.867 445.363-256.18.498.867zM668.952 259.267L223.59 515.447l-.498-.867L668.454 258.4l.498.867zM613.931 229.529L168.569 485.708l-.499-.866 445.362-256.18.499.867zM560.458 193.861L115.096 450.04l-.498-.866 445.362-256.18.498.867zM499.427 158.173L54.065 414.353l-.499-.867 445.362-256.179.499.866z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.065,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M53.542 357.379l445.362 256.179.498-.867L54.04 356.512l-.498.867zM113.02 321.691l445.362 256.18.499-.867-445.362-256.18-.499.867zM168.083 291.931l445.362 256.18.498-.867-445.362-256.18-.498.867zM221.555 259.267l445.362 256.18.499-.867L222.054 258.4l-.499.867zM276.618 229.529L721.98 485.708l.499-.866-445.363-256.18-.498.867zM330.13 193.861L775.492 450.04l.498-.866-445.362-256.18-.498.867zM391.081 158.173l445.362 256.18.498-.867-445.362-256.179-.498.866z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M188.299 397.693l-3.867 14.423 31.943 18.46 53.905 14.465h36.833l3.908-14.423-4.361-2.528h126.797l-8.556-4.931v-6.764H286.453l-7.375-4.279-.121-.041-53.784-14.382h-36.874z",
  fill: "#CED1D5"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M461.288 167.972v254.519l-12.741-7.355V160.617l12.741 7.355z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M499.386 408.205l-8.805 5.076-3.419 1.968-25.863 14.952-25.932-14.952-12.154-7.044 25.345-14.641v21.582l12.741 7.354 12.742-7.354v-21.547l25.345 14.606z",
  fill: "#F9FAFB"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M423.188 408.207v14.675l7.251 4.178 30.831 17.818v-14.675l-22.613-13.053-3.28-1.899-12.155-7.044h-.034z",
  fill: "#B8BABA"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M499.379 408.207l-8.781 5.066-3.425 1.982-25.884 14.948v14.654l38.114-21.968v-14.682h-.024zM474.031 160.617v254.519l-12.742 7.355V167.972l12.742-7.355z",
  fill: "#CFD2D3"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M473.294 13.086L680 196.76l-28.176 16.405-126.158 73.314-28.087 16.333h-.045l-23.573 13.708-206.658-183.723 15.428-8.977 8.764-5.09 28.079-16.333 153.72-89.311z",
  fill: "url(#gcpaint1_linear)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M173.717 365.999l184.472 18.134-44.693 85.367-198.996-26 59.217-77.501z",
  fill: "#CED1D5"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M680 219.408l-21.301 12.082-21.803 12.369-83.151 48.314-28.059 16.333-30.472 17.669-21.205 12.347v-7.234l-.048-.024v-14.741L680 196.764v22.644z",
  fill: "#DBDFE0"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M474.008 331.284v7.234l-.049.024v-7.282l.049.024z",
  fill: "#141417"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M473.957 316.524v22.023l-.549-.311L267.3 154.824v-22.023l206.657 183.723z",
  fill: "#C5C8C9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M645.674 217.904L439.194 34.363l.664-.748 206.48 183.542-.664.747zM612.002 238.805L405.522 55.263l.664-.747 206.48 183.541-.664.748zM577.586 257.486L371.106 73.945l.664-.747 206.48 183.541-.664.747zM541.693 277.647L335.213 94.105l.665-.747 206.48 183.541-.665.748zM505.795 298.547l-206.48-183.541.664-.748L506.459 297.8l-.664.747z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M303.224 165.242L508.229 43.496l-.51-.86-205.005 121.746.51.86zM336.901 194.842L541.172 73.529l-.511-.86-204.27 121.313.51.86zM370.578 224.817l203.527-121.254-.512-.859-203.527 121.254.512.859zM404.251 254.79l204.638-121.376-.51-.86L403.741 253.93l.51.86zM437.932 284.763l203.895-121.746-.512-.858-203.896 121.746.513.858z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "gcpaint0_linear",
  x1: 844.991,
  y1: 385.997,
  x2: -29,
  y2: 385.997,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F2F2F2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "gcpaint1_linear",
  x1: 473.652,
  y1: 13.086,
  x2: 560.893,
  y2: 272.613,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#85FC99"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5DE273"
})), /*#__PURE__*/React.createElement("filter", {
  id: "gcfilter0_f",
  x: 0.89,
  y: 261.562,
  width: 884.594,
  height: 556.081,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 20.391,
  result: "effect1_foregroundBlur"
}))));

var _ref161 = /*#__PURE__*/React.createElement("symbol", {
  viewBox: "0 0 100 100",
  preserveAspectRatio: "xMidYMid",
  id: "icon-spinner",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 50,
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 10,
  r: 35,
  strokeDasharray: "164.93361431346415 56.97787143782138"
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "rotate",
  repeatCount: "indefinite",
  dur: "1s",
  values: "0 50 50;360 50 50",
  keyTimes: "0;1"
})));

var _ref162 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 24 24",
  id: "icon-star",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 19.13l-7.206 3.788 1.376-8.024L.34 9.212 8.398 8.04 12 .74l3.603 7.3 8.057 1.17-5.83 5.683 1.376 8.024L12 19.13z",
  fill: "currentColor"
}));

var _ref163 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 16 9",
  id: "icon-stock-bolt",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.286 0H16v5.625L13.821 3.48 9.143 8.437 5.32 4.5 0 9l5.321-7.137 3.822 3.762L12.5 2.18 10.286 0z",
  fill: "currentColor"
}));

var _ref164 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 12 12",
  id: "icon-stop",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6 11.5a5.5 5.5 0 110-11 5.5 5.5 0 010 11zm3.516-2.691a4.5 4.5 0 00-6.325-6.325l6.325 6.325zm-.707.707A4.5 4.5 0 012.484 3.19L8.81 9.516z",
  fill: "currentColor"
}));

var _ref165 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 24 24",
  id: "icon-table",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9 4h12a2 2 0 012 2v13a2 2 0 01-2 2H3a2 2 0 01-2-2V6a2 2 0 012-2h6zM7 6H3v3h4V6zm2 3V6h12v3H9zm-2 2H3v3h4v-3zm2 3v-3h12v3H9zm-2 2H3v3h4v-3zm2 3v-3h12v3H9z",
  fill: "currentColor"
}));

var _ref166 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 9 12",
  id: "icon-tick",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.13 12L1.544 7.671a2 2 0 010-3.342L8.13 0v12z",
  fill: "currentColor"
}));

var _ref167 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 10 11",
  id: "icon-time",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.403 3.484V1.893A3.63 3.63 0 112.44 2.929l-.57-.571A4.435 4.435 0 105 1.065h-.402v2.419h.806zM5 4.694a.807.807 0 00-.209.027L3.269 3.199l-.57.57L4.22 5.29A.807.807 0 105 4.693z",
  fill: "currentColor"
}));

var _ref168 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 15 15",
  id: "icon-trash",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.781.903h3.625c.668 0 1.209.537 1.209 1.2v.6h1.813c.667 0 1.208.536 1.208 1.199v1.2c0 .662-.54 1.199-1.208 1.199h-.049l-.556 6.597c0 .662-.54 1.2-1.208 1.2H4.572c-.667 0-1.208-.538-1.206-1.15L2.808 6.3H2.76A1.204 1.204 0 011.55 5.1v-1.2c0-.662.541-1.199 1.209-1.199h1.813v-.6c0-.662.54-1.2 1.208-1.2zM2.76 3.902h9.668v1.2H2.76v-1.2zM4.02 6.3h7.147l-.55 6.547-.002.05H4.572L4.021 6.3zm5.386-4.199v.6H5.781v-.6h3.625z",
  fill: "#000"
}));

var _ref169 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 19 31",
  id: "icon-traveller",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("rect", {
  x: 0.113,
  y: 0.701,
  width: 18.502,
  height: 29.466,
  rx: 3,
  fill: "#1641F7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.896 18.148h1.388V11.17H5.896v6.98zm4.163 0H8.672V11.17h1.387v6.98zm2.776 0h-1.388V11.17h1.388v6.98z",
  fill: "#6e6"
}));

var _ref170 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 9 5",
  id: "icon-triangle",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.5.5L9 5H0L4.5.5z",
  fill: "currentColor"
}));

var _ref171 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 5 5",
  id: "icon-triangle-2",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h5v5L0 0z",
  fill: "currentColor"
}));

var _ref172 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 8 13",
  id: "icon-usd",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.875 5.953h-1.75c-.483 0-.875-.375-.875-.838v-.839c0-.463.392-.838.875-.838h1.75c.483 0 .875.375.875.838 0 .463.392.839.875.839s.875-.376.875-.839c0-1.39-1.175-2.516-2.625-2.516V.922c0-.463-.392-.839-.875-.839s-.875.376-.875.839v.838C1.675 1.76.5 2.887.5 4.276v.839C.5 6.504 1.675 7.63 3.125 7.63h1.75c.483 0 .875.376.875.839v.838c0 .463-.392.839-.875.839h-1.75c-.483 0-.875-.376-.875-.839 0-.463-.392-.838-.875-.838S.5 8.844.5 9.307c0 1.39 1.175 2.516 2.625 2.516v.838c0 .463.392.839.875.839s.875-.376.875-.839v-.838c1.45 0 2.625-1.126 2.625-2.516V8.47c0-1.39-1.175-2.516-2.625-2.516z",
  fill: "#FBF9F9"
}));

var _ref173 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 8 13",
  id: "icon-usd-black",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.875 5.953h-1.75c-.483 0-.875-.375-.875-.838v-.839c0-.463.392-.838.875-.838h1.75c.483 0 .875.375.875.838 0 .463.392.839.875.839s.875-.376.875-.839c0-1.39-1.175-2.516-2.625-2.516V.922c0-.463-.392-.839-.875-.839s-.875.376-.875.839v.838C1.675 1.76.5 2.887.5 4.276v.839C.5 6.504 1.675 7.63 3.125 7.63h1.75c.483 0 .875.376.875.839v.838c0 .463-.392.839-.875.839h-1.75c-.483 0-.875-.376-.875-.839 0-.463-.392-.838-.875-.838S.5 8.844.5 9.307c0 1.39 1.175 2.516 2.625 2.516v.838c0 .463.392.839.875.839s.875-.376.875-.839v-.838c1.45 0 2.625-1.126 2.625-2.516V8.47c0-1.39-1.175-2.516-2.625-2.516z",
  fill: "#000"
}));

var _ref174 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 17 16",
  id: "icon-usd-minus",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#gqclip0_131_93797)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.875 6.453h-1.75c-.483 0-.875-.375-.875-.838v-.839c0-.463.392-.838.875-.838h1.75c.483 0 .875.375.875.838 0 .463.392.839.875.839s.875-.376.875-.839c0-1.389-1.175-2.515-2.625-2.515v-.839C7.875.96 7.483.583 7 .583s-.875.376-.875.84v.838C4.675 2.26 3.5 3.387 3.5 4.776v.839c0 1.39 1.175 2.515 2.625 2.515h1.75c.483 0 .875.376.875.839v.838c0 .464-.392.839-.875.839h-1.75c-.483 0-.875-.375-.875-.839 0-.463-.392-.838-.875-.838s-.875.375-.875.838c0 1.39 1.175 2.516 2.625 2.516v.839c0 .463.392.838.875.838s.875-.375.875-.838v-.839c1.45 0 2.625-1.126 2.625-2.515v-.839c0-1.39-1.175-2.516-2.625-2.516z",
  fill: "#000"
})), /*#__PURE__*/React.createElement("circle", {
  cx: 12.5,
  cy: 11.5,
  r: 4.5,
  fill: "#FC1355"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.875 11.938v-.876h5.25v.876h-5.25z",
  fill: "#FBF9F9"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "gqclip0_131_93797"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(2.333 1.167)",
  d: "M0 0h11.667v11.667H0z"
}))));

var _ref175 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 17 16",
  id: "icon-usd-plus",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#grclip0_131_93788)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.875 6.453h-1.75c-.483 0-.875-.375-.875-.838v-.839c0-.463.392-.838.875-.838h1.75c.483 0 .875.375.875.838 0 .463.392.839.875.839s.875-.376.875-.839c0-1.389-1.175-2.515-2.625-2.515v-.839C7.875.96 7.483.583 7 .583s-.875.376-.875.84v.838C4.675 2.26 3.5 3.387 3.5 4.776v.839c0 1.39 1.175 2.515 2.625 2.515h1.75c.483 0 .875.376.875.839v.838c0 .464-.392.839-.875.839h-1.75c-.483 0-.875-.375-.875-.839 0-.463-.392-.838-.875-.838s-.875.375-.875.838c0 1.39 1.175 2.516 2.625 2.516v.839c0 .463.392.838.875.838s.875-.375.875-.838v-.839c1.45 0 2.625-1.126 2.625-2.515v-.839c0-1.39-1.175-2.516-2.625-2.516z",
  fill: "#000"
})), /*#__PURE__*/React.createElement("circle", {
  cx: 12.5,
  cy: 11.5,
  r: 4.5,
  fill: "#6E6"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.938 11.063h2.187v.874h-2.188v2.188h-.874v-2.188H9.874v-.874h2.188V8.874h.874v2.188z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "grclip0_131_93788"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(2.333 1.167)",
  d: "M0 0h11.667v11.667H0z"
}))));

var _ref176 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 8 13",
  id: "icon-usd-white",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.875 5.953h-1.75c-.483 0-.875-.375-.875-.838v-.839c0-.463.392-.838.875-.838h1.75c.483 0 .875.375.875.838 0 .463.392.839.875.839s.875-.376.875-.839c0-1.39-1.175-2.516-2.625-2.516V.922c0-.463-.392-.839-.875-.839s-.875.376-.875.839v.838C1.675 1.76.5 2.887.5 4.276v.839C.5 6.504 1.675 7.63 3.125 7.63h1.75c.483 0 .875.376.875.839v.838c0 .463-.392.839-.875.839h-1.75c-.483 0-.875-.376-.875-.839 0-.463-.392-.838-.875-.838S.5 8.844.5 9.307c0 1.39 1.175 2.516 2.625 2.516v.838c0 .463.392.839.875.839s.875-.376.875-.839v-.838c1.45 0 2.625-1.126 2.625-2.516V8.47c0-1.39-1.175-2.516-2.625-2.516z",
  fill: "#FBF9F9"
}));

var _ref177 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 24 24",
  id: "icon-user",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 23C5.925 23 1 18.075 1 12S5.925 1 12 1s11 4.925 11 11-4.925 11-11 11zm7.4-5.875a9 9 0 10-14.799 0C5.726 15.638 8.37 15 12 15c3.63 0 6.274.638 7.4 2.125zm-1.435 1.615C17.672 17.687 15.569 17 12 17c-3.57 0-5.672.687-5.965 1.74A8.966 8.966 0 0012 21a8.966 8.966 0 005.965-2.26zM12 15c-2.24 0-4-1.573-4-5 0-2.244 1.58-4 4-4 2.414 0 4 1.922 4 4.2 0 3.28-1.782 4.8-4 4.8zm-2-5c0 2.27.818 3 2 3 1.178 0 2-.702 2-2.8 0-1.25-.784-2.2-2-2.2-1.266 0-2 .816-2 2z",
  fill: "currentColor"
}));

var _ref178 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 21 20",
  id: "icon-users",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.612 3.764a.708.708 0 01.814-.584 3.304 3.304 0 012.765 3.26 3.304 3.304 0 01-2.841 3.265.708.708 0 01-.197-1.403 1.888 1.888 0 001.622-1.864c0-.936-.683-1.713-1.579-1.86a.708.708 0 01-.584-.814zM17.213 11.927a.708.708 0 01.805-.596c.648.097 1.285.269 1.777.591.527.346.898.879.898 1.6 0 .475-.164.892-.46 1.226-.282.32-.657.534-1.045.682a.708.708 0 01-.505-1.324c.26-.1.41-.206.49-.296a.4.4 0 00.103-.289c0-.16-.055-.28-.258-.414-.239-.157-.637-.29-1.21-.375a.708.708 0 01-.595-.805zM6.831 12.173c1.096-.368 2.537-.476 4.003-.476 1.475 0 2.916.112 4.011.484.551.187 1.067.457 1.45.86.4.418.626.95.626 1.575 0 .626-.228 1.158-.63 1.575-.386.4-.903.667-1.455.851-1.096.367-2.537.474-4.002.474-1.474 0-2.916-.112-4.011-.483-.551-.187-1.067-.457-1.45-.858-.4-.418-.627-.95-.627-1.575 0-.626.229-1.157.63-1.575.386-.4.903-.667 1.455-.852zm-.434 1.835a.798.798 0 00-.234.592c0 .253.081.436.234.596.17.177.452.35.88.495.866.294 2.115.408 3.557.408 1.436 0 2.685-.11 3.553-.4.43-.144.714-.315.883-.491a.797.797 0 00.235-.592.81.81 0 00-.235-.598c-.17-.177-.452-.35-.88-.496-.866-.294-2.114-.409-3.556-.409-1.436 0-2.684.112-3.553.403-.43.144-.714.316-.884.492z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.678 6.45a4.156 4.156 0 114.156 4.157h-.028A4.142 4.142 0 016.678 6.45zm4.156-2.738a2.74 2.74 0 00-2.74 2.74v.002A2.726 2.726 0 0010.81 9.19h.024a2.739 2.739 0 100-5.478zM6.056 3.764a.708.708 0 01-.584.814 1.887 1.887 0 00-1.579 1.86c.003.95.706 1.736 1.622 1.864a.708.708 0 11-.197 1.403 3.303 3.303 0 01-2.841-3.264v-.002a3.304 3.304 0 012.765-3.26.708.708 0 01.814.585zM4.454 11.927a.708.708 0 01-.595.805c-.572.086-.97.218-1.21.375-.203.133-.258.254-.258.414a.4.4 0 00.104.289c.08.09.23.197.49.296a.708.708 0 11-.506 1.324c-.388-.149-.763-.362-1.045-.682a1.813 1.813 0 01-.46-1.227c0-.72.371-1.253.899-1.599.491-.322 1.128-.494 1.776-.591a.708.708 0 01.805.596z",
  fill: "currentColor"
}));

var _ref179 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 13 12",
  id: "icon-volume",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("rect", {
  y: 7,
  width: 3,
  height: 5,
  rx: 1,
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("rect", {
  x: 5,
  y: 4,
  width: 3,
  height: 8,
  rx: 1,
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("rect", {
  x: 10,
  width: 3,
  height: 12,
  rx: 1,
  fill: "currentColor"
}));

var _ref180 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 12 12",
  id: "icon-wifi",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6 2.5c-1.79 0-3.435.427-4.68 1.143l.448.898C2.848 3.906 4.338 3.503 6 3.503c1.662 0 3.152.403 4.232 1.038l.448-.898C9.435 2.927 7.79 2.5 6 2.5zm0 2.006c-1.416 0-2.725.368-3.757.989l.448.9C3.57 5.845 4.724 5.508 6 5.508c1.276 0 2.43.337 3.308.885l.449-.9C8.725 4.875 7.415 4.507 6 4.507zm-2.85 2.81A5.363 5.363 0 016 6.512c1.056 0 2.04.296 2.849.804l-.45.901A4.35 4.35 0 006 7.515a4.35 4.35 0 00-2.399.702l-.45-.901zM6 8.518c-.715 0-1.384.21-1.962.578l.45.904A2.663 2.663 0 016 9.521c.548 0 1.066.174 1.51.479l.452-.904A3.636 3.636 0 006 8.518z",
  fill: "#000"
}));

var _ref181 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 20 21",
  id: "icon-wifi-loading",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 11,
  r: 10,
  fill: "#A0A0AC"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.579 5.254l-.825.825 2.328 2.328A8.169 8.169 0 004.21 9.808l-.044.044.825.825.044-.044a6.99 6.99 0 011.914-1.36l.86.862a5.813 5.813 0 00-2.037 1.323l.825.825a4.645 4.645 0 012.14-1.22l1.024 1.023c-.85.033-1.69.374-2.339 1.022l.825.825a2.333 2.333 0 013.3 0l.03-.03 3.844 3.843.825-.825L4.579 5.254zm6.195 4.562l2.445 2.445.803-.803a5.807 5.807 0 00-3.248-1.642zM8.508 7.55l1.047 1.046a6.983 6.983 0 015.335 1.994l.825-.825A8.158 8.158 0 008.509 7.55zm2.214 7.208a1.167 1.167 0 00-1.65 0l.825.825.825-.825z",
  fill: "#34363F"
}), /*#__PURE__*/React.createElement("circle", {
  opacity: 0.5,
  cx: 10,
  cy: 10.5,
  r: 10,
  fill: "#211E21"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20 10.5a10 10 0 00-10-10v10h10z",
  fill: "#6E6"
}));

var _ref182 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 14 15",
  id: "icon-wifi-notconnected",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.579 1.254l-.825.825 2.328 2.328A8.17 8.17 0 001.21 5.808l-.044.044.825.825.044-.044a6.99 6.99 0 011.914-1.36l.86.862a5.813 5.813 0 00-2.037 1.323l.825.825a4.645 4.645 0 012.14-1.22l1.024 1.023c-.85.033-1.69.374-2.339 1.022l.825.825a2.333 2.333 0 013.3 0l.03-.03 3.844 3.843.825-.825L1.579 1.254zm6.195 4.562l2.445 2.445.803-.803a5.807 5.807 0 00-3.248-1.642zM5.508 3.55l1.046 1.046A6.983 6.983 0 0111.89 6.59l.825-.825A8.158 8.158 0 005.509 3.55zm2.214 7.208a1.167 1.167 0 00-1.65 0l.825.825.825-.825z",
  fill: "#34363F"
}));

var _ref183 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 14 14",
  id: "icon-wifi-white",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.21 5.309l-.043.044.824.825.044-.044a7 7 0 019.856-.044l.825-.825a8.167 8.167 0 00-11.506.044zm1.562 1.65a5.833 5.833 0 018.25 0l-.825.825a4.667 4.667 0 00-6.6 0l-.825-.825zm6.6 1.65a3.5 3.5 0 00-4.95 0l.825.825a2.333 2.333 0 013.3 0l.825-.825zm-1.65 1.65a1.167 1.167 0 00-1.65 0l.825.824.825-.825z",
  fill: "#FBF9F9"
}));

var _ref184 = /*#__PURE__*/React.createElement("symbol", {
  viewBox: "0 0 28 18",
  id: "icon-wiki",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M28 .074l-.013.532c-1.23.035-1.969.689-2.441 1.757-1.094 2.52-4.519 10.462-6.793 15.632h-.595l-3.583-8.418c-1.421 2.772-2.987 5.667-4.34 8.418a5.44 5.44 0 01-.655-.013C7.528 13.2 5.376 8.452 3.32 3.657 2.821 2.493 1.16.606.013.62.013.484 0 .183 0 0h7.082v.606c-.84.048-2.31.58-1.894 1.49.958 2.167 4.532 10.476 5.494 12.581.656-1.294 2.528-4.76 3.294-6.225-.608-1.233-2.563-5.837-3.185-6.974-.424-.776-1.579-.846-2.44-.859V.013l6.233.013v.571c-.849.026-1.667.34-1.286 1.138.827 1.744 1.338 2.969 2.104 4.564.245-.47 1.518-3.025 2.104-4.394.39-.898-.17-1.247-1.688-1.282.013-.157 0-.449.013-.592 1.942-.014 4.86-.014 5.384-.027v.593c-.984.035-2.003.558-2.541 1.382l-2.59 5.353c.28.702 2.77 6.225 3.027 6.83l5.355-12.318C24.089.837 22.873.619 22.4.61V.004l5.59.048.009.022z",
  fill: "currentcolor",
  fillRule: "nonzero"
}));

var _ref185 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 24 24",
  id: "icon-wind-turbine",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#hbclip0_14911_469951)",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.973 11.818a.521.521 0 00.467-.293c.36-.723 2.156-4.394 2.156-5.656 0-1.212-.93-4.869-2.623-4.869S9.35 4.657 9.35 5.869c0 1.262 1.795 4.933 2.155 5.656.091.18.271.293.467.293zM21.237 17.32c-1.032-.678-4.999-1.095-5.783-1.17a.508.508 0 00-.491.247.554.554 0 00-.012.562c.398.703 2.43 4.24 3.461 4.92.755.496 2.46 1.051 3.702 1.051.83 0 1.398-.238 1.689-.71.911-1.47-1.576-4.247-2.566-4.9zM8.666 16.148c-.786.057-4.762.376-5.809 1.03-1.004.628-3.553 3.345-2.676 4.837.293.498.892.751 1.781.751 1.241 0 2.872-.498 3.615-.961 1.047-.655 3.16-4.142 3.573-4.834a.555.555 0 00.002-.564.516.516 0 00-.486-.26z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 15,
  r: 2
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "hbclip0_14911_469951"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
}))));

var _ref186 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 92 92",
  id: "icon-wind-turbine-3d",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#hcclip0_4170_3604)"
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.04,
  filter: "url(#hcfilter0_f_4170_3604)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M45.64 43.143L8.625 64.867l-2.985 1.755 5.452 3.248 24.415 14.517 5.435 3.235h.009l4.562 2.714 34.54-20.282 5.453-3.205-2.986-1.779-1.696-1.007-5.434-3.235-29.748-17.685z",
  fill: "#211E21"
})), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.792 52.04l4.549 2.582 4.666 2.642 2.533 1.476 7.2 4.178 8.049 4.671 6.002 3.491 3.854 2.236 2.659 1.543 4.533 2.642v-.515l.015-.007v-.2L1.792 51.185v.854z",
  fill: "#E4E4E4"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M45.852 77.055v.591l4.677-2.692 2.609-1.484 17.97-10.31 7.22-4.14 2.623-1.504 4.677-2.681 4.58-2.629v-.58L45.852 77.055z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M46.077 25.902L5.097 49.45l-3.305 1.902 6.037 3.52 27.028 15.736 6.017 3.506h.01l5.05 2.942L84.17 55.072l6.037-3.474-3.306-1.928-1.877-1.092-6.016-3.506-32.932-19.17z",
  fill: "url(#hcpaint0_linear_4170_3604)"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.065,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M84.735 48.616L40.441 74.095l-.05-.087L84.687 48.53l.05.086zM78.82 45.067L34.526 70.545l-.05-.086L78.77 44.98l.05.087zM73.343 42.107L29.05 67.585 29 67.5l44.295-25.478.05.086zM68.025 38.858L23.731 64.337l-.05-.086 44.295-25.479.05.086zM62.553 35.9L18.259 61.38l-.05-.086 44.294-25.479.05.086zM57.235 32.353L12.941 57.832l-.05-.087 44.294-25.478.05.086zM51.165 28.804L6.87 54.282l-.05-.086 44.294-25.478.05.086z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.065,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.819 48.616l44.294 25.479.05-.087L6.867 48.53l-.05.086zM12.734 45.067l44.294 25.478.05-.086L12.784 44.98l-.05.087zM18.21 42.107l44.295 25.478.05-.086L18.26 42.021l-.05.086zM23.529 38.858l44.294 25.479.05-.086-44.295-25.479-.05.086zM29.005 35.9L73.3 61.38l.05-.086-44.294-25.479-.05.086zM34.327 32.353l44.294 25.479.05-.087-44.294-25.478-.05.086zM40.39 28.804l44.293 25.478.05-.086-44.294-25.478-.05.086z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.886 49.439s.02.2 0 .694c-.02.46-.301.916-.845 1.267-1.127.727-2.956.727-4.083 0-.545-.352-.827-.81-.845-1.27v-.724c1.127-.727 5.773.033 5.773.033z",
  fill: "#64AC70"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.04 48.13c1.129.726 1.129 1.905 0 2.633-1.126.727-2.955.727-4.082 0-1.128-.728-1.128-1.907 0-2.634 1.127-.727 2.956-.727 4.083 0z",
  fill: "#85FC99"
}), /*#__PURE__*/React.createElement("path", {
  d: "M45.062 50.248c-.4 0-.802-.074-1.103-.221-.295-.144-.439-.33-.433-.515l.036-1.189.008-.265.033-1.12.01-.29c.001-.086.004-.17.007-.257l.082-2.736.008-.264.043-1.413.008-.257.098-3.264.008-.265.034-1.134v-.01l.007-.248a5045.948 5045.948 0 00.1-3.277l.033-1.135.008-.258.107-3.54.008-.265.026-.858.008-.258.099-3.287.008-.265.026-.86.007-.258.115-3.816.008-.265.018-.582.008-.258.017-.586.05.023a.426.426 0 00.141.103.923.923 0 00.234.073l.901.425.02.009.004.138.005.258.005.206.006.264.101 4.342.006.258.004.182.006.264.09 3.848.005.258.01.418.006.264.096 4.13.006.258.009.394.003.158.003.106.084 3.636.006.258.015.63.006.264.09 3.917.006.258.015.607.006.264.08 3.424.005.258.02.842.006.264.006.296c.01.397.02.794.028 1.19.005.192-.15.383-.464.526-.296.136-.68.203-1.062.203z",
  fill: "url(#hcpaint1_linear_4170_3604)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M45.222 12.618c-.518-.302-.987-.33-1.326-.131l-1.79 1.048c.338-.198.808-.17 1.326.132l2.371 1.379 1.79-1.049-2.37-1.38z",
  fill: "#F4F4F4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.593 13.997l-1.79 1.049c.467.272.846.933.845 1.475l-.005 1.417c0 .241-.085.41-.22.49l1.79-1.048c.136-.08.22-.25.221-.49l.004-1.417c.002-.542-.377-1.204-.845-1.476z",
  fill: "#D7D9D9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M46.648 16.52v-.005c-.002-.541-.38-1.198-.846-1.47l1.79-1.048c.467.271.845.928.846 1.47v.005l-1.79 1.049z",
  fill: "#E8E9E9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M45.803 15.046l-2.37-1.38c-1.032-.6-1.87-.116-1.872 1.078l-.001.236c-.001.486.338 1.078.758 1.322l3.561 2.073c.422.245.764.05.765-.437l.004-1.417c.002-.542-.377-1.203-.845-1.475z",
  fill: "#C2C4C4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M44.716 16.693a.365.365 0 01-.178-.055.89.89 0 01-.399-.696c0-.181.09-.286.221-.286.054 0 .114.017.178.054.22.129.399.44.399.697 0 .181-.09.286-.22.286zm-.9-.519l-1.71-.995v-.234l1.71.996v.233zm0-.544l-1.71-.996V14.4l1.71.996v.234z",
  fill: "#6E6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M51.19 19.21a.436.436 0 01-.223-.058l-.032-.018-.062-.046-.719-.615c.168-.22.229-.479.223-.675a1.09 1.09 0 00-.254-.68l3.204.131.679.028 5.933.24.017.006.032.018c.012.008.02.023.024.044.017.082-.024.256-.086.418-.06.158-.14.304-.204.341l-.465.047-.765.079-2.074.21-.538.055-4.631.471a.454.454 0 01-.059.004z",
  fill: "url(#hcpaint2_linear_4170_3604)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M48.786 18.746l-.461-.266-.008-.01-.797-.46-.192-.111-.16-.093c-.135-.077-.22-.243-.223-.48-.008-.48.323-1.072.739-1.32a.685.685 0 01.347-.11c.072 0 .138.017.196.05l.21.122.897.519.079.045-.021-.008.255.148.198.114a.382.382 0 00-.195-.05h-.001a.648.648 0 00-.305.086l-.005.002-.008.005-.016.009-.013.007c-.41.246-.739.826-.74 1.304l.001.017c.003.236.088.402.223.48z",
  fill: "url(#hcpaint3_linear_4170_3604)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.303 18.889c-.248 0-.424-.093-.518-.143-.134-.078-.22-.244-.223-.48v-.017c0-.478.329-1.058.74-1.304l.012-.007.016-.01c.003 0 .005-.002.008-.004l.005-.002a.647.647 0 01.305-.086h.001a.382.382 0 01.195.05c.115.07.206.15.278.233.206.24.25.512.255.679.005.196-.056.455-.224.675-.076.1-.174.19-.298.265-.167.1-.345.149-.544.15h-.008zm.437-1.85a.325.325 0 00-.158.04c-.186.101-.238.364-.118.587.089.163.245.26.395.26.055 0 .109-.014.159-.04.184-.102.237-.366.117-.588a.467.467 0 00-.395-.26z",
  fill: "#E3E3E3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.938 12.238l-.958-9.98-.026-.04h.004l-.033-.019c-.046-.026-.156.011-.27.078-.165.095-.337.25-.337.356l.063 13.93.032.019.392-.229 1.07-3.585c.055-.189.078-.368.063-.53z",
  fill: "url(#hcpaint4_linear_4170_3604)"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#hcfilter1_d_4170_3604)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M47.848 18.005l-2.726 2.167a1.862 1.862 0 00-.389.433L37.665 31.4c-.085.123.032.328.164.405l.032.019-.014-.011c.06.038.123.056.175.026l.04-.038 10.033-13.52-.215-.256-.032-.019z",
  fill: "url(#hcpaint5_linear_4170_3604)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M45.67 17.062c-.291-.175-.769-.18-1.068-.011-.3.169-.305.448-.015.623s.768.18 1.067.01c.3-.168.305-.447.015-.622z",
  fill: "#C2C4C4"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "hcpaint0_linear_4170_3604",
  x1: 85.533,
  y1: 51.462,
  x2: -1.39,
  y2: 51.462,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F2F2F2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hcpaint1_linear_4170_3604",
  x1: 43.526,
  y1: 33.438,
  x2: 46.588,
  y2: 33.438,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C2C4C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EDEDED"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hcpaint2_linear_4170_3604",
  x1: 54.052,
  y1: 19.672,
  x2: 54.855,
  y2: 16.597,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DBDBDB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F4F4F4"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hcpaint3_linear_4170_3604",
  x1: 48.774,
  y1: 16.26,
  x2: 47.696,
  y2: 18.114,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EDEDED"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C2C4C4"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hcpaint4_linear_4170_3604",
  x1: 42.163,
  y1: 19.89,
  x2: 54.061,
  y2: 0.82,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DBDBDB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F4F4F4"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hcpaint5_linear_4170_3604",
  x1: 50.498,
  y1: 20.365,
  x2: 43.91,
  y2: 24.272,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DBDBDB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.613,
  stopColor: "#F4F4F4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F4F4F4"
})), /*#__PURE__*/React.createElement("filter", {
  id: "hcfilter0_f_4170_3604",
  x: 1.639,
  y: 39.143,
  width: 87.866,
  height: 55.194,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2,
  result: "effect1_foregroundBlur_4170_3604"
})), /*#__PURE__*/React.createElement("filter", {
  id: "hcfilter1_d_4170_3604",
  x: 5.593,
  y: -14.038,
  width: 74.544,
  height: 77.934,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 16.021
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.521569 0 0 0 0 0.988235 0 0 0 0 0.6 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4170_3604"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4170_3604",
  result: "shape"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "hcclip0_4170_3604"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h92v92H0z"
}))));

var _ref187 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 25 25",
  id: "icon-world-view",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.914 5.582a12.56 12.56 0 00-.578-.795A12.47 12.47 0 0012.5 0c-4 0-7.556 1.876-9.843 4.796A12.447 12.447 0 000 12.5a12.446 12.446 0 002.657 7.704A12.47 12.47 0 0012.5 25v-.04.04c3.996 0 7.549-1.873 9.836-4.786A12.446 12.446 0 0025 12.5V12.5c0-2.56-.769-4.937-2.086-6.918zM9.528 1.435C8.388 2.616 7.463 4.456 6.889 6.69c-1.298-.327-2.443-.773-3.365-1.311a11.458 11.458 0 016.004-3.943zm-6.585 4.74c1.032.622 2.297 1.135 3.72 1.505a21.94 21.94 0 00-.413 4.29H1.055c.098-2.138.779-4.12 1.888-5.794zm-1.89 6.815H6.25V13.05c.005 1.506.154 2.944.422 4.268-1.428.37-2.695.884-3.729 1.507a11.404 11.404 0 01-1.89-5.835zm2.47 6.632c.925-.54 2.074-.986 3.376-1.314.584 2.252 1.527 4.1 2.686 5.272a11.458 11.458 0 01-6.061-3.958zm8.448 4.24c-1.775-.375-3.284-2.616-4.079-5.774a21.731 21.731 0 014.079-.38v6.154zm0-7.195a21.878 21.878 0 00-4.3.42 21.744 21.744 0 01-.38-4.097h4.68v3.677zm0-4.698H7.29c0-1.435.133-2.803.372-4.058 1.336.27 2.788.421 4.308.422v3.636zm0-4.677a21.714 21.714 0 01-4.089-.382c.792-3.178 2.307-5.436 4.089-5.813v6.195zm11.974 4.677H18.75c0-1.514-.148-2.96-.415-4.293 1.423-.372 2.686-.886 3.717-1.508a11.403 11.403 0 011.893 5.8zM21.47 5.37c-.92.54-2.063.987-3.36 1.315-.574-2.23-1.499-4.07-2.638-5.25A11.454 11.454 0 0121.47 5.37zm-8.478-4.279c1.797.353 3.327 2.617 4.124 5.816a21.74 21.74 0 01-4.124.385v-6.2zm0 7.242c1.533 0 2.997-.152 4.344-.426a21.78 21.78 0 01.372 4.062h-4.716V8.333zm0 4.657h4.716a21.76 21.76 0 01-.38 4.101 21.864 21.864 0 00-4.336-.424V12.99zm0 10.878v-6.16c1.457 0 2.845.137 4.115.383-.8 3.179-2.325 5.425-4.115 5.777zm2.422-.288c1.159-1.17 2.101-3.017 2.685-5.268 1.301.33 2.448.778 3.37 1.318a11.454 11.454 0 01-6.055 3.95zm6.637-4.747c-1.032-.624-2.298-1.139-3.724-1.51.268-1.326.418-2.766.422-4.273v-.051-.009h5.198a11.4 11.4 0 01-1.896 5.843z",
  fill: "currentColor"
}));

var _ref188 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 17 15",
  id: "icon-x",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.431 0h2.606l-5.721 6.132L17 14.45h-5.246L7.647 9.395 2.946 14.45H.34L6.4 7.892 0 0h5.376l3.71 4.618L13.431 0zm-.912 13.01h1.445L4.617 1.386H3.065l9.454 11.624z",
  fill: "currentColor"
}));

function SvgSprite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 0,
    height: 0,
    style: {
      position: "absolute"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97, _ref98, _ref99, _ref100, _ref101, _ref102, _ref103, _ref104, _ref105, _ref106, _ref107, _ref108, _ref109, _ref110, _ref111, _ref112, _ref113, _ref114, _ref115, _ref116, _ref117, _ref118, _ref119, _ref120, _ref121, _ref122, _ref123, _ref124, _ref125, _ref126, _ref127, _ref128, _ref129, _ref130, _ref131, _ref132, _ref133, _ref134, _ref135, _ref136, _ref137, _ref138, _ref139, _ref140, _ref141, _ref142, _ref143, _ref144, _ref145, _ref146, _ref147, _ref148, _ref149, _ref150, _ref151, _ref152, _ref153, _ref154, _ref155, _ref156, _ref157, _ref158, _ref159, _ref160, _ref161, _ref162, _ref163, _ref164, _ref165, _ref166, _ref167, _ref168, _ref169, _ref170, _ref171, _ref172, _ref173, _ref174, _ref175, _ref176, _ref177, _ref178, _ref179, _ref180, _ref181, _ref182, _ref183, _ref184, _ref185, _ref186, _ref187, _ref188);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprite);
export default __webpack_public_path__ + "static/media/sprite.2c9d2e6c.svg";
export { ForwardRef as ReactComponent };